/// <reference path="../_references.js" />

var mAgentsControls = new AgentsControls(),
    mAgentsData = new AgentsData(),
    mUserRoles = [];

function resetContentHoldersAgents(lMasterWidth) {
    if (mStateManager.Settings()[0] === 'NotificationEscalationPlans') {
        var lPanelHeight = $('#uEscalationPlanProfilePanel').height(),
            lDetailHeight = $('#uEscalationPlanProfileTable').height();

        setHeight('#uEscalationPlanListViewHolder', (lPanelHeight - (lDetailHeight + 5)));
    }
    //added check
    if (lMasterWidth <= 1024) {
        $('#uAgentsContentHolder').css('margin', '0 5px 0 5px');
    }
}

//-----------------------
// State Manager Handlers
//-----------------------
function mStateManagerAgents_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.Layout.htm',
        lIsValid;
    mAgentsData.TargetIsMe = (mAgentsData.TargetId === gUserDetails.UserId);
    lIsValid = mAgentsData.TargetIsMe;
    if (!lIsValid) {
        lIsValid = applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab);
    }
    if (lIsValid) {
        mCache.bind('Agentsupdated', agentsDataItem_Updated, null);
        mCache.bind('Usersupdated', agentsDataItem_Updated, null);
        agentsDataListConverter();
        populateElement('uMasterContentHolder', lLayout, mStateManagerAgents_OnComplete);
    } else {
        mStateManagerAgentsSecondary_Init(aPrevious, aCurrent);
    }


}

function mStateManagerAgentsLayout_Init(aPrevious, aCurrent) {
    "use strict";
    var lIsValid = mAgentsData.TargetIsMe;
    if (!lIsValid) {
        lIsValid = applyUserPermissionsNavigation(gPageClassManager.Agents, aCurrent.Settings[0]);
    }
    if (lIsValid) {
        $('.LayoutTab.Selected').removeClass('Selected');
        $('#u' + aCurrent.Tab + 'LayoutTab' + aCurrent.Settings[0]).addClass('Selected');
        if (aCurrent.Settings[0] === 'Agents') {
            $('.ContentPrimaryTabAgents').show();
            $('.ContentPrimaryTabNotificationEscalationPlans').hide();
        } else {
            $('.ContentPrimaryTabAgents').hide();
            $('.ContentPrimaryTabNotificationEscalationPlans').show();
        }

        mStateManagerAgentsLayout_OnComplete();
    }
}

function mStateManagerAgentsPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename = 'Agents.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.Layout.htm',
        lIsValid;
    lIsValid = mAgentsData.TargetIsMe;
    if (!lIsValid) {
        if (aCurrent.Settings[0] !== 'NotificationEscalationPlans' || aCurrent.Settings[1] !== 'Details') {
            lIsValid = applyUserPermissionsNavigation(gPageClassManager.AgentsDetailsPrimary, aCurrent.Settings[1]);
        } else {
            lIsValid = true;
        }
    }
    if (lIsValid) {
        if (aCurrent.Settings[0] === 'NotificationEscalationPlans' && aCurrent.Settings[1] !== 'Details') {
            ChangeHashSettings(1, 'Details');
        } else if (aCurrent.Settings[0] === 'Agents' && aCurrent.Settings[1] === 'Details') {
            ChangeHashSettings(1, 'Profile');
        } else {
            $('.ContentPrimaryTab.Selected').removeClass('Selected');
            $('.ContentPrimaryTab.' + aCurrent.Settings[1] + 'Tab').addClass('Selected');
            populateElement('uAgentsMainContentPanel', lFilename, agentsPrimaryLoad_OnComplete);
        }
    }
}


function mStateManagerAgentsSecondary_Init(aPrevious, aCurrent) {
    "use strict";

    if (!isNullOrUndefined(aCurrent.Settings[2]) && aCurrent.Settings[2] !== 'null') {
        mAgentsData.TargetId = parseInt(aCurrent.Settings[2]);
        mAgentsData.TargetIsMe = (mAgentsData.TargetId === gUserDetails.UserId);
        mStateManager.ChangeSettings(2, null);
        if(!mAgentsData.TargetIsMe)
            uAgentsCardViewFilter_OnFilter();
        else
            mStateManagerAgents_Init(aPrevious, aCurrent);
        window.setTimeout(function () {
            if (mAgentsData.TargetIsMe) {
                $('#uAgentsListCell').hide();
                $('#uAgentsLayoutTabAgents').hide();
                $('.TargetIsMeHidden').hide();
                //998
                applyUserPermissions([40, 41, 42, 43, 44]);
            }
            else {
                $('#uAgentsListCell').show();
                $('#uAgentsLayoutTabAgents').show();
            }
            //else {
            //    mStateManagerAgents_Init(null, aCurrent);
            //   // uAgentsCardViewFilter_OnFilter();
            //}
        }, 250);
    } else if (!isNullOrUndefined(aPrevious) && !isNullOrUndefined(aPrevious.Settings[2]) && aPrevious.Settings[2] === 'null') {
        $('#uAgentsListCell').show();
        $('#uAgentsLayoutTabAgents').show();
        mAgentsControls.CardView.dispose();
        mAgentsControls.CardView = null;
        mAgentsControls.CardViewPaginator.dispose();
        mAgentsControls.CardViewPaginator = null;
        mAgentsData.TargetId = -1;
        mStateManagerAgents_Init(null, aCurrent);
    }

    // localize here
    veritracks.localization.localizeTitle();
}


//--------------
// Load Complete
//--------------
function agentsEscalationPlans_OnComplete() {
    "use strict";
    mCache.unbind('EscalationPlansupdated', agentsEscalationPlans_OnComplete);
    mStateManagerAgentsLayout_Init(null, mStateManager.Hash());
}

function mStateManagerAgents_OnComplete() {
    "use strict";
    if (!mAgentsData.TargetIsMe) {
        applyUserPermissions([13, 22, 23, 24, 25, 26, 27, 28, 29, 30]);
    }
    var lBuilder = new SumoPredicateBuilder(),
        lClass = 'Agents';
    $('#uMasterMenuPanel').show();
    resetContentHolders();

    if (!mAgentsData.TargetIsMe) {
        mCache.bind('EscalationPlansupdated', agentsEscalationPlansDataListConverter, null);
        mCache.bind('EscalationPlansupdated', agentsEscalationPlans_OnComplete, null);
        lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        mCache.AddUpdatableItem('EscalationPlans',
            gObjectList.EscalationPlan.AssemblyQualifiedName,
            lBuilder.RootExpression,
            gCacheSettings.EscalationPlanUpdateInterval,
            null,
            mActivityNotification.addNotification(localizeWrapper('cAgentLoadingEscalationPlans')));
    } else {
        $('#uAgentsLayoutTabNotificationEscalationPlans').hide();
        mStateManagerAgentsLayout_Init(null, mStateManager.Hash());
    }
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyControlState(lClass, mAgentsControls.CardView);
}

function mStateManagerAgentsLayout_OnComplete() {
    "use strict";
    var lClass = 'Agents';
    if (!mAgentsData.TargetIsMe) {
        applyUserPermissions([13, 23, 24, 25, 26, 27, 28, 29, 30]);
    }
    if (mStateManager.Settings()[0] === 'Agents') {
        //gCardViewFactory_OnAgentsInit();
        agentsCardView_Init();
    } else {
        mCache.unbind('EscalationPlansupdated', mStateManagerAgentsLayout_OnComplete);
        mCache.bind('EscalationPlansupdated', agentsEscalationPlans_Updated, null);
        agentsEscalationPlansCardView_Init();
    }
    mStateManagerAgentsPrimary_Init(null, mStateManager.Hash());
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyControlState(lClass, mAgentsControls.CardView);
    uAgentsCardViewSortOnViewState();
}

function agentsEscalationPlanListViewSort(aParams, aSort){
    "use strict";
    var lEscalationPlans = mAgentsControls.EscalationPlanListView.getDataSource(),
    lEscalationPlansSortedList = [];

    lEscalationPlansSortedList = aSort.sort(lEscalationPlans);
    mAgentsControls.EscalationPlanListView.setDataSource(lEscalationPlansSortedList);
}

function agentsPrimaryLoad_OnComplete() {
    function success() {
        mStateManagerAgentsPrimary_OnComplete();
    }

    var lHash = mStateManager.Hash();
    if (lHash.Settings[0] === 'Agents' && lHash.Settings[1] === 'Profile') {
        cacheItemExpirable_Init('Culture', 'Culture', 0, true, false, success, null);
    } else {
        success();
    }
}

function mStateManagerAgentsPrimary_OnComplete() {
    "use strict";
    if (!mAgentsData.TargetIsMe) {
        applyUserPermissions([13, 23, 24, 25, 26, 27, 28, 29, 30]);
    } else {
        applyUserPermissions([40, 41, 42, 43, 44]);
    }
    resetContentHolders();
    if (mStateManager.Settings()[0] === 'Agents') {
        window['agents' + mStateManager.Settings()[0] + mStateManager.Settings()[1] + '_Init']();
        if (mAgentsData.TargetIsMe) {
            $('.TargetIsMeHidden').remove();
        }
    } else {
        if (isNullOrUndefined(mAgentsControls.EscalationPlanListView)) {
            mAgentsControls.EscalationPlanListView = new sumo.controls.ListView('uEscalationPlanListView', 'uEscalationPlanListViewHolder', {
                    'keyFieldType': 'number',
                    'cssClass': 'VeritracksSelectListView',
                    'selectMethod': 'single'
                }, [
                { 'id': 'AgentId', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'AgentId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': AgentNameFormatter },
                { 'id': 'ContactTypeId', 'title': localizeWrapper('cAgentContactMethod'), 'dataField': 'data', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentEscalationPlanContactMethodFormatter },
                { 'id': 'ContactInterval', 'title': localizeWrapper('cAgentContactInterval'), 'dataField': 'ContactInterval', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': null }
            ]);
            mAgentsControls.EscalationPlanListView.bind('selectedchanged', uEscalationPlanListView_OnSelectChange, null);
            mAgentsControls.EscalationPlanListView.bind('sort', agentsEscalationPlanListViewSort);
        }
        agentsNotificationEscalationPlans_Init();
    }
    mStateManagerAgentsSecondary_Init(null, mStateManager.Hash());
}

//------
// Leave
//------
function mStateManagerAgents_Leave(aPrevious, aCurrent) {
    "use strict";
    mCache.unbind('Agentsupdated', agentsDataItem_Updated);
    mCache.unbind('Usersupdated', agentsDataItem_Updated);
    mCache.unbind('EscalationPlansupdated', agentsEscalationPlans_Updated);
    mStateManagerAgentsLayout_Leave(aPrevious, aCurrent);
    mAgentsData.FirstRun = true;
    mAgentsData.ArchivedEnrollees = null;
    mAgentsData.TargetIsMe = false;
    mAgentsData.TargetId = -1;
}

function mStateManagerAgentsLayout_Leave(aPrevious, aCurrent) {
    "use strict";
        if (!isNullOrUndefined(mAgentsControls.CardView)) {
            mAgentsControls.CardView.dispose();
            mAgentsControls.CardView = null;
        }

        if (!isNullOrUndefined(mAgentsControls.CardViewFilter)) {
            mAgentsControls.CardViewFilter.dispose();
            mAgentsControls.CardViewFilter = null;
        }

        if (!isNullOrUndefined(mAgentsControls.CardViewPaginator)) {
            mAgentsControls.CardViewPaginator.dispose();
            mAgentsControls.CardViewPaginator = null;
        }

        if (!isNullOrUndefined(mAgentsControls.Validator)) {
            mAgentsControls.Validator.dispose();
            mAgentsControls.Validator = null;
        }

        if (!isNullOrUndefined(mAgentsControls.PasswordValidator)) {
            mAgentsControls.PasswordValidator.dispose();
            mAgentsControls.PasswordValidator = null;
        }

        if (aPrevious.Settings[0] === 'Agents') {
    } else {
        if (!isNullOrUndefined(mAgentsControls.EscalationPlanListView)) {
            mAgentsControls.EscalationPlanListView.dispose();
            mAgentsControls.EscalationPlanListView = null;
        }
    }
    mStateManagerAgentsPrimary_Leave(aPrevious, aCurrent);
}

function mStateManagerAgentsPrimary_Leave(aPrevious, aCurrent) {
    "use strict";
    if (aPrevious.Settings[0] === 'Agents') {
        switch (aPrevious.Settings[1]) {
            case 'Profile':
            //    mCache.RemoveItem('Culture');
                break;
            case 'OffHours':
                if (!isNullOrUndefined(mAgentsControls.OffHoursListView)) {
                    mAgentsControls.OffHoursListView.dispose();
                    mAgentsControls.OffHoursListView = null;
                }
                break;
        }
    } else {
    }
}

function getMyAgentsIdByOrganizationId(aUserId,organizationId) {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lMyAgents = [],
        lAgentIds = [],
        lAgent,
        lKey;
    if(organizationId){
        lBuilder.AddNewExpressionConditional('OrganizationId', organizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
        lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgents, lBuilder.RootExpression);

    if (!isNullOrUndefined(lMyAgents)) {
        if (lMyAgents.length == 0) {
            lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
        }
    } else {
        lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
    }

    for (lKey in lMyAgents) {
        if (lMyAgents.hasOwnProperty(lKey)) {
            lAgent = lMyAgents[lKey];
            lAgentIds.push(lAgent.Id);
        }
    }

    return lAgentIds;
}
function getMyAgentIds(aUserId) {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lMyAgents = [],
        lAgentIds = [],
        lAgent,
        lKey;

    lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgents, lBuilder.RootExpression);

    if (!isNullOrUndefined(lMyAgents)) {
        if (lMyAgents.length == 0) {
            lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
        }
    } else {
        lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
    }

    for (lKey in lMyAgents) {
        if (lMyAgents.hasOwnProperty(lKey)) {
            lAgent = lMyAgents[lKey];
            lAgentIds.push(lAgent.Id);
        }
    }

    return lAgentIds;
}

function getMyAgentIdsByOrganization(aUserId, aOrganizationId) {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lMyAgents,
        lAgentIds = [],
        lAgent,
        lKey;

    lBuilder.AddNewExpressionConditional('OrganizationId', aOrganizationId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('UserId', aUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(lAgents, lBuilder.RootExpression);

    if (lMyAgents.length == 0) {
        lMyAgents = query(getDataItems('AgentsStop'), lBuilder.RootExpression);
    }
        for (lKey in lMyAgents) {
            if (lMyAgents.hasOwnProperty(lKey)) {
                lAgent = lMyAgents[lKey];
                lAgentIds.push(lAgent.Id);
            }
        }

    return lAgentIds;
}

// AGENT LIST POPULATION
function agentsDataListConverter() {
    "use strict";
    var lAgents = getDataItems('Agents'),
        lUsers = getDataItems('Users'),
        lOrganizations = getDataItems('Organizations'),
        lRoles = getDataItems('UserRoleValueTypes'),
        lBuilder = new SumoPredicateBuilder(),
        lBuilder2 = new SumoPredicateBuilder(),
        lUserRole = getDataItems('UserRoles'),
        lMyAgents,
        lAgentIds,
        lCardList = [],
        lAgentCard = null,
        lAgent,
        lUser,
        lOrganization,
        lOrganizationIds,
        lAgentKey,
        lSortState,
        lKey,
        lRole,
        sortExpression = new SortExpression();

    // default sort
    sortExpression.addAscendingColumn('SortId');
    setViewState('AgentsCardViewSort', sortExpression);
    lSortState = getViewState('AgentsCardViewSort');

    for (lKey in lUsers) {
        if (lUsers.hasOwnProperty(lKey)) {
            lUser = lUsers[lKey];
            if (lUser.DisplayType === 1) {
                lAgentCard = new AgentCardView();
                lAgentCard.User = lUser;
                lAgentCard.UserName = lUser.UserName;
                if (lUser.UserRoleValueTypeId === 2) {
                    lAgentCard.UserName += ' - Enhanced Crime Analyst';
                }
                lBuilder.AddNewExpressionConditional('UserId', lUser.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lMyAgents = query(lAgents, lBuilder.RootExpression);
                lBuilder.Clear();
                lAgentIds = [];
                lOrganizationIds = [];

                for (lAgentKey in lMyAgents) {
                    if (lMyAgents.hasOwnProperty(lAgentKey)) {
                        lAgent = lMyAgents[lAgentKey];
                        lAgentIds.push(lAgent.Id);
                        lAgentCard.AgentsByOrganization[lAgent.OrganizationId] = lAgent;
                        lOrganizationIds.push(lAgent.OrganizationId);
                    }
                }


                lAgentCard.UserId = lUser.Id;
                lAgentCard.AgentIds = lAgentIds;
                lAgentCard.OrganizationIds = lOrganizationIds;
                lAgentCard.FullName = lUser.FullName;
                lAgentCard.FirstName = lUser.FirstName;
                lAgentCard.LastName = lUser.LastName;

                lAgentCard.SortId = lUser.FullName + lUser.Id;
                lAgentCard.SecondSortId = lUser.FirstName + lUser.LastName + lUser.Id;

                if(ObjectLength(lMyAgents) > 0)
                    lCardList.push(lAgentCard);
            }
        }
    }
    mAgentsData.Clean = lCardList;
    mAgentsData.Sort = null;
    if (!isNullOrUndefined(lSortState)) {
        mAgentsData.Sort = lSortState.Value.sort(mAgentsData.Clean);
    }
}

function agentsDataItem_Updated(aCache, aData) {
    "use strict";
    var aCache,
        lData = aData;

    if (!isNullOrUndefined(mAgentsControls.CardView)) {
        if (UpdateViewOnNewData(lData, mAgentsData.Paginated)) {
            agentsDataListConverter();
            mAgentsControls.CardView.setUpdated(true);
        }
    }
}

function agentsEscalationPlansDataListConverter() {
    "use strict";
    var lEscalationPlans = getDataItems('EscalationPlans'),
        lOrganizations = getDataItems('Organizations'),
        lCardList = [],
        lCard,
        lItem,
        lKey;

    for (lKey in lEscalationPlans) {
        if (lEscalationPlans.hasOwnProperty(lKey)) {
            lItem = lEscalationPlans[lKey];
            lCard = new EscalationPlanCardView();
            lCard.EscalationPlanId = lItem.Id;
            lCard.Name = lItem.Name;
            lCard.Organization = lOrganizations[lItem.OrganizationId];
            lCard.OrganizationId = lItem.OrganizationId;
            lCard.OrganizationName = lCard.Organization.Name;
            lCard.Plan = lItem;
            lCardList.push(lCard);
        }
    }
    mAgentsData.EscalationPlansClean = lCardList;
}


function agentsEscalationPlans_Updated(){
    "use strict";
    agentsEscalationPlansDataListConverter();
    mAgentsControls.CardView.setUpdated(true);
}

// LIST POPULATION
function gFilterFactory_OnAgentsInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(14);

    if (isNullOrUndefined(mAgentsControls.CardViewFilter)) {
        var lParams = {
            'Title': localizeWrapper('cAgentFindAgents'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uAgentsCardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
                { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationIds', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll'), 'relationalOperator': mRelationalOperatorEnum.Contains(), 'ComparisonType': 'integer' }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 14
        };

        mAgentsControls.CardViewFilter = aSender.createControl(
        'uAgentsCardViewFilter',
        'uAgentsListFilterHolder',
        lParams);
    } else {
        mAgentsControls.CardViewFilter.render();
    }
    mAgentsControls.CardViewFilter.filter();
}

function gPaginatorFactory_OnAgentsInit() {
    "use strict";
    var lAgentState = getViewState('AgentsSelectedAgent'),
        lPageState = getViewState('AgentsSelectedPage');

   // if (isNullOrUndefined(mAgentsControls.CardViewPaginator)) {
        mAgentsControls.CardViewPaginator = new sumo.controls.Paginator('uAgentsCardViewPaginator', 'uAgentsPagerHolder', {
            'ItemCount': count(mAgentsData.Dirty),
            'ItemsPerPage': gPaginationSettings.AgentsAgentsItems
        });
        if (!isNullOrUndefined(lAgentState) && !isNullOrUndefined(lPageState)) {
            mAgentsControls.CardViewPaginator.setPage(lPageState.Value);
        }
  //  } else {
       // mAgentsControls.CardViewPaginator.render();
   // }
    mAgentsControls.CardViewPaginator.bind('pagechanged', uAgentsCardViewPaginator_OnPageChanged);
    //mAgentsControls.CardViewFilter.filter();

}

function uAgentsCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
        //lViewState = getViewState('AgentsSelectedAgent'),
        lSelected,
        lIsEmpty,
        lClass = 'Agents';

    if (isNullOrUndefined(mAgentsData.Sort)) {
        mAgentsData.Sort = mAgentsData.Clean;
    }

    if (mAgentsData.TargetId === -1) {
        mAgentsData.Dirty = query(mAgentsData.Sort, aExpression);
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('UserId', mAgentsData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mAgentsData.Dirty = query(mAgentsData.Sort, lBuilder.RootExpression);
        if (!mAgentsData.TargetIsMe) {
            mAgentsData.TargetId = -1;
        }
    }

    lIsEmpty = (mAgentsData.Dirty.length === 0);
    if (lIsEmpty && mStateManager.Settings()[1] !== 'Profile') {
        mStateManager.ChangeSettings(1, 'Profile');
    }
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyFilterState(lClass, lIsEmpty);

    if (isNullOrUndefined(mAgentsControls.CardViewPaginator)) {
        gPaginatorFactory_OnAgentsInit();
    }
    mAgentsData.Paginated = mAgentsControls.CardViewPaginator.paginate(mAgentsData.Dirty);
    if (!isNullOrUndefined(mAgentsControls.CardView)) {
        mAgentsControls.CardView.setDataSource(mAgentsData.Paginated);
    }

    //if (!isNullOrUndefined(lViewState)) {
    //    lSelected = parseInt(lViewState.Value);
    //    // $('#uAgentsCardViewRow'+lSelectedIndex).addClass('sumo-data-row-selected');
    //    mAgentsData.AgentsCurrentId = lSelected;
    //}

}

function uAgentsCardViewPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mAgentsData.Dirty)) {
        mAgentsData.Dirty = mAgentsData.Clean;
    }
    mAgentsData.Paginated = aSender.paginate(mAgentsData.Dirty);
    mAgentsControls.CardView.setDataSource(mAgentsData.Paginated);
    setViewState('AgentsSelectedPage', aNewPage);
}

function uAgentsCardView_OnUpdate() {
    "use strict";
    mAgentsControls.CardViewFilter.filter();
    uAgentsCardViewSortOnViewState();
}

function uAgentsCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mAgentsControls.CardView.unbind('databind', uAgentsCardView_OnDataBind);
    mAgentsControls.CardView.bind('databind', cardView_OnDataBind);
    if (!isNullOrUndefined(aData)) {
        mAgentsControls.CardView.selected(aData);
    } else {
        mAgentsControls.CardView.selectedIndex(0);
    }
}

function uAgentsCardViewSortOnViewState() {
    "user strict";
    var lSortState = getViewState('AgentsCardViewSort');
    if (!isNullOrUndefined(lSortState)) {
        mAgentsControls.CardView.sortExpression(lSortState.Value);
    }
}

function uAgentsCardView_OnSort(aParams, aSort) {
    "use strict";
    var lAgents = mAgentsData.Clean,
        lAgentsListSorted = [];

    lAgentsListSorted = aSort.sort(lAgents);
    mAgentsData.Sort = lAgentsListSorted;
    mAgentsControls.CardViewFilter.filter();
    setViewState('AgentsCardViewSort', aSort);
}

function agentsCardView_Init() {
    "use strict";
    var lViewState = getViewState('AgentsSelectedAgent');

    if (isNullOrUndefined(mAgentsControls.CardView)) {
        mAgentsControls.CardView = new sumo.controls.CardView('uAgentsCardView', 'uAgentsListHolder', {
            'cardTemplate': 'Interface/Agents.Agents.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'UserId', 'isSortable': true, 'Columns': [
                { 'id': 'SortId', 'title': 'Last Name, First Name, Login ID' },
                { 'id': 'SecondSortId', 'title': 'First Name, Last Name, Login ID' }
            ]
        });
        mAgentsControls.CardView.bind('selectedchanged', veritracks.security.controller.extendSession);
        mAgentsControls.CardView.bind('selectedchanged', uAgentsCardView_OnSelectChange);
        if (!isNullOrUndefined(lViewState)) {
            mAgentsControls.CardView.bind('databind', uAgentsCardView_OnDataBind, lViewState.Value);
        } else {
            mAgentsControls.CardView.bind('databind', cardView_OnDataBind);
        }
        mAgentsControls.CardView.bind('update', uAgentsCardView_OnUpdate);
        mAgentsControls.CardView.bind('sort', uAgentsCardView_OnSort);
    }
   gFilterFactory_OnAgentsInit(gFilterFactory, null, null);
}

function agentsEscalationPlansCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lIsEmpty,
        lClass = 'Agents';
    mAgentsData.EscalationPlansDirty = query(mAgentsData.EscalationPlansClean, aExpression);
    mAgentsData.EscalationPlansPaginated = mAgentsControls.CardViewPaginator.paginate(mAgentsData.EscalationPlansDirty);
    if (!isNullOrUndefined(mAgentsControls.CardView)) {
        mAgentsControls.CardView.setDataSource(mAgentsData.EscalationPlansPaginated);
    }
    lIsEmpty = (mAgentsData.EscalationPlansDirty.length === 0);
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyFilterState(lClass, lIsEmpty);
}

function agentsEscalationPlansCardViewFilter_Init() {
    "use strict";
    var lUserPreferences = getUserPreferences(14);

    if (isNullOrUndefined(mAgentsControls.CardViewFilter)) {
        var lParams = {
            'Title': localizeWrapper('cAgentFindEscalationPlans'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': agentsEscalationPlansCardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'Name', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'Name' },
                { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 14
        };

        mAgentsControls.CardViewFilter = gFilterFactory.createControl(
        'uAgentsCardViewFilter',
        'uAgentsListFilterHolder',
        lParams);
    } else {
        mAgentsControls.CardViewFilter.render();
    }
}

function agentsEscalationPlansCardViewPaginator_OnPageChanged() {
    "use strict";
    if (isNullOrUndefined(mAgentsData.EscalationPlansDirty)) {
        mAgentsData.EscalationPlansDirty = mAgentsData.EscalationPlansClean;
    }
    mAgentsData.EscalationPlansPaginated = mAgentsControls.CardViewPaginator.paginate(mAgentsData.EscalationPlansDirty);
    mAgentsControls.CardView.setDataSource(mAgentsData.EscalationPlansPaginated);
}

function agentsEscalationPlansCardViewPaginator_Init() {
    "use strict";
    if (isNullOrUndefined(mAgentsControls.CardViewPaginator)) {
        mAgentsControls.CardViewPaginator = new sumo.controls.Paginator('uAgentsCardViewPaginator', 'uAgentsPagerHolder', {
            'ItemCount': count(mAgentsData.EscalationPlansDirty),
            'ItemsPerPage': gPaginationSettings.AgentsEscalationPlansItems
        });
//            gPaginatorFactory.createControl('uAgentsCardViewPaginator', 'uAgentsPagerHolder', {
//            'ItemCount': count(mAgentsData.EscalationPlansDirty),
//            'ItemsPerPage': 500000
//        });
        mAgentsControls.CardViewPaginator.bind('pagechanged', agentsEscalationPlansCardViewPaginator_OnPageChanged);
    } else {
        mAgentsControls.CardViewPaginator.render();
    }
    mAgentsControls.CardViewFilter.filter();
}

function agentsEscalationPlansCardView_OnUpdate(){
    "use strict";
    mAgentsControls.CardViewFilter.filter();
}


function agentsEscalationPlansCardView_Init() {
    "use strict";
    if (isNullOrUndefined(mAgentsData.EscalationPlansClean)) {
        agentsEscalationPlansDataListConverter();
    }

    if (isNullOrUndefined(mAgentsControls.CardView)) {
        mAgentsControls.CardView = new sumo.controls.CardView('uAgentsCardView', 'uAgentsListHolder', { 'cardTemplate': 'Interface/Agents.NotificationEscalationPlans.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView' });
        mAgentsControls.CardView.bind('selectedchanged', veritracks.security.controller.extendSession);
        mAgentsControls.CardView.bind('selectedchanged', agentsEscalationPlansCardView_OnSelectChange);
        mAgentsControls.CardView.bind('databind', cardView_OnDataBind);
        mAgentsControls.CardView.bind('update', agentsEscalationPlansCardView_OnUpdate);
    }
    agentsEscalationPlansCardViewFilter_Init();
    agentsEscalationPlansCardViewPaginator_Init();
}


// LIST EVENTS
function uAgentsCardView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    var lSelected = mAgentsControls.CardView.selectedDataItem();
    $('#uUserDetailsIdHolder').show();
    mAgentsData.ArchivedEnrollees = null;
    mAgentsData.ArchivedEnrolleesLock = false; // unlocked
    window['agents' + mStateManager.Settings()[0] + mStateManager.Settings()[1] + '_Populate']();
    uCancelRiskLevelPlanButton_OnClick();

    if (!isNullOrUndefined(lSelected)) {
        if (!mAgentsData.TargetIsMe) {
            setViewState('AgentsSelectedAgent', lSelected.UserId);
        }
        if (mAgentsData.TargetIsMe) {
            $('.TargetIsMeHidden').hide();
        }
        enhancedCrimeAnalystTempRemoveDisplay(lSelected.User.UserRoleValueTypeId);
    }


}


// temp function til fix is found
function enhancedCrimeAnalystTempRemoveDisplay(aUserRoleTypeId) {
    "use strict";
    var lUserRoleTypeId = aUserRoleTypeId;

    // crime analyst
    if (lUserRoleTypeId == 2) {
        $('.pEnrolleesOffenderProfile').addClass('HideClass');
        $('.pAgentsDetailsDailyNotifications').addClass('HideClass');
        $('.pAgentsDetailsImmediateNotifications').addClass('HideClass');
        $('.pAgentsDetailsRiskLevelPlans').addClass('HideClass');
        $('.pAgentsDetailsOffHours').addClass('HideClass');
       // $('.pAgentsDetailsPermissions').addClass('HideClass');
    }
    else {
        $('.pAgentsDetailsProfile').removeClass('HideClass');
        $('.pEnrolleesOffenderProfile').removeClass('HideClass');
        $('.pAgentsDetailsDailyNotifications').removeClass('HideClass');
        $('.pAgentsDetailsImmediateNotifications').removeClass('HideClass');
        $('.pAgentsDetailsRiskLevelPlans').removeClass('HideClass');
        $('.pAgentsDetailsOffHours').removeClass('HideClass');
        $('.pAgentsDetailsPermissions').removeClass('HideClass');
    }

}
function agentsEscalationPlansCardView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    uCancelEscalationPlanButton_OnClick();
    agentsNotificationEscalationPlans_Init();
}


// PAGE INIT
function agentsAgentsDetails_Populate() {
    "use strict";
    agentsAgentsProfile_Populate();
}

function agentsAgentsProfile_Populate() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizations = getDataItems('Organizations'),
        lRoles = getDataItems('UserRoleValueTypes'),
        lPreferences = getUserPreferences(4),
        lOrganizationOutput = [],
        lOrganizationCount = 0,
        lBuilder = new SumoPredicateBuilder(),
        lSMSOptInEnabled = veritracks.system.clientSetting('SMSoptinflag'),
        lAutoDashboardEnabled = veritracks.system.clientSetting('AutoDashboardRefreshEnabled'),
        lPasswordPolicyEnabled = veritracks.system.clientSetting('passwordpolicyenable'),
        lOrganization,
        lPreference,
        lValue = 1,
        lAgent,
        lUser,
        lRole,
        lKey;

    if (!lSMSOptInEnabled) {
        $('.SMSOptInEnabled').remove();
    }
    if (!lPasswordPolicyEnabled) {
        $('#uAgentPasswordPolicyEnabled').hide();
    }

    uCancelAgentButton_OnClick();
    if (gUserDetails.Role == 2) {
        $('#uRegularUserPrivilegeOrganizations').hide();
        $('#uRegularUserPrivilegeOrganizationsData').hide();
    }

    if (!isNullOrUndefined(lCard)) {
        lUser = getDataItem(lCard.UserId, 'Users');
        if (lUser !== null) {
            PopulateDetailView(lUser, {
                'PrimaryPhone': PhoneNumberFormatter,
                'SecondaryPhone': PhoneNumberFormatter,
                'ThirdPhone': PhoneNumberFormatter,
                'FourthPhone': PhoneNumberFormatter,
                'PrimarySMSOptInFlag': SMSOptInFormatter,
                'SecondarySMSOptInFlag': SMSOptInFormatter,
                'ThirdSMSOptInFlag': SMSOptInFormatter,
                'FourthSMSOptInFlag': SMSOptInFormatter,
                'PasswordPolicy': PasswordPolicyFormatter,
                'TwoFARequiredFlag': SMSOptInFormatter
            }, 'uUserDetails');


            var l2faEnabled = veritracks.system.clientSetting('2faenabled')

            $('.Agent2FASettings').hide()
            $('.Agent2FARequired').hide()
            if (l2faEnabled) {
                var l2FARequired = veritracks.system.clientSetting('2farequired');
                if (CheckUserHasPermission(251)) {
                    if (lUser.AccountStatus == "NEW" || !lUser.AccountStatus) {
                        $('.Agent2FASettings').hide()
                    } else {
                        $('.Agent2FASettings').show()
                    }
                }
                $('.Agent2FARequired').show()
            }


            for (lKey in lCard.OrganizationIds) {
                if (lCard.OrganizationIds.hasOwnProperty(lKey)) {
                    lOrganizationCount++;
                    lOrganization = lOrganizations[lCard.OrganizationIds[lKey]];
                    if (lOrganizationCount > 1) {
                        lOrganizationOutput.push(', ');
                    }
                    if (lOrganization) {
                        lOrganizationOutput.push(lOrganization.Name);
                    }
                }
            }

            $('#uUserDetailsOrganizations').text(lOrganizationOutput.join(''));

            for (var i in lRoles) {
                if (lRoles[i].Id === lUser.UserRoleValueTypeId) {
                    lRole = lRoles[i];
                    lCard.Role = lRole;
                    break;
                }
            }


            $('#uUserDetailsRole').text(lRole.Description);
        }

    }
}

function agentsAgentsProfile_Init() {
    "use strict";
    if (mAgentsData.TargetIsMe) {
        $('.MyAccountSettings').show();
    } else {
        $('.MyAccountSettings').hide();
    }
    agentsAgentsProfile_Populate();
}

function agentsAgentsPermissions_PopulateData() {
    "use strict";
    var lPermissions= getDataItems('Permissions'),
        lUserPermission,
        lItem,
        lBuilder = new SumoPredicateBuilder(),
        lAdvancedPermissionsEnabled = veritracks.system.clientSetting('AdvancedPermissionsEnabled'),
        lFeaturePreview = veritracks.system.clientSetting('veritracksfeaturepreview'),
        lKey;
    var lCard = mAgentsControls.CardView.selectedDataItem();

    // TEMPORARY FIX TO ONLY SHOW THIS PERMISSION TO CA1
    $('.DataAccessPermissions').hide();
    if (lAdvancedPermissionsEnabled) {
        $('.DataAccessPermissions').show();
    } else {
        lBuilder.AddNewExpressionConditional('Id', 45, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lPermissions = query(lPermissions, lBuilder.RootExpression);
    }

    $('.FeaturePreviewPermissions').hide();
    if (lFeaturePreview) {
        $('.FeaturePreviewPermissions').show();
    } else {
        lBuilder.AddNewExpressionConditional('Id', 61, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lPermissions = query(lPermissions, lBuilder.RootExpression);
    }


    for (lKey in lPermissions) {
        if (lPermissions.hasOwnProperty(lKey)) {
            lItem = lPermissions[lKey];
            lUserPermission = mAgentsData.UserPermissions[lItem.Id];
            if (isNullOrUndefined(lUserPermission)) {
                lUserPermission = { 'Value': -1 };
            }
            if (lItem.IsWritable) {
                PopulateDetailView(lUserPermission, { 'Value': agentWritablePermissionFormatter }, 'uPermission' + lItem.Id);
            } else {
                PopulateDetailView(lUserPermission, { 'Value': agentReadablePermissionFormatter }, 'uPermission' + lItem.Id);
            }
        }
    }

    var l2faEnabled = veritracks.system.clientSetting('2faenabled')

    if (!l2faEnabled) {
        $('#uPermission251Value').parent().parent().hide()
    }
}

function agentsAgentsPermissions_OnComplete(aParams, aData) {
    "use strict";
    var lItem,
        lBuilder = new SumoPredicateBuilder(),
        lUser,
        lUsers = getDataItems('Users'),
        lKey;
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', aParams, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lUser = query(lUsers, lBuilder.RootExpression);
    lUser = lUser[aParams];
    setUserPermissions(lUser, aData);
    setLoadingBarStatus('uPermissionsLoadingBar', 'uAgentsPermissionsHolder', false);
    agentsAgentsPermissions_PopulateData();
}

function agentsAgentsPermissions_Populate() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lll = veritracks.system.clientSetting('');

    uCancelPermissionsButton_OnClick();
    mAgentsData.UserPermissions = null;
    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('UserId', lCard.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.UserPermission.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsPermissions_OnComplete, null, lCard.UserId, null, 0, true);
    }


    if (lCard.UserId === gUserDetails.UserId || lCard.User.UserRoleValueTypeId === 2) {
        $('#uEditPermissionsButton').hide();
    } else {
        $('#uEditPermissionsButton').show();
    }
}

function uPermissionValueEdit_OnChange(aEvent) {
    "use strict";
    var lPermissions = getDataItems('Permissions'),
        lBuilder = new SumoPredicateBuilder(),
        lThis = $(this),
        lElementId = this.id,
        lPermissionId = lElementId.substring(11, lElementId.length - 9),
        //lPermission,
        lValue = parseInt(lThis.val(), 10),
        lItem,
        lKey,
        lPermissionLatest = checkPushingLatestSelectChange([lPermissionId, lValue]);

    if (lPermissionLatest == true) {
        mAgentsControls.userPermissionsChanged.push([lPermissionId, lValue]);
    } else {
        mAgentsControls.userPermissionsChanged[lPermissionLatest[0]][1] = lPermissionLatest[1];
    }

    if (lValue === -1) {
        $('#uPermission' + lPermissionId + 'ValueEdit').val(0).change();
    } else {
        var lCard = mAgentsControls.CardView.selectedDataItem();
        //lPermission = lPermissions[lPermissionId];
        lBuilder.AddNewExpressionConditional('MasterPermissionId', lPermissionId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lPermissions = query(lPermissions, lBuilder.RootExpression);

        for (lKey in lPermissions) {
            if (lPermissions.hasOwnProperty(lKey)) {
                lItem = lPermissions[lKey];
                if (lValue === 0) {
                    $('#uPermission' + lItem.Id + 'ValueEdit').val(0).change().attr('disabled', 'disabled');
                } else {
                    $('#uPermission' + lItem.Id + 'ValueEdit').change().removeAttr('disabled');
                }
            }
        }
    }
}

function checkPushingLatestSelectChange(lPermissionArray) {
    "use strict";
    var lPossibleChangedValues = mAgentsControls.userPermissionsChanged;

    if (lPossibleChangedValues.length >= 1) {
        for (var i = 0; i < lPossibleChangedValues.length; i++) {
            if (lPossibleChangedValues[i][0].lastIndexOf(lPermissionArray[0]) > -1) {
                return [i, lPermissionArray[1]];
            }
        }
    }

    return true;
}

function agentsAgentsPermissions_Init() {
    "use strict";
    var lPermissions = getDataItems('Permissions'),
        lRoles = getDataItems('UserRoleValueTypes'),
        lColumnWidth = 0,
        lHtmlItem,
        lHtml = [],
        lElements,
        lItem,
        lKey;
    var lCard = mAgentsControls.CardView.selectedDataItem();

    for (lKey in lPermissions) {
        if (lPermissions.hasOwnProperty(lKey)) {
            lItem = lPermissions[lKey];
            if (lItem.Id != 201) { //battery history
                if (isNullOrUndefined(lHtml[lItem.PermissionType])) {
                    lHtml[lItem.PermissionType] = [];
                    lHtmlItem = lHtml[lItem.PermissionType];
                    lHtmlItem.push('<table>');
                } else {
                    lHtmlItem = lHtml[lItem.PermissionType];
                }

                lHtmlItem.push('<tr><td class="FormTitleLong">');
                lHtmlItem.push(localizeDataItem('Permission', lItem.Name));
                lHtmlItem.push('</td><td class="FormField">');
                lHtmlItem.push('<div class="Editable" id="uPermission');
                lHtmlItem.push(lItem.Id.toString());
                lHtmlItem.push('Value"></div>');
                lHtmlItem.push('<select class="Editing PermissionValueEdit" id="uPermission');
                lHtmlItem.push(lItem.Id.toString());
                lHtmlItem.push('ValueEdit"></select>');
                lHtmlItem.push('</td></tr>');
            }
        }
    }

    for (lKey in lHtml) {
        if (lHtml.hasOwnProperty(lKey)) {
            lItem = lHtml[lKey];
            lItem.push('</table>');
            $('#uAgentsPermissions' + lKey + 'Holder').html(lItem.join(''));
        }
    }
    $('.PermissionValueEdit').change(uPermissionValueEdit_OnChange);

    lElements = $('.FormTitle');
    for (lKey = 0; lKey < lElements.length; ++lKey) {
        lItem = $(lElements[lKey]);
        if(lItem[0].clientWidth- 20 > lColumnWidth){
            lColumnWidth = lItem[0].clientWidth - 20;
        }
    }
    setWidth('.FormTitle', lColumnWidth);

    agentsAgentsPermissions_Populate();
}

function uEditPermissionsButton_OnClick() {
    "use strict";
    var lPermissions = getDataItems('Permissions'),
        lWritableOptions = [{ 'Id': 0, 'Value': localizeText('cAgentDeny') }, { 'Id': 1, 'Value': localizeText('cAgentRead') }, { 'Id': 2, 'Value': localizeText('cAgentReadWrite') }],
        lGrantableOptions = [{ 'Id': 0, 'Value': localizeText('cAgentDeny') }, { 'Id': 1, 'Value': localizeText('cAgentGrant') }],
        lSelected = mAgentsControls.CardView.selectedDataItem(),
        lOptions,
        lUserPermission,
        lItem,
        lKey;

    if (lSelected.UserId !== gUserDetails.UserId) {
        for (lKey in lPermissions) {
            if (lPermissions.hasOwnProperty(lKey)) {
                lItem = lPermissions[lKey];
                lUserPermission = mAgentsData.UserPermissions[lItem.Id];
                if (isNullOrUndefined(lUserPermission)) {
                    lUserPermission = { 'Value': -1 };
                }
                if (lItem.IsWritable) {
                    lOptions = lWritableOptions;
                } else {
                    lOptions = lGrantableOptions;
                }
                populateEditView(lUserPermission, [
                    { 'Id': 'Value', 'Type': 'Dropdown', 'DataSource': lOptions, 'LocaleName': 'Permission', 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': true, 'nullText': localizeText('cAgentUnset') }
                ], {}, 'uPermission' + lItem.Id, 'Edit', localizeDataItem);
            }
        }
        $('#uSavePermissionsButton').show();
        $('#uCancelPermissionsButton').show();
        $('#uSelectAllPermissionsButton').show();
        $('#uEditPermissionsButton').hide();
       // $('.PermissionValueEdit').change();
        EnterEditMode('uAgentsPermissionsHolder');
        $('.AgentsPermissionsEdit').show();
        uPermissionsDefaultCheck();
      //  $('.AgentsPermissionsEdit').bind('change', uAgentsCheck_OnClick);
    } else {
        $('#uEditPermissionsButton').hide();
        $('.AgentsPermissionsEdit').hide();
    }
}

function uPermissionsDefaultCheck() {
    "use strict";

    for (var i = 0; i < 9; i++) {
        $('#uAgentsPermissionsCheck'+ i).prop('checked', false);
    }

}

$('.AgentsPermissionsEdit').live('click', function () {
    var lselectedFlag = $(this).attr('id'),
        lselected = ($('#uUnSelectAllPermissionsButton').is(':hidden')),
        lPermissions = getDataItems('Permissions'),
        lBuilder = new SumoPredicateBuilder(),
        lItem,
        lBoxSelected = $(this).prop('checked'),
        lUserPermission,
        lKey,
        lOptions;

    lselectedFlag = parseInt(lselectedFlag.replace("uAgentsPermissionsCheck", ""));
    lBuilder.AddNewExpressionConditional('PermissionType', lselectedFlag, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', [251], false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And()); // ignored in select all

    lPermissions = query(lPermissions, lBuilder.RootExpression);

    if (!mAgentsData.PermissionsClicked) {
        lselected = lBoxSelected;
    }
    for (lKey in lPermissions) {
        if (lPermissions.hasOwnProperty(lKey)) {
            lItem = lPermissions[lKey];
            lUserPermission = mAgentsData.UserPermissions[lItem.Id];
            if (lItem.IsWritable) {
                lOptions = 2; // read/write
            } else {
                lOptions = 1; // grant
            }
            if (lselected) {
                $('#uPermission' + lItem.Id + 'ValueEdit').val(lOptions);
            }
            else {
                $('#uPermission' + lItem.Id + 'ValueEdit').val(0);
            }
        }
    }
});

function uEditPermissionsSelectAll_OnClick() {
    "use strict";
    uSelectAllPermissions(false);

    $('#uSelectAllPermissionsButton').hide();
    $('#uUnSelectAllPermissionsButton').show();
}

function uSelectAllPermissions(aChecked) {
    var i = 0;

    mAgentsData.PermissionsClicked = true;
    for (i = 0; i <= 8; i++) {
        if (aChecked) {
            $('#uAgentsPermissionsCheck' + i).prop('checked', true);
        }
        else {
            $('#uAgentsPermissionsCheck' + i).prop('checked', false);
        }
        $('#uAgentsPermissionsCheck' + i).click();
    }

    mAgentsData.PermissionsClicked = false;
}
function uEditPermissionsUnSelectAll_OnClick() {
    "use strict";
    uSelectAllPermissions(true);

    $('#uUnSelectAllPermissionsButton').hide();
    $('#uSelectAllPermissionsButton').show();
}

function uCancelPermissionsButton_OnClick() {
    "use strict";
    $('#uSavePermissionsButton').hide();
    $('#uCancelPermissionsButton').hide();
    $('#uSelectAllPermissionsButton').hide();
    $('#uUnSelectAllPermissionsButton').hide();
    $('#uEditPermissionsButton').show();
    ExitEditMode('uAgentsPermissionsHolder');
    $('.AgentsPermissionsEdit').hide();
}

function agentsAgentsPermissions_OnSave(aParams, aData) {
    "use strict";
    mAgentsControls.userPermissionsChanged = [];
    agentsAgentsPermissions_OnComplete(aParams, aData);
    uCancelPermissionsButton_OnClick();
}

function uSavePermissionsButton_OnClick() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lPermissions = getDataItems('Permissions'),
        lPermissions,
        lUserPermissionWrite = [],
        lUserPermission,
        lUserPermissionPrev,
        lItem,
        lKey,
        lIsNewPermission;

    function onShow() {
        for (lKey in lPermissions) {
            if (lPermissions.hasOwnProperty(lKey)) {
                lItem = lPermissions[lKey];
                lUserPermission = mAgentsData.UserPermissions[lItem.Id];
                if (isNullOrUndefined(lUserPermission)) {
                    lUserPermission = new UserPermission();
                    lUserPermission.Id = lItem.Id;
                    lUserPermission.PermissionId = lItem.Id;

                    lUserPermission.UserId = lCard.UserId;
                    lUserPermission.LoginUserId = gUserDetails.UserId;
                }
                lUserPermission.TransactionId = moment().format("YYYYMMDDHHmmss");
                lUserPermission.LoginUserId = gUserDetails.UserId;
                populateFromEditView(lUserPermission, 'uPermission' + lItem.Id, 'Edit');
                if (lUserPermission.Value !== "-1") {
                    lUserPermissionWrite.push(lUserPermission);
                }
            }
        }


        // modifying anyone that is not a regular agent will convert them to a regular agent.
        if (lCard.User.UserRoleValueTypeId > 1) {
            saveHiddenPermissions(lUserPermissionWrite, lCard.User.UserRoleValueTypeId);
            var lUser = lCard.User;
            var lUserRole = getUserRoleById(lCard.UserId);
            var lRole = getDataItem(1, "UserRoleValueTypes");

            lUser.UserRoleValueTypeId = lRole.Id;
            lUser.Description = lRole.Description;
            lUserRole.UserRoleValueTypeId = lRole.Id;
            lUserRole.Description = lRole.Description;

            // update cache
            setDataItem(lUser.Id, "Users", lUser);

            // save userrolevaluetype to userwrite
            WriteSingle(lUser, null, null, null, true);
            // save new role to userrolewrite

            setDataItem(lUserRole.Id, "UserRoles", lUserRole);
            WriteSingle(lUserRole, null, null, null, true);
            agentsDataItem_Updated();
        }

        WriteMultiple(lUserPermissionWrite, agentsAgentsPermissions_OnSave, agentsAgentsPermissions_OnFail, lCard.UserId, true);
    }

    $('#uSavePermissionsButton').hide();
    $('#uCancelPermissionsButton').hide();
    $('#uSelectAllPermissionsButton').hide();
    $('#uUnSelectAllPermissionsButton').hide();
    setLoadingBarStatus('uPermissionsLoadingBar', 'uAgentsPermissionsHolder', true, onShow);
}

function checkIfPermissionIsChanged(aUserPermissionPrev, aUserPermission) {
    "use strict";
    var lPossibleChangedValues = mAgentsControls.userPermissionsChanged,
        lUserPermission = aUserPermission,
        lUserPermissionPrev = aUserPermissionPrev;

    if (lPossibleChangedValues.length >= 1) {
        for (var i = 0; i < lPossibleChangedValues.length; i++) {
            if (lPossibleChangedValues[i][0].lastIndexOf(lUserPermission.PermissionId) > -1) {
                if (lPossibleChangedValues[i][1] != lUserPermissionPrev.Value) {
                    return true;
                }
            }
        }
    }

    return false;

}

function agentsAgentsPermissions_OnFail(a, b, c, d) {
    console.log(a, b, c, d);
}

function saveHiddenPermissions(aPermissions, aRole) {
    "use strict";
    var lPermissions = getDataItems('Permissions'),
        lBuilder = new SumoPredicateBuilder(),
        lKey;

    lBuilder.AddNewExpressionConditional('PermissionType', 9, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lPermissions = query(lPermissions, lBuilder.RootExpression);


    for (lKey in lPermissions) {
        if (lPermissions.hasOwnProperty(lKey)) {
            var lP = lPermissions[lKey];
            aPermissions[lP.Id - 1].Value = 0;
        }
    }
}
// DATA POPULATION

function getSupervisorTypes() {
    var lSupervisorTypeList = [];

    lSupervisorTypeList.push({ 'Id': -1, 'Value': localizeText('cAgentStandarUser') });
    lSupervisorTypeList.push({ 'Id': 1, 'Value': localizeText('cAgentSupervisor1') });
    lSupervisorTypeList.push({ 'Id': 2, 'Value': localizeText('cAgentSupervisor2') });
    lSupervisorTypeList.push({ 'Id': 3, 'Value': localizeText('cAgentSupervisor3') });
    lSupervisorTypeList.push({ 'Id': 4, 'Value': localizeText('cAgentSupervisor4') });
    return lSupervisorTypeList;
}


function fillAgentNumbers() {
    var lHtml = [];

    if ($('#uUserDetailsPrimarySMSOptInFlagEdit').is(":checked")) {
        var primary = $('#uUserDetailsPrimaryPhoneEdit').val();
        lHtml.push('<option value="');
        lHtml.push(primary + '">');
        lHtml.push(primary + '</option>');
    }
    if ($('#uUserDetailsSecondarySMSOptInFlagEdit').is(":checked")) {
        var secondary = $('#uUserDetailsSecondaryPhoneEdit').val();
        lHtml.push('<option value="');
        lHtml.push(secondary + '">');
        lHtml.push(secondary + '</option>');
    }
    if ($('#uUserDetailsThirdSMSOptInFlagEdit').is(":checked")) {
        var third = $('#uUserDetailsThirdPhoneEdit').val();
        lHtml.push('<option value="');
        lHtml.push(third + '">');
        lHtml.push(third + '</option>');
    }
    if ($('#uUserDetailsFourthSMSOptInFlagEdit').is(":checked")) {
        var fourth = $('#uUserDetailsFourthPhoneEdit').val();
        lHtml.push('<option value="');
        lHtml.push(fourth + '">');
        lHtml.push(fourth + '</option>');
    }
    return lHtml.join('');
}
$('.AgentContactSelectFields').live('change', function (self) {
    var lName = self.target.id;
    var id = lName.replace(/\D/g, '');
    var value = $('#' + lName).val();
    var lHtml = [];
    var field = lName.replace('MethodIdEdit', 'ValueSection');
    var editField = lName.replace('MethodId', 'Value');

    if (value == 1) { // phone create dropdown
        var current = $('#' + editField).val();
        $('#' + field).empty();

        lHtml.push(generateContactDropdown(editField));
        $('#' + field).append(lHtml.join(''));
        $('#' + editField).val(current);
        $('#'+ field + 'Error').hide();
    } else if (value == 2) { // email create text box
        if (!$('#' + editField).hasClass('ValidateEmail')) {
            $('#' + field).empty();

            var inputFields = field.includes('First') ? 'Validate ValidateRequired ValidateEmail ValidateEmailDomain ValidateLength Validate50Length' : 'Validate ValidateEmail ValidateEmailDomain ValidateLength Validate50Length'
            lHtml.push('<input class="' + inputFields + '" type="text" id="');
            lHtml.push(editField);
            lHtml.push('" />');
            $('#' + field).append(lHtml.join(''));
        }
    }

    if (value == 2) {
        updateAgentOrganizationDetail(id, value, lName);
    }

    if (!isNullOrUndefined(mAgentsControls.Validator)) {
        mAgentsControls.Validator.scan();
    }
});

function updateAgentOrganizationDetail(organizationId, method, Name) {
  'use strict';
  var lCurrentContact = $('#' + Name.replace('MethodId', 'Value'));
  var lValue = lCurrentContact.val();
  var lCopyValue = '';
  var checkOne;
  var checkTwo;
  var formatter = "Email";

  if (method == 1) {
      return;
  } else {
    lCopyValue = $('#uUserDetailsEmailEdit').val().toUpperCase();
  }

  if (Name.includes('First')) {
    checkOne = $(
      '#' + Name.replace('MethodId', 'Value').replace('First', 'Second')
    );
    checkTwo = $(
      '#' + Name.replace('MethodId', 'Value').replace('First', 'Third')
    );
  } else if (Name.includes('Second')) {
    checkOne = $(
      '#' + Name.replace('MethodId', 'Value').replace('Second', 'First')
    );
    checkTwo = $(
      '#' + Name.replace('MethodId', 'Value').replace('Second', 'Third')
    );
  } else if (Name.includes('Third')) {
    checkOne = $(
      '#' + Name.replace('MethodId', 'Value').replace('Third', 'First')
    );
    checkTwo = $(
      '#' + Name.replace('MethodId', 'Value').replace('Third', 'Second')
    );
  }

  if (mAgentsData.Loading && lValue == "") return

  if (lCopyValue.length > 0 && (lValue == '' || !lValue.match(mRegexValidation[formatter]))) {
      var checkOneSuccess = checkOne.val().toLowerCase() !== lCopyValue.toLowerCase()
      var checkTwoSuccess = checkTwo.val().toLowerCase() !== lCopyValue.toLowerCase()

     if (checkOneSuccess && checkTwoSuccess) {
      lCurrentContact.val(lCopyValue);
    }
  }

}

function generateContactDropdown(id) {
    var lHtml = [];

    lHtml.push('<select class="phoneContactDropdown" id="');
    lHtml.push(id);
    lHtml.push('"  style="width:149px">');
    lHtml.push('<option value="" selected> Please Select Phone Number </option>')
    lHtml.push(fillAgentNumbers());
    lHtml.push('</select>');

    return lHtml.join('');
}
//--------
// Profile
//--------
function agentsAgentsProfileOrganizationDetails_Init(aOrganization) {
    "use strict";
    var lHtml = [],
        lClass = 'OrganizationDetails' + aOrganization.Id.toString(),
        lObjectList = $('.' + lClass),
        lAgent,
        lSupervisorTypeList = [],
        lDutyOfficerList = getDataItems('Agents'),
        lTimeZoneList = getDataItems('TimeZone'),
        lBuilder = new SumoPredicateBuilder();

    var lContactMethod = getDataItems('UserContactMethod');

    lContactMethod = lContactMethod.filter(function (method) { return method.Id !== 3 });

    if (!isNullOrUndefined(mAgentsData.CardViewEditItem)) {
        lAgent = mAgentsData.CardViewEditItem.AgentsByOrganization[aOrganization.Id];
    }
    if (isNullOrUndefined(lAgent)) {
        lAgent = new Agent();
    }

    if (lObjectList.length === 0) {
        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td colspan="2"><h3>');
        lHtml.push(aOrganization.Name);
        lHtml.push('</h3></td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormField">');
        lHtml.push('<input class="AgentContactUpdateFields EditForm" type="text" placeholder="' + localizeText('cAgentPrimaryContact') + '" id="u');
        lHtml.push(lClass);
        lHtml.push('FirstContactNameEdit" />');
        lHtml.push('</td>');
        lHtml.push('<td style="width:250px">');
        lHtml.push('<select class="AgentContactSelectFields" id="u');
        lHtml.push(lClass);
        lHtml.push('FirstContactMethodIdEdit">');
        lHtml.push('</select>');
        lHtml.push('<div style="float:right;" id="u')
        lHtml.push(lClass);
        lHtml.push('FirstContactValueSection">');
        if (lAgent.FirstContactMethodId == 1) {
            lHtml.push(generateContactDropdown('u' + lClass + 'FirstContactValueEdit'))
        } else {
            lHtml.push('<input class="Validate ValidateRequired ValidateEmail ValidateEmailDomain ValidateLength Validate50Length" type="text" id="u');
            lHtml.push(lClass);
            lHtml.push('FirstContactValueEdit" />')
        }
        lHtml.push('</div>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormField">');
        lHtml.push('<input class="AgentContactUpdateFields EditForm" type="text" placeholder="' + localizeText('cAgentSecondaryContact') + '" id="u');
        lHtml.push(lClass);
        lHtml.push('SecondContactNameEdit" />');
        lHtml.push('</td>');
        lHtml.push('<td style="width:250px">');
        lHtml.push('<select class="AgentContactSelectFields" id="u');
        lHtml.push(lClass);
        lHtml.push('SecondContactMethodIdEdit">');
        lHtml.push('</select>');
        lHtml.push('<div style="float:right;" id="u')
        lHtml.push(lClass);
        lHtml.push('SecondContactValueSection">');
        if (lAgent.SecondContactMethodId == 1) {
            lHtml.push(generateContactDropdown('u' + lClass + 'SecondContactValueEdit'))
        } else {
            lHtml.push('<input class="Validate ValidateEmail ValidateEmailDomain ValidateLength Validate50Length" type="text" id="u');
            lHtml.push(lClass);
            lHtml.push('SecondContactValueEdit" />')
        }
        lHtml.push('</div>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormField">');
        lHtml.push('<input class="AgentContactUpdateFields EditForm" type="text" placeholder="' + localizeText('cAgentTertiaryContact') + '" id="u');
        lHtml.push(lClass);
        lHtml.push('ThirdContactNameEdit" />');
        lHtml.push('</td>');
        lHtml.push('<td style="width:250px">');
        lHtml.push('<select class="AgentContactSelectFields" id="u');
        lHtml.push(lClass);
        lHtml.push('ThirdContactMethodIdEdit">');
        lHtml.push('</select>');
        lHtml.push('<div style="float:right;" id="u')
        lHtml.push(lClass);
        lHtml.push('ThirdContactValueSection">');
        if (lAgent.ThirdContactMethodId == 1) {
            lHtml.push(generateContactDropdown('u' + lClass + 'ThirdContactValueEdit'))
        } else {
            lHtml.push('<input class="Validate ValidateEmail ValidateEmailDomain ValidateLength Validate50Length" type="text" id="u');
            lHtml.push(lClass);
            lHtml.push('ThirdContactValueEdit" />')
        }
        lHtml.push('</div>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentIsDutyOfficer') + '</td>');
        lHtml.push('<td class="FormField">');
        lHtml.push('<input type="checkbox" id="u');
        lHtml.push(lClass);
        lHtml.push('IsDutyOfficerEdit" />');
        lHtml.push(' <label for="u');
        lHtml.push(lClass);
        lHtml.push('IsDutyOfficerEdit">' + localizeWrapper('cAgentThisAgentDutyOfficer') + '</label>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lBuilder.AddNewExpressionConditional('OrganizationId', aOrganization.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsDutyOfficer', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDutyOfficerList = query(lDutyOfficerList, lBuilder.RootExpression);
        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentDutyOfficer') + '</td>');
        lHtml.push('<td class="FormField">');
        lHtml.push('<select id="u');
        lHtml.push(lClass);
        lHtml.push('DutyOfficerIdEdit">');
        lHtml.push('</select>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormTitle">' + localizeWrapper('cAgentSupervisorType') + '</td>');
        lHtml.push('<td class="FormField">');
        lHtml.push('<select id="u');
        lHtml.push(lClass);
        lHtml.push('SupervisorTypeIdEdit">');
        lHtml.push('</select>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        lHtml.push('<tr class="OrganizationDetails ');
        lHtml.push(lClass);
        lHtml.push('">');
        lHtml.push('<td class="FormTitle">' + localizeWrapper('cEnrolleeTimeZone') + '</td>');
        lHtml.push('<td class="FormField">');
        lHtml.push('<select id="u');
        lHtml.push(lClass);
        lHtml.push('TimeZoneIdEdit">');
        lHtml.push('</select>');
        lHtml.push('</td>');
        lHtml.push('</tr>');

        $('#uOrganizationDetailsTable').append(lHtml.join(''));

        veritracks.localization.localize('.' + lClass);

        var laTimeZoneIds = [];
        if (lAgent.DutyOfficerId == -1 && lAgent.Id == -1) {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            var lUserAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
            for (var key in lUserAgents) {
                if (lUserAgents.hasOwnProperty(key)) {
                    if (laTimeZoneIds.indexOf(lUserAgents[key].TimeZoneId) == -1) {
                        if (checkOrganizationProperty(lUserAgents[key].OrganizationId, 'only_one_timezone') === 'Y'){
                            laTimeZoneIds.push(lUserAgents[key].TimeZoneId);
                        }//end of if
                    }//end of if
                }//end of if
            }//end of for
        } else {
            if (checkOrganizationProperty(lAgent.OrganizationId, 'only_one_timezone') === 'Y') {
                laTimeZoneIds.push(lAgent.TimeZoneId);
            }//end of if

        }

        var lSelectedTimezoneName = $('#uOffenderProfileTimeZoneCode').text();
        lTimeZoneList = lTimeZoneList.filter(function (a) {
            if (laTimeZoneIds.length > 0 && laTimeZoneIds.indexOf(a.Id) == -1) {
                return false;
            }
            return a.IsActive == 1 || a.TimeZoneCode == lSelectedTimezoneName;
        })

        $('#u' + lClass + 'FirstContactValueEdit').val("");
        $('#u' + lClass + 'SecondContactValueEdit').val("");
        $('#u' + lClass + 'ThirdContactValueEdit').val("");

        //$('#u' + lClass + 'FirstContactMethodIdEdit').val(lAgent.FirstContactMethodId > 0 ? lAgent.FirstContactMethodId : 2);
        //$('#u' + lClass + 'SecondContactMethodIdEdit').val(lAgent.SecondContactMethodId > 0 ? lAgent.SecondContactMethodId : 2);
        //$('#u' + lClass + 'ThirdContactMethodIdEdit').val(lAgent.ThirdContactMethodId > 0 ? lAgent.ThirdContactMethodId : 2);

        populateEditView(lAgent, [
                { 'Id': 'SupervisorTypeId', 'Type': 'Dropdown', 'DataSource': getSupervisorTypes(), 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': false },
                { 'Id': 'DutyOfficerId', 'Type': 'Dropdown', 'DataSource': lDutyOfficerList, 'DataValueField': 'Id', 'DataTextField': 'FullName', 'insertBlank': true, 'blankText': localizeText('cAgentNoDutyOfficer') },
                { 'Id': 'TimeZoneId', 'Type': 'Dropdown', 'DataSource': lTimeZoneList, 'LocaleName': 'TimeZone', 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
                { 'Id': 'FirstContactMethodId', 'Type': 'Dropdown', 'DataSource': lContactMethod, 'LocaleName': 'ContactMethod', 'DataValueField': 'Id', 'DataTextField': 'ContactMethodName'},
                { 'Id': 'SecondContactMethodId', 'Type': 'Dropdown', 'DataSource': lContactMethod, 'LocaleName': 'ContactMethod', 'DataValueField': 'Id', 'DataTextField': 'ContactMethodName'},
                { 'Id': 'ThirdContactMethodId', 'Type': 'Dropdown', 'DataSource': lContactMethod, 'LocaleName': 'ContactMethod', 'DataValueField': 'Id', 'DataTextField': 'ContactMethodName'},
        ], {}, 'u' + lClass, 'Edit', localizeDataItem);

        $('#u' + lClass + 'IsDutyOfficerEdit').prop('checked', lAgent.IsDutyOfficer);
    } else {
        $('.OrganizationDetailsRemove.' + lClass).removeClass('OrganizationDetailsRemove');
    }
}

//function agentsAgentsProfileRoleDetails_Init(aRole) {
//    "use strict";
//    var lHtml = [],
//        lClass = 'OrganizationDetails' + aRole.Id.toString(),
//        lObjectList = $('.' + lClass),
//        lAgent,
//        lBuilder = new SumoPredicateBuilder();

//    if (lObjectList.length === 0) {
//        lHtml.push('<tr class="OrganizationDetails ');
//        lHtml.push(lClass);
//        lHtml.push('">');
//        lHtml.push('<td colspan="2"><h3>');
//        lHtml.push(aRole.Description);
//        lHtml.push('</h3></td>');
//        lHtml.push('</tr>');

//        $('#uRoleDetailsTable').append(lHtml.join(''));

//        populateEditView(aRole, [
//                { 'Id': 'Id', 'Type': 'Dropdown', 'DataSource': getDataItems('UserRoleTypeIds'), 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': false }
//        ], {}, 'u' + lClass, 'Edit');
//    } else {
//        $('.OrganizationDetailsRemove.' + lClass).removeClass('OrganizationDetailsRemove');
//    }
//}


function agentsDeactivateAgentCheck_OnComplete(aParams, aData) {
    "use strict";
    var lResult = aData.Id,
        lSelected = mAgentsControls.ProfileListView.selected(),
        lError = [];
    if (lResult >= 16) {
        lError.push('<div>' + localizeWrapper('cAgentZonesRemain') + '</div>');
        lResult -= 16;
    }
    if (lResult >= 8) {
        lError.push('<div>' + localizeWrapper('cAgentRiskLevelPlansRemain') + '</div>');
        lResult -= 8;
    }
    if (lResult >= 4) {
        lError.push('<div>' + localizeWrapper('cAgentProfilesRemain') + '</div>');
        lResult -= 4;
    }
    if (lResult >= 2) {
        lError.push('<div>' + localizeWrapper('cAgentNotificationsRemain') + '</div>');
        lResult -= 2;
    }
    if (lResult >= 1) {
        lError.push('<div>' + localizeWrapper('cAgentContactsRemain') + '</div>');
        lResult -= 1;
    }
    if (lError.length > 0) {
        if (lSelected === null) {
            lSelected = [];
        }

        lSelected.push(aParams.OrganizationId);
        mAgentsControls.ProfileListView.selected(lSelected);
        agentsShowInactiveZones([aParams], lError, (aData.Id >= 16 ? true : false));

    }
}

function uUserDetailsOrganizationsEdit_OnSelectChange() {
    "use strict";
    var lSelectedOrganizations = mAgentsControls.ProfileListView.selectedDataItem(),
        lSelectedIds = mAgentsControls.ProfileListView.selected(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lCheck,
        lItem,
        lKey;

    $('.OrganizationDetails').addClass('OrganizationDetailsRemove');

    for (lKey in lSelectedOrganizations) {
        if (lSelectedOrganizations.hasOwnProperty(lKey)) {
            lItem = lSelectedOrganizations[lKey];
            agentsAgentsProfileOrganizationDetails_Init(lItem);

            if (mAgentsData.UserEditItem.Id !== -1){
                if ($("#uOrganizationDetails" + lItem.Id + "FirstContactValueEdit").val() == '') {
                    $("#uOrganizationDetails" + lItem.Id + "FirstContactValueEdit").val(lCard.User.Email.toUpperCase());
                }

            } else {
                if ($("#uOrganizationDetails" + lItem.Id + "FirstContactValueEdit").val() == '') {
                    $("#uOrganizationDetails" + lItem.Id + "FirstContactValueEdit").val($("#uUserDetailsEmailEdit").val().toUpperCase());
                }

            }//end of if
        }//end of outer if
    }//end of for
    $('.AgentContactSelectFields').change()

    if (mAgentsData.UserEditItem.Id !== -1) {
        for (lKey in lCard.OrganizationIds) {
            if (lCard.OrganizationIds.hasOwnProperty(lKey)) {
                lItem = lCard.OrganizationIds[lKey];
                lItem = lCard.AgentsByOrganization[lItem];
                if (lSelectedIds !== null && lSelectedIds.indexOf(lItem.OrganizationId) === -1) {
                    lCheck = new DeactivateAgentCheck();
                    lCheck.Id = lItem.Id;
                    WriteSingle(lCheck, agentsDeactivateAgentCheck_OnComplete, null, lItem);
                    //Execute(lCheck, agentsDeactivateAgentCheck_OnComplete, null, lItem);

                }
            }
        }

    }

    if (lSelectedIds === null || (mAgentsData.UserEditItem.Id === -1 && lSelectedIds.length === 0)) {
        $('#uSaveAgentButton').hide();
    } else {
        $('#uSaveAgentButton').show();
    }

    $('.OrganizationDetailsRemove').remove();
    if (!isNullOrUndefined(mAgentsControls.Validator)) {
        mAgentsControls.Validator.scan();
    }

}


function uUserDetailsRolesEdit_OnSelectChange() {
    "use strict";
    var lSelectedRoles = mAgentsControls.ProfileRoleListView.selectedDataItem(),
        lSelectedIds = mAgentsControls.ProfileRoleListView.selected(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lCheck,
        lItem,
        lKey;

    $('.OrganizationDetails').addClass('OrganizationDetailsRemove');

    for (lKey in lSelectedRoles) {
        if (lSelectedRoles.hasOwnProperty(lKey)) {
            lItem = lSelectedRoles[lKey];
            //agentsAgentsProfileRoleDetails_Init(lItem);
        }
    }
    if (mAgentsData.UserEditItem.UserRoleValueTypeId !== -1) {
        for (lKey in lCard.Role) {
            if (lCard.Role.hasOwnProperty(lKey)) {
                lItem = lCard.Role;
            }
        }
    }

    if (lSelectedIds === null || (mAgentsData.UserEditItem.Id === -1 && lSelectedIds.length === 0)) {
        $('#uSaveAgentButton').hide();
    } else {
        $('#uSaveAgentButton').show();
    }

    $('.OrganizationDetailsRemove').remove();
    if (!isNullOrUndefined(mAgentsControls.Validator)) {
        mAgentsControls.Validator.scan();
    }
}

function handlePhoneSMSOnClick(aThis) {
    "use strict";
    var isChecked = aThis.checked;
    var value = $('#' + aThis.id.replace('SMSOptInFlag', 'Phone')).val()
    var fieldFound = false;

    $('.phoneContactDropdown').each(function () {
        var options = this.options;
        var i = 0;
        for (i = 0; i < options.length; i++) {
            if (value == options[i].text) {

                if (isChecked) {
                    fieldFound = true;
                }
                if (!isChecked && options[i].selected) {
                    fieldFound = true
                }
            }
        }

        if (!fieldFound) {
            if (isChecked) {
                this.options.add(new Option(value, value, false, false))
            }
        }
    })

    if (!isChecked) {
        if (fieldFound) {
            aThis.checked = true
            mActivityNotification.addNotification('Cannot opt out of sms if organization uses phone number.... Remove organization dependency.')
        } else {
            $('.phoneContactDropdown').each(function () {
                var options = this.options;
                var i = 0;
                for (i = 0; i < options.length; i++) {
                    if (value == options[i].text) {
                        this.options.remove(i)
                    }
                }
            })
        }
    }
}


function updatePhoneContactDropdown(aNumber, lId) {
    "use strict";
    var lOldValue = "";

    switch (lId) {
        case 'uUserDetailsPrimaryPhoneEdit':
            lOldValue = mAgentsData.UserEditItem.PrimaryPhone;
            mAgentsData.UserEditItem.PrimaryPhone = aNumber;
            break;
        case 'uUserDetailsSecondaryPhoneEdit':
            lOldValue = mAgentsData.UserEditItem.SecondaryPhone;
            mAgentsData.UserEditItem.SecondaryPhone = aNumber;
            break;
        case 'uUserDetailsThirdPhoneEdit':
            lOldValue = mAgentsData.UserEditItem.ThirdPhone;
            mAgentsData.UserEditItem.ThirdPhone = aNumber;
            break;
        case 'uUserDetailsFourthPhoneEdit':
            lOldValue = mAgentsData.UserEditItem.FourthPhone;
            mAgentsData.UserEditItem.FourthPhone = aNumber;
            break;
        default:
            break;
    }

    // update section for phone with number selected


    $('.phoneContactDropdown').each(function () {
        var options = this.options;
        var i = 0;
        for (i = 0; i < options.length; i++) {
            if (lOldValue == options[i].text) {
                this.options[i].text = aNumber;
            }
        }
    })

}

function ValidateCallbackPhoneSMSEnabled(aElement) {
    var lId = $('#' + aElement.id);
    var lSMSId = $('#' + aElement.id.replace('Phone', 'SMSOptInFlag'));
    var lDisable = false;
    if (lId.hasClass('ValidateSuccess')) {
        var lValue = lId.val();
        if (lValue.indexOf('x') !== -1 || lValue.indexOf('X') !== -1) {
            lDisable = true;
        }
    } else {
        lDisable = true;
    }

    lSMSId.prop("disabled", lDisable);

    if (!lDisable) {
        updatePhoneContactDropdown(lValue, aElement.id);
    }

    if (lSMSId.is(":checked")) {
        if (!lId.hasClass('ValidateSuccess') && !lId.hasClass('ValidateError')) {
            lId.addClass('ValidateError')
        }
    }
}

function PopulateAgentEditData(aCard) {
    "use strict";
    var lPreferences = getUserPreferences(4),
        lSMSOptions = [{ 'Id': 0, 'Name': localizeText('cAgentNotEnabled') }],
        lSMSOptInEnabled = veritracks.system.clientSetting('SMSoptinflag'),
        lPasswordPolicyEnabled = veritracks.system.clientSetting('passwordpolicyenable'),
        lSMSField = $('#smsOptInOptions'),
        lSelRoles = $('#selRoles'),
        lPreference,
        lHtml = [],
        lWidth = 0,
        lValue = 1,
        lItem,
        lKey;

    mAgentsData.Loading = true;

    function populateCultureDropdown() {
        var lCultures = getDataItems('Culture'),
            lPreferences = getUserPreferences(13),
            lCultureId = gUserDetails.CultureId,
            lOptionHtml = [],
            lItem,
            lKey;

        for (lKey in lCultures) {
            if (lCultures.hasOwnProperty(lKey)) {
                lItem = lCultures[lKey];
                lOptionHtml.push('<option value="');
                lOptionHtml.push(lItem.Id);
                lOptionHtml.push('">');
                lOptionHtml.push(lItem.Name);
                lOptionHtml.push('</option>');
            }
        }
        if (count(lPreferences) > 0) {
            lItem = lPreferences['CultureId'];
            if (!isNullOrUndefined(lItem) && lItem.Value != -1) {
                lCultureId = lItem.Value;
            }
        }
        $('#uAgentCultureSettingEdit').html(lOptionHtml.join('')).val(lCultureId);
    }

    function populateAutoDashboardDropdown() {
        var lPreferences = getUserPreferences(13),
            lAutoDasboardEnabled = veritracks.system.clientSetting('AutoDashboardRefreshEnabled'),
            lOptions = [{ 'Id': 0, 'Name': localizeText('cManual') }, { 'Id': 1, 'Name': localizeText('cAutomatic') }],
            lOptionHtml = [],
            lDashboardVal = 0,
            lItem,
            lKey;


        if (lAutoDasboardEnabled) {
            for (lKey in lOptions) {
                if (lOptions.hasOwnProperty(lKey)) {
                    lOptionHtml.push('<option value="' + lOptions[lKey].Id + '">' + lOptions[lKey].Name + '</option>');
                }
            }
            if (count(lPreferences) > 0) {
                lItem = lPreferences['AutomaticDashboardUpdate'];
                if (!isNullOrUndefined(lItem) && lItem.Value != -1) {
                    lDashboardVal = lItem.Value;
                }
            }
            $('#uAgentAutoDashboardSettingEdit').html(lOptionHtml.join('')).val(lDashboardVal);
        } else {
            $('#uAgentAutoDashboard').hide();
        }
    }

    lPreference = lPreferences['TrackType'];
    if (!isNullOrUndefined(lPreference)) {
        lValue = parseInt(lPreference.Value, 10);
    }
    lHtml.push('<option value="1">' + localizeText('cTripsVisits') + '</option>');
    lHtml.push('<option value="2">' + localizeText('cTrackpoints') + '</option>');

    $('#uTripsVisitsSettingEdit').html(lHtml.join('')).val(lValue);
    lHtml = [];

    populateCultureDropdown();
    populateAutoDashboardDropdown();
    mAgentsData.CardViewEditItem = aCard;

    mAgentsData.CurrentOrganizations = [];
    $('.OrganizationDetails').remove();
    mAgentsControls.ProfileListView = new sumo.controls.ListView('uUserDetailsOrganizationsEdit', 'uUserDetailsOrganizationsEditHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true,
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true }
    ]);

    var roles = getDataItems('UserRoleValueTypes');
    if (gUserDetails.Role == 1) {
        $('#uRegularUserPrivilegeRoles').show();
        lSelRoles.show();
        lSelRoles.empty();
        for (var i in roles) {
            if (roles.hasOwnProperty(i)) {
                if( i <= 2)
                    lSelRoles.append('<option value=' + roles[i].Id + '>'+ localizeDataItem('UserRoleValueType', roles[i].Description) + '</option>');
            }
        }
    } else {
        $('#uRegularUserPrivilegeRoles').hide();
        lSelRoles.hide();
    }

    mAgentsControls.ProfileListView.setDataSource(OrganizationSortFormatter());

    if (aCard !== null) {
        mAgentsData.UserEditItem = $.extend({}, aCard.User);
        mAgentsData.UserEditItem.__type = 'User:www.veritracks.com';
        mAgentsControls.ProfileListView.selected(aCard.OrganizationIds);
        lSelRoles.val(aCard.Role.Id);
        lSMSField.val(aCard.User.SMSOptIn);
    } else {
        mAgentsData.UserEditItem = new User();
        $('#uUserDetailsIdHolder').hide();
    }

    if (mAgentsData.UserEditItem.SMSOptIn == 1) {
        lSMSOptions.push({ 'Id': 1, 'Name': localizeWrapper('cAgentPrimaryPhone') });
    } else if (mAgentsData.UserEditItem.SMSOptIn == 2) {
        lSMSOptions.push({ 'Id': 2, 'Name': localizeWrapper('cAgentSecondaryPHone') });
    }
    // add sms select options
    lSMSField.empty();
    for (var lKey in lSMSOptions) {
        if (lSMSOptions.hasOwnProperty(lKey)) {
            lSMSField.append('<option value=' + lSMSOptions[lKey].Id + '>' + lSMSOptions[lKey].Name + '</option>');
        }
    }

    populateEditView(mAgentsData.UserEditItem, [
        { 'Id': 'SecurityQuestionId', 'Type': 'Dropdown', 'DataSource': getDataItems('SecurityQuestions'), 'LocaleName': 'SecurityQuestion', 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': true }
    ], {
        'PrimaryPhone': PhoneNumberFormatter,
        'SecondaryPhone': PhoneNumberFormatter,
        'FirstName':veritracks.system.decodeHtml,'LastName':veritracks.system.decodeHtml
    }, 'uUserDetails', 'Edit', localizeDataItem);
    mAgentsControls.Validator = new Validator('uUserDetailsTable', mRegexValidation, lSMSOptInEnabled);

    $('[name=smsOptInOptions]').val(mAgentsData.UserEditItem.SMSOptIn);

    if (aCard !== null) {
        for (lKey in aCard.AgentsByOrganization) {
            if (aCard.AgentsByOrganization.hasOwnProperty(lKey)) {
                lItem = aCard.AgentsByOrganization[lKey];
                populateEditView(lItem, [], {}, 'uAgentSpecific', 'Edit' + lKey);
            }
        }
    }

    mAgentsControls.ProfileListView.bind('selectedchanged', uUserDetailsOrganizationsEdit_OnSelectChange);
    uUserDetailsOrganizationsEdit_OnSelectChange();

    if (lPasswordPolicyEnabled) {
        $('#uUserDetailsPasswordPolicyEdit').attr('checked', true).attr("disabled", true);
    }

    var l2FARequired = veritracks.system.clientSetting('2farequired');
    var l2FAEnabled = veritracks.system.clientSetting('2faenabled');

    if (l2FAEnabled && l2FARequired) {
        $('#uUserDetailsTwoFARequiredFlagEdit').attr('checked', true).attr('disabled', true);
    }

    mAgentsData.Loading = false;
}

function uAddAgentButton_OnClick() {
    "use strict";
    $('#uEditAgentButton').hide();
    $('#uAddAgentButton').hide();

    $('#uSaveAgentButton').show();
    $('#uCancelAgentButton').show();
    $('#uUserDetailsAnswerSetFailed').hide();
    $('#uUserDetailsPasswordSetFailed').hide();
    $('.Agent2FASettings').hide();
    EnterEditMode('uUserDetailsTable');
    EnterAddMode('uUserDetailsTable');
    PopulateAgentEditData(null);
    $('#uUserDetailsTable').show();

}

function uEditAgentButton_OnClick() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem();
    $('#uEditAgentButton').hide();
    $('#uAddAgentButton').hide();

    $('#uSaveAgentButton').show();
    $('#uCancelAgentButton').show();
    $('#uUserDetailsAnswerSetFailed').hide();
    $('#uUserDetailsPasswordSetFailed').hide();

    EnterEditMode('uUserDetailsTable');
    PopulateAgentEditData(lCard);
    if (veritracks.system.clientSetting('allowtemporarypassword') == 1 && gUserDetails.UserId != lCard.UserId) {
        $("#uAgentResetPasswordHolder").show();
    }
}

function agentsProfileEdit_Leave() {
    "use strict";
    if (!isNullOrUndefined(mAgentsControls.ProfileListView)) {
        mAgentsControls.ProfileListView.dispose();
        mAgentsControls.ProfileListView = null;
    }
    $('#uRegularUserPrivilegeRoles').show();
    $('#uUserDetailsIdHolder').show();
}

function agentsUserWrite_OnRender(aSender, aParams, aData){
    "use strict";
    aSender.selected(aData);
    aSender.bind('databind', cardView_OnDataBind);
    aSender.unbind('databind', agentsUserWrite_OnRender);
}

function agentsAgentProfileUserSecurityAnswer_OnSuccess(aParams, aData) {
    "use strict";
    if (aData.Id === 0) {
        $('#uUserDetailsAnswerSetFailed').show();
    } else {
        $('#uUserDetailsAnswerSetFailed').hide();
    }
}

function agentsAgentProfileUserPassword_OnSuccess(aParams, aData) {
    "use strict";
    if (aData.Id === 0) {
        $('#uUserDetailsPasswordSetFailed').show();
    } else {
        //RefreshCacheItem(gObjectList.User.AssemblyQualifiedName);
        //RefreshCacheItem(gObjectList.DashboardReport.AssemblyQualifiedName);
        //RefreshCacheItem(gObjectList.DashboardReportColumn.AssemblyQualifiedName);
        $('#uUserDetailsPasswordSetFailed').hide();
    }
}

function updateImmediateNotifications(aAgents) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    var agentIds = getArrayByIds(aAgents);

    if (agentIds) {
        lBuilder.AddNewExpressionConditional('AgentId', agentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Notification.AssemblyQualifiedName, lBuilder.RootExpression, 0, updateNotificationContact, null);
    }
}


function updateNotificationContact(aParams, aData) {
    var lUpdateNotifications = [];

    aData.forEach(function (notification) {
        var lAgent = getDataItem(notification.AgentId, 'Agents');
        var lContactType = 0;
        switch (notification.UserContactPriority) {
            case 1:
                lContactType = lAgent.FirstContactMethodId
                break;
            case 2:
                lContactType = lAgent.SecondContactMethodId
                break;
            case 3:
                lContactType = lAgent.ThirdContactMethodId
                break;
        }

        if (lContactType == 2) return false;

        if (notification.ContactFormatId == 2) {
            notification.ContactFormatId = 1
            lUpdateNotifications.push(notification);
        }
    })

    if (lUpdateNotifications.length > 0) {
        WriteMultiple(lUpdateNotifications, null, null, null, false)
    }
}

function agentsAgentWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lQuestion = $('#uUserDetailsSecurityQuestionIdEdit').val(),
        lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val(),
        lCurrentPassword = $('#uUserDetailsCurrentPasswordEdit').val(),
        lNewPassword = $('#uUserDetailsPasswordEdit').val(),
        lUserSecurityAnswer,
        lUserPassword,
        lIsError = false,
        lItem,
        lKey;


    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            if (lItem.Id > 0) {
                setDataItem(lItem.Id, 'Agents', lItem);
            } else {
                lIsError = true;
            }
        }
    }

    updateImmediateNotifications(aData);


    if (lIsError) {
        DisplayPopup(localizeWrapper('cAgentDisableUnable'), localizeWrapper('cAgentOrganizationRemaining'), '', false);
    }

    agentsDataListConverter();
    mAgentsControls.CardView.unbind('databind', cardView_OnDataBind);
    mAgentsControls.CardView.bind('databind', agentsUserWrite_OnRender, aParams);
    window.location.hash = 'Agents.Agents.Profile.' + aParams.Id.toString();
    //mAgentsControls.CardViewFilter.filter();

    $('#uEditAgentButton').show();
    $('#uAddAgentButton').show();
    agentsProfileEdit_Leave();
    ExitEditMode('uUserDetailsTable');
}

function agentsShowInactiveZones(aAgent, aErrorHtml, aZoneError) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lActiveAgentIds = [],
        lZones = [],
        lInactiveZonesList = null,
        lColumns = [],
        lZonesHtml = [];


    if (!isNullOrUndefined(aAgent) ) {
        for (var key in aAgent) {
            if (aAgent.hasOwnProperty(key)) {
                lActiveAgentIds.push(aAgent[key].Id);
            }
        }//end of for
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('AgentId', lActiveAgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lZones = query(getDataItems("Zones"), lBuilder.RootExpression);
        var lColumns = [

       { 'id': 'Id', 'title': localizeWrapper('cId'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 50, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
       { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
       { 'id': 'Shape', 'title': localizeWrapper('cZoneShape'), 'dataField': 'Shape', 'width': 'autoData', 'minWidth': 60, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': zoneShapeFormatter },
       { 'id': 'Organization', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter }

        ];

        if (aZoneError) {
            lZonesHtml = aErrorHtml.slice(0, 1);
            if (aErrorHtml.length > 1) {
                aErrorHtml = aErrorHtml.slice(1, aErrorHtml.length);
            } else {
                aErrorHtml = [];
            }
        }
        DisplayPopup(localizeWrapper('cAgentDisableUnable'), '<h2>' + localizeWrapper('cAgentCorrectIssues') + '</h2>' + lZonesHtml.join('') + '<div id="uAgentInactiveZoneListPanel"></div><br/>' + aErrorHtml.join(''), '', false);

        if (aZoneError) {
            lInactiveZonesList = new sumo.controls.ListView('uAgentInactiveZoneListView', 'uAgentInactiveZoneListPanel', { 'keyField': 'Id', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': false }, lColumns);
            lInactiveZonesList.setDataSource(lZones);
        }

    }//end of if

}

function agentsUserWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lOrganizations = getDataItems('Organizations'),
        lAgents = getDataItems('Agents'),
        lPermissions = getDataItems('Permissions'),
        lAutoDasboardEnabled = veritracks.system.clientSetting('autodashboardrefreshenabled'),
        lPermissionWrite = [],
        lAgentWrite = [],
        lPreferencesWrite = [],
        lAssignedIds,
        lOrganization,
        lAgentQuery,
        lOldUser = [],
        lPreference,
        lPermission,
        lValue,
        lAgent,
        lItem,
        lKey,
        lUserRole,
        lRole;
    //RefreshCacheItem(gObjectList.User.AssemblyQualifiedName);
    if (aData.Id > 0) {
        lRole = getUserRoleById(aData.Id);
        if (isNullOrUndefined(lRole)) {
            lRole = new UserRole();
        }
        lUserRole = $.extend({}, lRole);
        lUserRole.Id = lRole.Id;
        lUserRole.UserId = aData.Id;
        lUserRole.Description = ($('#selRoles option:selected').text() == "" ? lUserRole.Description : $('#selRoles option:selected').text());
        lUserRole.UserRoleValueTypeId = (Number($('#selRoles').val()) == 0 ? lUserRole.UserRoleValueTypeId : Number($('#selRoles').val()));
        lUserRole.TransactionId = moment().format("YYYYMMDDHHmmss");

        WriteSingle(lUserRole, roleWrite_OnSuccess, roleWrite_OnFailure, lUserRole, true);
        setDataItem(aData.Id, 'Users', aData);
        $('#uUserDetailsUserNameEditError').hide();

        lBuilder.AddNewExpressionConditional('UserId', aData.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAgents = query(lAgents, lBuilder.RootExpression);
        lBuilder.Clear();

        for (lKey in lAgents) {
            if (lAgents.hasOwnProperty(lKey)) {
                lAgent = lAgents[lKey];
                lAgent.IsActive = false;
                lAgentWrite.push(lAgent);
            }
        }


        for (lKey in lPermissions) {
            if (lPermissions.hasOwnProperty(lKey)) {
                lItem = lPermissions[lKey];
                lPermission = new UserPermission();
                lPermission.Id = lItem.Id;
                lPermission.PermissionId = lItem.Id;
                lPermission.UserId = aData.Id;
                lPermission.LoginUserId = gUserDetails.UserId;
                lPermission.Value = 0;
                lPermissionWrite[lPermission.Id] = lPermission;
            }
        }
        if (aParams === -1) {
            //RefreshCacheItem(gObjectList.User.AssemblyQualifiedName);
            RefreshCacheItem(gObjectList.UserClientSchema.AssemblyQualifiedName);
            RefreshCacheItem(gObjectList.DashboardReport.AssemblyQualifiedName);
            RefreshCacheItem(gObjectList.DashboardReportColumn.AssemblyQualifiedName);
        }
        // changing to anything that is not a regular agent should have new permissions written.

        if (lRole.UserRoleValueTypeId != lUserRole.UserRoleValueTypeId) {
            if (lUserRole.UserRoleValueTypeId == 2) {
                lPermissionWrite = uEnhancedCrimeAnalystDefaultPermissions(lPermissionWrite);
                //uDefaultRolesPermissions(lPermissionWrite, lUserRole.UserRoleValueTypeId);
            }
            lPermissionWrite = CleanPermissions(lPermissionWrite);
            WriteMultiple(lPermissionWrite, null, null, null, true, true);

        }

        lAssignedIds = mAgentsControls.ProfileListView.selected();
        if (!isNullOrUndefined(lAssignedIds)) {
            lBuilder.AddNewExpressionConditional('Id', lAssignedIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lOrganizations = query(lOrganizations, lBuilder.RootExpression);
            lBuilder.Clear();

            for (lKey in lOrganizations) {
                if (lOrganizations.hasOwnProperty(lKey)) {
                    lOrganization = lOrganizations[lKey];

                    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lAgentQuery = query(lAgents, lBuilder.RootExpression);
                    lBuilder.Clear();

                    if (lAgentQuery.length > 0) {
                        lAgent = lAgentQuery[lAgentQuery.length - 1];
                    } else {
                        lAgent = new Agent();
                    }

                    lAgent.IsActive = true;
                    lAgent.FirstName = aData.FirstName;
                    lAgent.FullName = aData.FullName;
                    lAgent.LastName = aData.LastName;
                    lAgent.TransactionId = moment().format("YYYYMMDDHHmmss");
                    if (lAgent.Id === -1) {
                        lAgent.UserId = aData.Id;
                        lAgent.OrganizationId = lOrganization.Id;
                        lAgentWrite.push(lAgent);
                    }
                    populateFromEditView(lAgent, 'uOrganizationDetails' + lAgent.OrganizationId.toString(), 'Edit');
                    lAgent.IsDutyOfficer = $('#uOrganizationDetails' + lAgent.OrganizationId.toString() + 'IsDutyOfficerEdit').is(':checked');
                    if (lAgent.DutyOfficerId === null) {
                        lAgent.DutyOfficerId = -1;
                    }
                    lAgent.IsSupervisor = (lAgent.SupervisorTypeId !== '-1');
                }
            }
        }

        if (lAgentWrite.length > 0) {
            WriteMultiple(lAgentWrite, agentsAgentWrite_OnSuccess, Sad, aData, true);
        } else {
            agentsAgentWrite_OnSuccess(aData, []);
        }
    } else {
        $('#uSaveAgentButton').show();
        $('#uCancelAgentButton').show();
        $('#uUserDetailsUserNameEditError').show();
    }

    setLoadingBarStatus('uAgentsTrackPointLoadingBar', 'uUserDetailsTable', false);
}

function CleanPermissions(aPermissions) {
    var lPermissions = [];

    for (var lKey in aPermissions) {
        if (aPermissions.hasOwnProperty(lKey)) {
            lPermissions.push(aPermissions[lKey]);
        }
    }

    return lPermissions;
}
//function uDefaultRolesPermissions(aPermissions, aRole) {
//    "use strict";
//    var lBuilder = new SumoPredicateBuilder(),
//        lUserPermissions = aPermissions,
//        lRolePermissions,
//        lKey;

//    lBuilder.AddNewExpressionConditional('UserRoleValueTypeId', aRole, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
//    lRolePermissions = query(getDataItems('RolePermissionMemberships'), lBuilder.RootExpression);

//    for (lKey in lRolePermissions) {
//        if (lRolePermissions.hasOwnProperty(lKey)) {
//            lUserPermissions[lRolePermissions[lKey].PermissionId - 1].Value = lRolePermissions[lKey].Value;
//        }
//    }
//    WriteMultiple(lUserPermissions, Permissions_OnSuccess, null, null, true, true);

//    function Permissions_OnSuccess(aParams, aData) {
//        var lData = aData;
//    }
//}

function uEnhancedCrimeAnalystDefaultPermissions(aPermissions) {
    "use strict";
    var lPermissions,
        lBuilder = new SumoPredicateBuilder(),
        lUserPermissions = aPermissions,
        lItem,
        lKey,
        i = 0;

    // permission types allowed: 1 = Enrollees, 4 = Analysis, 9 = Cached Data
    lBuilder.AddNewExpressionConditional('PermissionType', [1, 4, 9], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lPermissions = query(getDataItems('Permissions'), lBuilder.RootExpression);
    // partial access to enrollees
    // partial accessto analysis
    for (lKey in lPermissions) {
        if (lPermissions.hasOwnProperty(lKey)) {
            lItem = lPermissions[lKey];

            if (lItem.IsWritable) {
                if (lItem.PermissionType == 1) {
                    lUserPermissions[lItem.Id].Value = 1;
                } else {
                    lUserPermissions[lItem.Id].Value = 2;
                }
            }
            else {
                lUserPermissions[lItem.Id].Value = 1;
            }
        }
    }

    return lUserPermissions;
}

function uSaveAgentButton_OnClick() {
    "use strict";
    var lQuestion = $('#uUserDetailsSecurityQuestionIdEdit').val(),
        lSecurityAnswer = $('#uUserDetailsSecurityAnswerEdit').val();

    function onShow() {
        var TwoFAPrevious = mAgentsData.UserEditItem.TwoFARequiredFlag;

        populateFromEditView(mAgentsData.UserEditItem, 'uUserDetails', 'Edit');        
        //Vulnerability 3257
        mAgentsData.UserEditItem.LastName = veritracks.system.encodeHtml(mAgentsData.UserEditItem.LastName);
        mAgentsData.UserEditItem.FirstName = veritracks.system.encodeHtml(mAgentsData.UserEditItem.FirstName);
        mAgentsData.UserEditItem.FullName = mAgentsData.UserEditItem.FirstName + ' ' + mAgentsData.UserEditItem.LastName;
        if (mAgentsData.UserEditItem.Id === -1) {
            mAgentsData.UserEditItem.DataAccessGroupId = gUserDetails.CurrentDataAccessGroupId;
        }
        if (mAgentsData.TargetIsMe && lQuestion !== '-1' && lSecurityAnswer !== '') {
            mAgentsData.UserEditItem.SecurityQuestionId = lQuestion;
        }

        mAgentsData.UserEditItem.UserRoleValueTypeId = (Number($('#selRoles').val()) == 0 ? mAgentsData.UserEditItem.UserRoleValueTypeId : Number($('#selRoles').val()));
        mAgentsData.UserEditItem.Description = ($('#selRoles option:selected').text() == "" ? mAgentsData.UserEditItem.Description : $('#selRoles option:selected').text());

        if (mAgentsData.UserEditItem.SecurityQuestionId == -1 && mAgentsData.UserEditItem.Id != -1) {
            CheckUserStatus();
        } else {
            mAgentsData.UserEditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            SaveSMSDeliveryMethod(function (aParams, aData) {
                if (veritracks.system.clientSetting('passwordpolicyenable')) {
                    mAgentsData.UserEditItem.PasswordPolicy = 1
                }
                WriteSingle(mAgentsData.UserEditItem, agentsUserWrite_OnSuccess, null, mAgentsData.UserEditItem.Id, true);
            });
        }

        if (TwoFAPrevious == 1 && mAgentsData.UserEditItem.TwoFARequiredFlag == 0) {
            save2FA(mAgentsData.UserEditItem.Id, null)
        }
    }

    mAgentsControls.Validator.setValidatorCallback(false);
    if (mAgentsControls.Validator.IsValid()) {
        $('#uSaveAgentButton').hide();
        $('#uCancelAgentButton').hide();
        setLoadingBarStatus('uAgentsTrackPointLoadingBar', 'uUserDetailsTable', true, onShow);
    }
    mAgentsControls.Validator.setValidatorCallback(true);
}
function onChangeAgentRole(){
    //gets fired when selecting agent role.
    
    DisplayModal(localizeWrapper('cConfirmationTitle'),"<div style='margin-bottom:10px;'>"+localizeWrapper("cAgentRolePermissionsConfirmation")+"</div>", null, null);
}
function CheckUserStatus() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', mAgentsData.UserEditItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.User.AssemblyQualifiedName, lBuilder.RootExpression, 0, UpdateNewUser, null);

    function UpdateNewUser(aParams, aData) {
        if (aData) {
            var lUser = aData[0];
            mAgentsData.UserEditItem.SecurityQuestionId = lUser.SecurityQuestionId;
            mAgentsData.UserEditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            SaveSMSDeliveryMethod(function (aParams, aData) {
                if (veritracks.system.clientSetting('passwordpolicyenable')) {
                    mAgentsData.UserEditItem.PasswordPolicy = 1
                }
                WriteSingle(mAgentsData.UserEditItem, agentsUserWrite_OnSuccess, null, mAgentsData.UserEditItem.Id, true);
            });
        }
    }
}

function SaveSMSDeliveryMethod(aCallback) {
    var lSaveAllowed = false;
    var lOldUser = $.extend({}, getDataItem(mAgentsData.UserEditItem.Id, 'Users'));
    var lSMSOptInEnabled = veritracks.system.clientSetting('SMSoptinflag');


    if (lSMSOptInEnabled) {
        mAgentsData.UserEditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteUserSMSDeliveryMethod(mAgentsData.UserEditItem, function (aParams, aData) {
            aCallback(aParams, aData);
            smsDelivery_OnSuccess(aParams, aData);
        }, failure, null);
    } else {
        aCallback();
    }

    return lSaveAllowed;
}

function smsDelivery_OnSuccess(aParams, aData) {
    if (aData == "") {

    } else {
        mActivityNotification.addNotification(localizeWrapper('cAgentSMSMessage' + aData));
    }
}

function roleWrite_OnSuccess(aParams, aData) {
    var lUserRoles = getDataItems('UserRoles');

    lUserRoles[aData.Id] = aData;
}
function roleWrite_OnFailure(aData) {
    var d = aData;
}

function uCancelAgentButton_OnClick() {
    "use strict";
    var lIsEmpty,
        lClass = 'Agents';

    $('#uEditAgentButton').show();
    $('#uAddAgentButton').show();

    $('#uSaveAgentButton').hide();
    $('#uCancelAgentButton').hide();
    $('#uUserDetailsUserNameEditError').hide();
    $("#uAgentResetPasswordHolder").hide();
    $('#uUserDetailsIdHolder').show();
    CloseModal();
    agentsProfileEdit_Leave();
    ExitEditMode('uUserDetailsTable');
    ExitAddMode('uUserDetailsTable');
    lIsEmpty = (mAgentsData.Dirty.length === 0);
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyFilterState(lClass, lIsEmpty);
    $("#uAgentResetPasswordError").hide();
    $("#uUserDetailsEmailEditError").hide();
    if ($("#uAgentUserPasswordReset").prop('checked') == true) {
        $("#uAgentUserPasswordReset").click();
    }
    uResetAgentPasswordButton_OnClick(true);

    var lCard = mAgentsControls.CardView.selectedDataItem();

    var l2faEnabled = veritracks.system.clientSetting('2faenabled')

    $('.Agent2FASettings').hide()

    if (l2faEnabled) {
        if (lCard) {
            var lUser = getDataItem(lCard.UserId, 'Users');
            if (CheckUserHasPermission(251)) {
                if (lUser.AccountStatus == "NEW" || !lUser.AccountStatus) {
                    $('.Agent2FASettings').hide()
                } else {
                    $('.Agent2FASettings').show()
                }
            }
        }
    }
}

//---------
// MY ZONES
//---------

function uMyZonesListView_OnSelectChange(aSender, aSelectedIndexList, aData) {
    "use strict";
    var lSelectedIndexList = mAgentsControls.MyZonesListView.selected(),
        lDataSourceLength = ObjectLength(mAgentsControls.MyZonesListView.getDataSource());
    if (!isNullOrUndefined(lSelectedIndexList) && lSelectedIndexList.length > 0) {
        $('#uMoveZonesButton').show();
    } else {
        $('#uMoveZonesButton').hide();
    }

    if (lDataSourceLength > 0) {
        if (ObjectLength(lSelectedIndexList) == lDataSourceLength) {
            $('#uSelectAllZonesButton').hide();
            $('#uUnSelectAllZonesButton').show();
        }
        else {
            $('#uSelectAllZonesButton').show();
            $('#uUnSelectAllZonesButton').hide();
        }
    }
    else {
        $('#uSelectAllZonesButton').hide();
        $('#uUnSelectAllZonesButton').hide();
    }

}

//---------
// Caseload
//---------
function uCurrentCaseloadListView_OnSelectChange(aSender, aSelectedIndexList, aData) {
    "use strict";
    var lSelectedIndexList = mAgentsControls.CurrentCaseloadListView.selected(),
        lDataSourceLength = ObjectLength(mAgentsControls.CurrentCaseloadListView.getDataSource());
    if (!isNullOrUndefined(lSelectedIndexList) && lSelectedIndexList.length > 0) {
        $('#uMoveEnrolleeButton').show();
    } else {
        $('#uMoveEnrolleeButton').hide();
    }

    if (lDataSourceLength > 0) {
        if (ObjectLength(lSelectedIndexList) == lDataSourceLength) {
            $('#uSelectAllEnrolleeButton').hide();
            $('#uUnSelectAllEnrolleeButton').show();
        }
        else {
            $('#uSelectAllEnrolleeButton').show();
            $('#uUnSelectAllEnrolleeButton').hide();
        }
    }
    else {
        $('#uSelectAllEnrolleeButton').hide();
        $('#uUnSelectAllEnrolleeButton').hide();
    }

}

function uCurrentCaseloadAdditionalListView_OnSelectChange(aSender, aSelectedIndexList, aData) {
    "use strict";
    var lSelectedIndexList = mAgentsControls.CurrentCaseloadAdditionalListView.selected();
    if (!isNullOrUndefined(lSelectedIndexList) && lSelectedIndexList.length > 0) {
        $('#uRemoveAdditionalEnrolleeButton').show();
    } else {
        $('#uRemoveAdditionalEnrolleeButton').hide();
    }
}

function agentsAgentsCaseloadAdditionalEnrollees_Init(aEnrolleeList) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lEnrollees = getDataItems('Enrollees'),
        lAdditionalEnrolleeList = {},
        lEnrolleeList = [],
        lAdditionalEnrollees,
        lEnrollee,
        lItem,
        lKey;
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAdditionalEnrollees = query(aEnrolleeList, lBuilder.RootExpression);

    for (lKey in lAdditionalEnrollees) {
        if (lAdditionalEnrollees.hasOwnProperty(lKey)) {
            lItem = lAdditionalEnrollees[lKey];
            lAdditionalEnrolleeList[lItem.EnrolleeId] = lItem;
            lEnrollee = lEnrollees[lItem.EnrolleeId];
            if (!isNullOrUndefined(lEnrollee)) {
                lEnrolleeList.push(lEnrollee);
            }
        }
    }
    mAgentsData.AdditionalEnrollees = query(lAdditionalEnrolleeList, lBuilder.RootExpression);
    mAgentsControls.CurrentCaseloadAdditionalListView.setDataSource(lEnrolleeList);
    uCurrentCaseloadAdditionalListView_OnSelectChange();
}

function agentsAgentsCaseloadAdditionalEnrollees_OnComplete(aParams, aData) {
    "use strict";
    agentsAgentsCaseloadAdditionalEnrollees_Init(aData);
}

function agentsAgentsCaseload_Populate() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder();

    mAgentsData.ArchivedEnrollees = null;
    if (!isNullOrUndefined(lCard) && lCard.AgentIds.length > 0) {
        lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lCard.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ArchiveFlag', 'Y', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Enrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsCaseloadArchivedEnrollees_OnComplete, null, {}, null, 0);
    }

    function agentsAgentsCaseloadArchivedEnrollees_OnComplete(aParams, aData) {
        if (ObjectLength(aData) == 0) {
        } else {
            FixDates(aData);
            mAgentsData.ArchivedEnrollees = aData;
        }

        if (!isNullOrUndefined(mAgentsControls.CurrentCaseloadListView)) {
            if (!isNullOrUndefined(lCard)) {
                mAgentsControls.CurrentCaseloadListViewFilter.filter();
                mAgentsControls.CurrentCaseloadAdditionalListView.setDataSource([]);

                mAgentsData.AdditionalEnrollees = [];
                lBuilder.Clear();
                if (lCard.AgentIds.length > 0) {
                    //lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('Id', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    ReadMultiple(gObjectList.AgentAdditionalEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsCaseloadAdditionalEnrollees_OnComplete, null, {}, null, 0);
                }
            }
        }
    }
}

function agentsAgentsZones_Populate() {
    if (isNullOrUndefined(mAgentsControls.MyZonesListView)) return

    var lBuilder = new SumoPredicateBuilder();
    var lCard = mAgentsControls.CardView.selectedDataItem();

    mAgentsControls.MyZonesListView.setDataSource([]);


    lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('EnrolleeCount', 0, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.Zone.AssemblyQualifiedName, lBuilder.RootExpression, 0, function (aParams, aData) {
        var lZones = aData;

        mAgentsData.MyZones = lZones;

        mAgentsControls.MyZonesListViewFilter.filter();

    }, null, {}, null, 0);
}
function riskLevelsFilter_DataListConverter() {
    "use strict";
    var lRiskLevels = RiskLevelFormatter(),
        lRiskLevel,
        lItems = [],
        lKey;


    for (lKey in lRiskLevels) {
        if (lRiskLevels.hasOwnProperty(lKey)) {
            lRiskLevel = lRiskLevels[lKey];
            lItems[lRiskLevel.Id] = lRiskLevel;
        }
    }
    return lItems;
}
function AgentsCaseLoad_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lEnrollees,
        lNewSelected = [],
        lBuilder,
        lSort,
        lKey;

    if (!isNullOrUndefined(mAgentsControls.CurrentCaseloadListView)) {
        lBuilder = new SumoPredicateBuilder();
        lSort = new SortExpression();
        lEnrollees = getDataItems('Enrollees');
        if (!isNullOrUndefined(lCard)) {
            lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lEnrollees = query(lEnrollees, lBuilder.RootExpression);
            if (!isNullOrUndefined(mAgentsData.ArchivedEnrollees)) {
                lEnrollees = mergeObject(lEnrollees, mAgentsData.ArchivedEnrollees);
            }
            lSort.addAscendingColumn('FullName');
            lEnrollees = lSort.sort(lEnrollees);
            lEnrollees = query(lEnrollees, aExpression);
            mAgentsControls.CurrentCaseloadListView.setDataSource(lEnrollees);

            //for (lKey in lEnrollees) {
            //    if (lEnrollees.hasOwnProperty(lKey)) {
            //        lNewSelected.push(lEnrollees[lKey].Id);
            //    }
            //}
            // mAgentsControls.CurrentCaseloadListView.selected(lNewSelected);
            if (ObjectLength(lEnrollees) > 0) {
                $('#uSelectAllEnrolleeButton').show();
                $('#uUnSelectAllEnrolleeButton').hide();
            }
            else {
                $('#uSelectAllEnrolleeButton').hide();
                $('#uUnSelectAllEnrolleeButton').hide();
            }
        }
    }
}


function agentsCaseloadFilter_Init() {
    var lParams,
    lFilterList = [],
    lRiskLevels = riskLevelsFilter_DataListConverter(),
    lUserPreferences = getUserPreferences(15);


    lParams = {
        'Title': localizeWrapper('cAgentFindEnrolleesCaseload'),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': AgentsCaseLoad_OnFilter,
        'Columns': [
            { 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
            { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' },
            { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'RiskLevelId', 'Title': localizeWrapper('cEnrolleeRiskLevel'), 'Type': 'Dropdown', 'DataField': 'RiskLevelId', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
            { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': 'Yes' }, { 'Value': false, 'Text': 'No' }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': null, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
            { 'Id': 'ArchiveFlag', 'Title': localizeWrapper('cEnrolleeArchived'), 'Type': 'Dropdown', 'DataField': 'ArchiveFlag', 'DataSource': [{ 'Value': 'Y', 'Text': 'Yes' }, { 'Value': 'N', 'Text': 'No' }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': 'Both', 'ComparisonType': 'String', 'InsertBlank': true, 'BlankText': localizeText('cBoth') }

        ],
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 15
    }

    mAgentsControls.CurrentCaseloadListViewFilter = gFilterFactory.createControl('uSelectedEnrolleeFilter', 'uSelectedEnrolleeFilterHolder', lParams);
}

function agentsAgentsCaseLoad_Init() {
    "use strict";

    agentsCaseloadFilter_Init();
    mAgentsControls.CurrentCaseloadListView = new sumo.controls.ListView('uCurrentCaseloadListView', 'uCurrentCaseloadListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
        { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string','sortable': false, 'canResize': true },
        { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'IsAssigned', 'title': localizeWrapper('cEnrolleeIsAssigned'), 'dataField': 'IsAssigned', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'formatMethod': EnrolleeAssignedFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'RiskLevel', 'title': localizeWrapper('cEnrolleeRiskLevel'), 'dataField': 'RiskLevelId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': EnrolleeRiskLevelFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'ArchiveFlag', 'title': localizeWrapper('cEnrolleeArchived'), 'dataField': 'ArchiveFlag', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': EnrolleeArchiveFlagFormatter, 'sortable': false, 'canResize': true }

    ]);
    mAgentsControls.CurrentCaseloadListView.bind('selectedchanged', veritracks.security.controller.extendSession);
    mAgentsControls.CurrentCaseloadListView.bind('selectedchanged', uCurrentCaseloadListView_OnSelectChange);

    mAgentsControls.CurrentCaseloadAdditionalListView = new sumo.controls.ListView('uCurrentCaseloadAdditionalListView', 'uCurrentCaseloadAdditionalListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true
    }, [
   { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
         { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'sortable': false, 'canResize': true },
        { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'IsAssigned', 'title': localizeWrapper('cEnrolleeIsAssigned'), 'dataField': 'IsAssigned', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'formatMethod': EnrolleeAssignedFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'RiskLevel', 'title': localizeWrapper('cEnrolleeRiskLevel'), 'dataField': 'RiskLevelId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': EnrolleeRiskLevelFormatter, 'sortable': false, 'canResize': true }
    ]);
    mAgentsControls.CurrentCaseloadAdditionalListView.bind('selectedchanged', veritracks.security.controller.extendSession);
    mAgentsControls.CurrentCaseloadAdditionalListView.bind('selectedchanged', uCurrentCaseloadAdditionalListView_OnSelectChange);

    agentsAgentsCaseload_Populate();
}

function AgentsMyZones_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lZones,
        lNewSelected = [],
        lBuilder,
        lSort,
        lKey;

    if (!isNullOrUndefined(mAgentsControls.MyZonesListView)) {
        lBuilder = new SumoPredicateBuilder();
        lSort = new SortExpression();
        if (!isNullOrUndefined(lCard)) {
            lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('IsActive',true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EnrolleeCount', 0, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

            lZones = query(mAgentsData.MyZones, lBuilder.RootExpression);
            lSort.addAscendingColumn('Name');
            lZones = lSort.sort(lZones);
            lZones = query(lZones, aExpression);
            mAgentsControls.MyZonesListView.setDataSource(lZones);

            if (ObjectLength(lZones) > 0) {
                $('#uSelectAllZonesButton').show();
                $('#uUnSelectAllZonesButton').hide();
            }
            else {
                $('#uSelectAllZonesButton').hide();
                $('#uUnSelectAllZonesButton').hide();
            }
        }
    }
}

function agentsMyZonesFilter_Init() {
    var lParams,
    lFilterList = [],
    lRiskLevels = riskLevelsFilter_DataListConverter(),
    lUserPreferences = getUserPreferences(15);


    lParams = {
        'Title': localizeWrapper('cAgentFindMyZones'),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': AgentsMyZones_OnFilter,
        'Columns': [
            { 'Id': 'Name', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'Name' },
            { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'Type', 'Title': localizeWrapper('cZoneType'), 'Type': 'Dropdown', 'DataField': 'Type', 'DataSource': getDataItems('ZoneType'), 'LocaleName': 'ZoneType', 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'DefaultValue': '', 'BlankText': localizeText('cAll') },
                { 'Id': 'Shape', 'Title': localizeWrapper('cZoneShape'), 'Type': 'Dropdown', 'DataField': 'Shape', 'DataSource': getDataItems('ZoneShape'), 'LocaleName': 'ZoneShape', 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'BlankText': localizeText('cAll'), 'DefaultValue': '' },
                { 'Id': 'Scope', 'Title': localizeWrapper('cZoneScope'), 'Type': 'Dropdown', 'DataField': 'Scope', 'DataSource': [{ 'Id': 1, 'Description': localizeText('cZoneScopeRegular') }, { 'Id': 3, 'Description': localizeText('cZoneScopeGlobal') }], 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'DefaultValue': '', 'BlankText': localizeText('cAll') }
        ],
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 15
    }

    mAgentsControls.MyZonesListViewFilter = gFilterFactory.createControl('uSelectedZoneFilter', 'uSelectedZoneFilterHolder', lParams);
}

function agentsAgentsZones_Init() {
    "use strict";

    agentsMyZonesFilter_Init();
    mAgentsControls.MyZonesListView = new sumo.controls.ListView('uMyZonesListView', 'uMyZonesListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
        { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'sortable': false, 'canResize': true },
        { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Scope', 'title': localizeWrapper('cZoneScope'), 'dataField': 'Scope', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'formatMethod': zoneScopeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Shape', 'title': localizeWrapper('cZoneShape'), 'dataField': 'Shape', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': zoneShapeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Type', 'title': localizeWrapper('cZoneType'), 'dataField': 'Type', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': zoneTypeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'IsActive', 'title': localizeWrapper('cEnrolleeActive'), 'dataField': 'IsActive', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': booleanLongFormatter, 'sortable': false, 'canResize': true }
    ]);

    mAgentsControls.MyZonesListView.bind('selectedchanged', uMyZonesListView_OnSelectChange);

    mAgentsData.MyZones = [];
    agentsAgentsZones_Populate();
}

function uAgentsMoveOrganizationIdEdit_OnChange(aSelect) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lAgents = getDataItems('Agents'),
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder();

    lSort.addAscendingColumn('FullName');
    lAgents = lSort.sort(lAgents);
    lBuilder.AddNewExpressionConditional('OrganizationId', $(aSelect).val(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAgents = query(lAgents, lBuilder.RootExpression);

    populateEditView({ 'AgentId': -1 }, [{ 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': lAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName', 'isNullableKey': false }], {}, 'uAgentsMove', 'Edit');
}

function uSelectAllEnrolleeButton_OnClick() {
    "use strict";
    var lEnrolleeList = mAgentsControls.CurrentCaseloadListView.getDataSource(),
        lSelectedList = [],
        lKey;

    for (lKey in lEnrolleeList) {
        if (lEnrolleeList.hasOwnProperty(lKey)) {
            lSelectedList.push(lEnrolleeList[lKey].Id);
        }
    }

    mAgentsControls.CurrentCaseloadListView.selected(lSelectedList);
}

function uUnSelectAllEnrolleeButton_OnClick() {
    mAgentsControls.CurrentCaseloadListView.selected([]);
}

function uSelectAllZonesButton_OnClick() {
    "use strict";
    mAgentsControls.MyZonesListView.selectAllList();
}

function uUnSelectAllZonesButton_OnClick() {
    mAgentsControls.MyZonesListView.selected([]);
}

// Move My ZONES

function agentsAgentsMyZonesMove_OnClick() {
    var lSelectedZones = mAgentsControls.MyZonesListView.selectedDataItem(),
        lOrganizationId = $('#uAgentsMoveOrganizationIdEdit').val(),
        lAgentId = $('#uAgentsMoveAgentIdEdit').val(),
        lAgent = getDataItem(lAgentId, "Agents");


    var lZonesToMove = lSelectedZones.map(function (zone) {
        zone.AgentId = lAgentId;
        zone.OrganizationId = lOrganizationId;
        return zone;
    })

    if (lZonesToMove.length > 0) {

        mActivityNotification.addNotification('Moving Zones.....')
        $('#uPopupContainer .SaveButton').hide();        
        UpdateZones(lZonesToMove, function (a, b) {
            b.forEach(function (zone) {
                setDataItem(zone.Id, 'Zones', zone);
            })
            mAgentsControls.MyZonesListViewFilter.filter();
            mActivityNotification.addNotification('Zones moved successfully....')
            ClosePopup();
        }, function (a, b) {
            $('#uPopupContainer .SaveButton').show();
            mActivityNotification.addNotification('Zones move failed....')

        }, null, true)
    } else {
        $('#uPopupContainer .SaveButton').show();

        mActivityNotification.addNotification('No Zones selected to move.....')
    }


}

function uMoveZonesButton_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        lHtml = [],
        lOrganizations = getDataItems('Organizations'),
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder();

    lOrganizations = query(lOrganizations, lBuilder.RootExpression);
    lSort.addAscendingColumn('Name');
    lOrganizations = lSort.sort(lOrganizations);

    lHtml.push('<div id="uAgentsMovePanel">');
    lHtml.push('<h3>' + localizeWrapper('cEnrolleeOrganization') + '</h3>');
    lHtml.push('<select id="uAgentsMoveOrganizationIdEdit" style="margin: 5px 0;" onchange="uAgentsMoveOrganizationIdEdit_OnChange(this)"></select>');
    lHtml.push('<br />');
    lHtml.push('<h3>' + localizeWrapper('cAgent') + '</h3>');
    lHtml.push('<select id="uAgentsMoveAgentIdEdit" style="margin: 5px 0;"></select>');
    lHtml.push('</div>');

    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsMyZonesMove_OnClick()')).appendTo(lButtonCommandBar);

    DisplayPopup(localizeWrapper('cAgentMoveMyZones'), lHtml.join(''), lButtonCommandBar);
    populateEditView({ 'OrganizationId': -1 }, [{ 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }], {}, 'uAgentsMove', 'Edit');
    $('#uAgentsMoveOrganizationIdEdit').change();
}

function uMoveEnrolleeButton_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        lHtml = [],
        lOrganizations = getDataItems('Organizations'),
        lSort = new SortExpression(),
        lBuilder = new SumoPredicateBuilder();

    lOrganizations = query(lOrganizations, lBuilder.RootExpression);
    lSort.addAscendingColumn('Name');
    lOrganizations = lSort.sort(lOrganizations);



    mAgentsData.MovingCaseload = false;
    lHtml.push('<div id="uAgentsMovePanel">');
    lHtml.push('<h3>' + localizeWrapper('cEnrolleeOrganization') + '</h3>');
    lHtml.push('<select id="uAgentsMoveOrganizationIdEdit" style="margin: 5px 0;" onchange="uAgentsMoveOrganizationIdEdit_OnChange(this)"></select>');
    lHtml.push('<br />');
    lHtml.push('<h3>' + localizeWrapper('cAgent') + '</h3>');
    lHtml.push('<select id="uAgentsMoveAgentIdEdit" style="margin: 5px 0;"></select>');
    lHtml.push('</div>');

    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsCaseloadMove_OnClick()')).appendTo(lButtonCommandBar);
    //$(GenerateButton('Cancel', 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentMoveEnrollees'), lHtml.join(''), lButtonCommandBar);
    populateEditView({ 'OrganizationId': -1 }, [{ 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }], {}, 'uAgentsMove', 'Edit');
    $('#uAgentsMoveOrganizationIdEdit').change();
}

function agentsAgentsCaseloadAddAdditional_OnClick() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lSelectedIds = mAgentsControls.CurrentCaseloadAddAdditionalListView.selected(),
        lEnrollees = getDataItems('Enrollees'),
        lAdditionalEnrollee = new AgentAdditionalEnrollee(),
        lAdditionalEnrolleeWrite = [],
        lMyAgentIds = {},
        lAgent,
        lItem,
        lKey;

    function onSuccess(aParams, aData) {
        var lAdditionalEnrollees = mAgentsData.AdditionalEnrollees;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lAdditionalEnrollees[lItem.EnrolleeId] = lItem;
            }
        }
        agentsAgentsCaseloadAdditionalEnrollees_Init(lAdditionalEnrollees);
        ClosePopup();
        setLoadingBarStatus('uAdditionalEnrolleesHolderLoadingBar', 'uAdditionalEnrolleesHolderContent', false, null);
        mActivityNotification.addNotification(localizeWrapper('cAgentEnrolleeAdditionalSuccess'));
    }

    if (!isNullOrUndefined(lCard) && !isNullOrUndefined(lSelectedIds) && lSelectedIds.length > 0) {
        setLoadingBarStatus('uAdditionalEnrolleesHolderLoadingBar', 'uAdditionalEnrolleesHolderContent', true, null);
        $('#uPopupContainer .Button').hide();

        for (lKey in lSelectedIds) {
            if (lSelectedIds.hasOwnProperty(lKey)) {
                lItem = lSelectedIds[lKey];
                lItem = lEnrollees[lItem];
                lAgent = lCard.AgentsByOrganization[lItem.OrganizationId];
                if (!isNullOrUndefined(lAgent)) {
                    lAdditionalEnrollee = new AgentAdditionalEnrollee();
                    lAdditionalEnrollee.Id = lAgent.Id;
                    lAdditionalEnrollee.EnrolleeId = lItem.Id;
                    lAdditionalEnrollee.TransactionId = moment().format("YYYYMMDDHHmmss");
                    lAdditionalEnrollee.UserId = gUserDetails.UserId;
                    lAdditionalEnrolleeWrite.push(lAdditionalEnrollee);
                }
            }
        }
    }

    if (lAdditionalEnrolleeWrite.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAgentEnrolleeAdditionalAdding'));
        WriteMultiple(lAdditionalEnrolleeWrite, onSuccess, null, {}, true);
    } else {
        ClosePopup();
    }
}

function uAdditionalEnrolleesAgentIdFilter_OnChange(aSelect) {
    "use strict";
    var lOrganizationValue = parseInt($('#uAdditionalEnrolleesOrganizationIdEdit').val()),
        lAgentValue,
        lBuilder = new SumoPredicateBuilder(),
        lEnrollees = mAgentsData.AvailableEnrollees;
    if (lOrganizationValue !== -1) {
        lAgentValue = parseInt($(aSelect).val());
        if (lAgentValue === -1) {
            lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        } else {
            lBuilder.AddNewExpressionConditional('AgentId', lAgentValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        lEnrollees = query(lEnrollees, lBuilder.RootExpression);
    }
    mAgentsControls.CurrentCaseloadAddAdditionalListView.setDataSource(lEnrollees);
}

function uAdditionalEnrolleesOrganizationIdFilter_OnChange(aSelect) {
    "use strict";
    var lValue = parseInt($(aSelect).val()),
        lAgents = getDataItems('Agents'),
        lBuilder = new SumoPredicateBuilder(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lSort = new SortExpression();
    $('.AdditionalEnrolleesAgents').hide();
    if (lValue === -1) {
        lAgents = [];

    } else {
        lBuilder.AddNewExpressionConditional('OrganizationId', lValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('Id', lCard.AgentIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        lAgents = query(lAgents, lBuilder.RootExpression);

        lSort.addAscendingColumn('LastName');
        lAgents = lSort.sort(lAgents);
    }
    populateEditView({ 'AgentId': -1 }, [
        { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': lAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName', 'isNullableKey': true, 'nullText': ' ' }
    ], {}, 'uAdditionalEnrollees', 'Edit');
    if (lValue !== -1) {
        $('.AdditionalEnrolleesAgents').show();
    }
    $('.AdditionalEnrolleesAgents').change();

}

function uAddAdditionalEnrolleeButton_OnClick() {
    "use strict";
    function onComplete() {

        mAgentsControls.CurrentCaseloadAddAdditionalListView = new sumo.controls.ListView('uCurrentCaseloadAddAdditionalListView', 'uCurrentCaseloadAdditionalAddListViewHolder', {
            'keyField': 'Id',
            'keyFieldType': 'number',
            'cssClass': 'VeritracksSelectListView',
            'selectMethod': 'auto',
            'canUnselect': true
        }, [
            { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
            { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
            { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter, 'sortable': false, 'canResize': true },
            { 'id': 'AgentId', 'title': localizeWrapper('cAgentPrimaryAgent'), 'dataField': 'AgentId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': AgentNameFormatter, 'sortable': false, 'canResize': true }
        ]);

        for (lKey in lOrganizationIds) {
            if (lOrganizationIds.hasOwnProperty(lKey)) {
                lItem = lOrganizationIds[lKey];
                lOrganization = getDataItem(lItem, 'Organizations');
                lOrganizations.push(lOrganization);
            }
        }
        for (lKey in lMyAdditionalEnrollees) {
            if (lMyAdditionalEnrollees.hasOwnProperty(lKey)) {
                lItem = lMyAdditionalEnrollees[lKey];
                lMyEnrolleeIds.push(lItem.Id);
            }
        }

        if (lMyEnrolleeIds.length > 0) {
            lBuilder.AddNewExpressionConditional('Id', lMyEnrolleeIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        }
        lBuilder.AddNewExpressionConditional('AgentId', lCard.AgentIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lEnrollees = query(lEnrollees, lBuilder.RootExpression);
        mAgentsData.AvailableEnrollees = lEnrollees;

        $('.AdditionalEnrolleesOrganizations').hide();
        $('.AdditionalEnrolleesAgents').hide();
        populateEditView({ 'OrganizationId': -1 }, [
            { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': OrganizationSortFormatter(lOrganizations), 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': true, 'nullText': ' ' }
        ], {}, 'uAdditionalEnrollees', 'Edit');
        if (lOrganizations.length > 1) {
            $('#uAdditionalEnrolleesOrganizationIdEdit').change();
            $('.AdditionalEnrolleesOrganizations').show();
        } else if (lOrganizations.length === 1) {
            lOrganization = lOrganizations[lOrganizations.length - 1];
            if (!isNullOrUndefined(lOrganization)) {
                $('#uAdditionalEnrolleesOrganizationIdEdit').val(lOrganization.Id).change();
            }
        }
    }

    var lBuilder = new SumoPredicateBuilder(),
        lEnrollees = getDataItems('Enrollees'),
        lOrganizationIds = mAgentsControls.CardView.selectedDataItem().OrganizationIds,
        lOrganizations = [],
        lOrganization,
        lButtonCommandBar = GenerateButtonCommandBar(),
        lMyAdditionalEnrollees = mAgentsControls.CurrentCaseloadAdditionalListView.getDataSource(),
        lMyEnrolleeIds = [],
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lHtml = [],
        lItem,
        lKey;

    mAgentsData.MovingCaseload = false;

    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsCaseloadAddAdditional_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentAddAditionalEnrollees'), '<div id="uAdditionalEnrolleesHolder"><img src="Images/ProgressBar.gif" alt="Loading..." style="margin-left: -75px;" /></div>', lButtonCommandBar, true);
    populateElement('uAdditionalEnrolleesHolder', 'Agents.Agents.CaseLoad.Popup.htm', onComplete);
}

function uRemoveAdditionalEnrolleeButton_OnClick() {
    "use strict";
    var lSelectedIds = mAgentsControls.CurrentCaseloadAdditionalListView.selected(),
        lAdditionalEnrolleeWrite = [],
        lItem,
        lKey;

    function onSuccess(aParams, aData) {
        var lAdditionalEnrollees = mAgentsData.AdditionalEnrollees;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lAdditionalEnrollees[lItem.EnrolleeId] = lItem;
            }
        }
        agentsAgentsCaseloadAdditionalEnrollees_Init(lAdditionalEnrollees);
        mActivityNotification.addNotification(localizeWrapper('cAgentEnrolleesRemovedAdditionalSuccess'));
    }

    for (lKey in lSelectedIds) {
        if (lSelectedIds.hasOwnProperty(lKey)) {
            lItem = lSelectedIds[lKey];
            lItem = mAgentsData.AdditionalEnrollees[lItem];
            lItem = $.extend({}, lItem);
            if (!isNullOrUndefined(lItem)) {
                lItem.IsActive = false;
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                lAdditionalEnrolleeWrite.push(lItem);
            }
        }
    }

    if (lAdditionalEnrolleeWrite.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAgentEnrolleeAdditionalRemoving'));
        WriteMultiple(lAdditionalEnrolleeWrite, onSuccess, null, {}, true);
    }
}



//--------------------
// Daily Notifications
//--------------------
function agentsAgentsDailyNotifications_Populate() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizations,
        lViewState = getViewState('AgentsSelectedOrganization'),
        lOrganizationId = -1;

    if (!isNullOrUndefined(lViewState)) {
        lOrganizationId = parseInt(lViewState.Value);
    }
    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('Id', lCard.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(getDataItems('Organizations'), lBuilder.RootExpression);
        populateEditView({ 'OrganizationId': lOrganizationId}, [
            { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
        ], {}, 'uDailyNotification', 'Edit');
    }
    $('#uDailyNotificationOrganizationIdEdit').change();
}

function uDailyNotificationsListView_OnSelectChange(aSender, aId, aData) {
    "use strict";
    var lSelected = mAgentsControls.DailyNotificationsListView.selected();
	$('#uRemoveDailyNotificationButton').hide();
    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
		$('#uRemoveDailyNotificationButton').show();
		$('#uRemoveDailyNotificationButtonBlockOut').hide();
        if (lSelected.length === 1) {
			$('#uEditDailyNotificationButton').show();
			$('#uEditDailyNotificationButtonBlockOut').hide();
        } else {
			$('#uEditDailyNotificationButton').hide();
			$('#uEditDailyNotificationButtonBlockOut').show();
		}
    } else {
        $('#uEditDailyNotificationButton').hide();
		$('#uRemoveDailyNotificationButton').hide();
		$('#uRemoveDailyNotificationButtonBlockOut').show();
		$('#uEditDailyNotificationButtonBlockOut').show();
    }
}

function agentsDailyNotificationsListViewSort(aParams, aSort) {
    var lDailyNotifcations = mAgentsControls.DailyNotificationsListView.getDataSource(),
        lDailyNotifcationsSortedList = [];

    lDailyNotifcationsSortedList = aSort.sort(lDailyNotifcations);
    mAgentsControls.DailyNotificationsListView.setDataSource(lDailyNotifcationsSortedList);

}

function agentsAgentsDailyNotifications_Init() {
    "use strict";
    mAgentsControls.DailyNotificationsListView = new sumo.controls.ListView('uDailyNotificationsListView', 'uDailyNotificationsListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'NotificationTypeId', 'title': localizeWrapper('cEvent'), 'dataField': 'NotificationTypeId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationTypeFormatter },
        { 'id': 'Scope', 'title': localizeWrapper('cEventScope'), 'dataField': 'Scope', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationScopeFormatter },
        { 'id': 'HitLevelId', 'title': localizeWrapper('cEventHits'), 'dataField': 'HitLevelId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationHitLevelFormatter }
    ]);
    //mAgentsControls.DailyNotificationsListView.bind('sort', agentsDailyNotificationsListViewSort);
    mAgentsControls.DailyNotificationsListView.bind('selectedchanged', veritracks.security.controller.extendSession);
    mAgentsControls.DailyNotificationsListView.bind('selectedchanged', uDailyNotificationsListView_OnSelectChange);
    agentsAgentsDailyNotifications_Populate();
}

function agentsAgentsDailyNotificationsData_Init(aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lItem,
        lKey;
    FixDates(aData);

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            mAgentsData.DailyNotifications[lItem.Id] = lItem;
        }
    }
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mAgentsData.DailyNotifications = query(mAgentsData.DailyNotifications, lBuilder.RootExpression);

    mAgentsControls.DailyNotificationsListView.setDataSource(mAgentsData.DailyNotifications);

    if (mAgentsData.DailyNotifications.length > 0) {
        $('#uSelectAllDailyNotificationButton').show();
		$('#uUnSelectAllDailyNotificationButton').hide();
		$('#uSelectAllDailyNotificationButtonBlockOut').hide();
    } else {
        $('#uSelectAllDailyNotificationButton').hide();
		$('#uUnSelectAllDailyNotificationButton').hide();
		$('#uSelectAllDailyNotificationButtonBlockOut').show();
    }
}

function agentsAgentsDailyNotifications_OnComplete(aParams, aData) {
    "use strict";
    ClosePopup();
    agentsAgentsDailyNotificationsData_Init(aData);
}

function uDailyNotificationOrganizationIdEdit_OnChange(aSelect) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lOrganizationId = $(aSelect).val(),
        lAgent;

    if (!isNullOrUndefined(lCard) && !isNullOrUndefined(lCard.AgentsByOrganization)) {
        setViewState('AgentsSelectedOrganization', lOrganizationId);
        lAgent = lCard.AgentsByOrganization[lOrganizationId];
        mAgentsData.DailyNotifications = [];
        mAgentsControls.DailyNotificationsListView.setDataSource([]);
        uDailyNotificationsListView_OnSelectChange();
        if (!isNullOrUndefined(lAgent)) {
            lBuilder.AddNewExpressionConditional('AgentId', lAgent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsImmediate', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Notification.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsDailyNotifications_OnComplete, null, {}, null, 0, true);
        }
    }
}

function uSelectAllDailyNotificationButton_OnClick() {
    "use strict";
    if ($('#uSelectAllDailyNotificationButton').is(":visible")) {
        $('#uSelectAllDailyNotificationButton').hide();
        $('#uUnSelectAllDailyNotificationButton').show();
        mAgentsControls.DailyNotificationsListView.selectAllList();
    } else {
        $('#uSelectAllDailyNotificationButton').show();
        $('#uUnSelectAllDailyNotificationButton').hide();
        mAgentsControls.DailyNotificationsListView.unselectAllList();
        uDailyNotificationsListView_OnSelectChange();
    }
}

function uSelectAllImmediateNotificationButton_OnClick() {
    "use strict";

	if ($('#uSelectAllImmediateNotificationButton').is(":visible")) {
        $('#uSelectAllImmediateNotificationButton').hide();
		$('#uUnSelectAllImmediateNotificationButton').show();
		$('#uSelectAllImmediateNotificationButtonBlockOut').hide();
        mAgentsControls.ImmediateNotificationsListView.selectAllList();
	} else {
		$('#uSelectAllImmediateNotificationButton').show();
		$('#uUnSelectAllImmediateNotificationButton').hide();
		$('#uSelectAllImmediateNotificationButtonBlockOut').hide();
        mAgentsControls.ImmediateNotificationsListView.unselectAllList();
        uImmediateNotificationsListView_OnSelectChange();
    }
}

function uSelectAllImmediateNotificationEventsListViewButton_OnClick() {
	"use strict";

	if ($('#uSelectAllImmediateNotificationEventsListViewButton').is(":visible")) {
		$('#uSelectAllImmediateNotificationEventsListViewButton').hide();
		$('#uUnSelectAllImmediateNotificationEventsListViewButton').show();
		mAgentsControls.ImmediateNotificationsEventsListView.selectAllList();
	} else {
		$('#uSelectAllImmediateNotificationEventsListViewButton').show();
		$('#uUnSelectAllImmediateNotificationEventsListViewButton').hide();
		mAgentsControls.ImmediateNotificationsEventsListView.unselectAllList();
	}
}


function uRemoveDailyNotificationButton_OnClick() {
    "use strict";
    var lSelectedItems = mAgentsControls.DailyNotificationsListView.selectedDataItem(),
        lNotificationWrite = [],
        lItem,
        lKey;

    for (lKey in lSelectedItems) {
        if (lSelectedItems.hasOwnProperty(lKey)) {
            lItem = lSelectedItems[lKey];
            lItem = $.extend({}, lItem);
            lItem.IsActive = false;
            lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            lNotificationWrite.push(lItem);
        }
    }

    if (lNotificationWrite.length > 0) {
        WriteMultiple(lNotificationWrite, agentsAgentsDailyNotifications_OnComplete, null, {}, true);
    }
}

function agentsAgentsAddDailyNotificationsPopup_OnSelectChange() {
    "use strict";
    var lEvents = mAgentsControls.DailyNotificationsEventsListView.selected(),
        lScopes = mAgentsControls.DailyNotificationsScopeListView.selected();

    if (!isNullOrUndefined(lEvents) && lEvents.length > 0 && !isNullOrUndefined(lScopes) && lScopes.length > 0) {
        $('#uPopupContainer .SaveButton').show();
    } else {
        $('#uPopupContainer .SaveButton').hide();
    }
}

function getScopeList() {
    return [{ 'Id': 1, 'Name': localizeText('cAgentMyEnrollees') }, { 'Id': 2, 'Name': localizeText('cAgentAgencysEnrollees') }];
}

function getMethodList(aNotification) {
    var lMethods = [];
    lMethods.push({ 'Id': 1, 'Name': localizeText('cAgentPrimaryEmail') });
    lMethods.push({ 'Id': 2, 'Name': localizeText('cAgentSecondaryEmail') });
    if (aNotification) {
        lMethods.push({ 'Id': 3, 'Name': localizeText('cAgentEscalationPlan') });
    }
    return lMethods;
}


function getAgentMethodList(aOri){
  'use strict';
  var lCardId = mAgentsControls.CardView.selected(),
  lBuilder = new SumoPredicateBuilder(),
  lAgentMethodList = [],
  lMethodList = [],
  lAgents = getDataItems('Agents');

  lBuilder.AddNewExpressionConditional("OrganizationId", aOri, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
  lBuilder.AddNewExpressionConditional("UserId", lCardId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
  lAgentMethodList = query(lAgents, lBuilder.RootExpression);
  for (var lKey in lAgentMethodList){
      if (lAgentMethodList.hasOwnProperty(lKey)) {
          if (lAgentMethodList[lKey].FirstContactValue != "") {
              lMethodList.push({ 'Id': 1, 'ContactName': lAgentMethodList[lKey].FirstContactName || 'First Contact', 'UserContactId': lAgentMethodList[lKey].UserContactId, 'AgentId': lAgentMethodList[lKey].Id, 'MethodId': lAgentMethodList[lKey].FirstContactMethodId });
          }

          if (lAgentMethodList[lKey].SecondContactValue != "") {
              lMethodList.push({ 'Id': 2, 'ContactName': lAgentMethodList[lKey].SecondContactName || 'Second Contact', 'UserContactId': lAgentMethodList[lKey].UserContactId, 'AgentId': lAgentMethodList[lKey].Id, 'MethodId': lAgentMethodList[lKey].SecondContactMethodId });
          }

          if (lAgentMethodList[lKey].ThirdContactValue != "") {
              lMethodList.push({ 'Id': 3, 'ContactName': lAgentMethodList[lKey].ThirdContactName || 'Third Contact', 'UserContactId': lAgentMethodList[lKey].UserContactId, 'AgentId': lAgentMethodList[lKey].Id, 'MethodId': lAgentMethodList[lKey].ThirdContactMethodId });
          }
    }
  }
  lBuilder.Clear();
  lBuilder.AddNewExpressionConditional("ContactName", "", false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
  lMethodList = query(lMethodList, lBuilder.RootExpression);
  return lMethodList;
}

function getTimesList() {
    return [{ 'Id': 1, 'Name': localizeText('cAgentOffHours') }, { 'Id': 2, 'Name': localizeText('cAgentNormalHours') }];
}
function agentsAgentsAddDailyNotificationsPopup_OnComplete() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lScopeList = getScopeList(),
        lEvents = getDataItems('NotificationType');
    $('#uPopupContainer .SaveButton').hide();
    if (!isNullOrUndefined(mAgentsControls.DailyNotificationsEventsListView)) {
        mAgentsControls.DailyNotificationsEventsListView.dispose();
        mAgentsControls.DailyNotificationsEventsListView = null;
    }
    mAgentsControls.DailyNotificationsEventsListView = new sumo.controls.ListView('uDailyNotificationsEvents', 'uDailyNotificationsEventsHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'number', 'canResize': true, 'formatMethod': agentNotificationTypeFormatter }
    ]);
    mAgentsControls.DailyNotificationsEventsListView.bind('selectedchanged', agentsAgentsAddDailyNotificationsPopup_OnSelectChange, null);
    lBuilder.AddNewExpressionConditional('IsImmediate', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);
    mAgentsControls.DailyNotificationsEventsListView.setDataSource(lEvents);

    if (!isNullOrUndefined(mAgentsControls.DailyNotificationsScopeListView)) {
        mAgentsControls.DailyNotificationsScopeListView.dispose();
        mAgentsControls.DailyNotificationsScopeListView = null;
    }
    mAgentsControls.DailyNotificationsScopeListView = new sumo.controls.ListView('uDailyNotificationsScope', 'uDailyNotificationsScopeHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
    ]);
    mAgentsControls.DailyNotificationsScopeListView.bind('selectedchanged', agentsAgentsAddDailyNotificationsPopup_OnSelectChange, null);
    mAgentsControls.DailyNotificationsScopeListView.setDataSource(lScopeList);

    populateEditView({ 'HitLevelId': -1 }, [
        { 'Id': 'HitLevelId', 'Type': 'Dropdown', 'DataSource': getDataItems('HitLevel'), 'LocaleName': 'HitLevel', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': false }
    ], {}, 'uDailyNotifications', 'Edit', localizeDataItem);
}

function agentsAgentsAddDailyNotificationsPopup_Init() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsAddDailyNotificationsAdd_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentAddDailyNotifications'), '<div id="uDailyNotificationsPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uDailyNotificationsPopupPanel', 'Agents.Agents.DailyNotifications.AddPopup.Layout.htm', agentsAgentsAddDailyNotificationsPopup_OnComplete);
}

function agentsAgentsAddDailyNotificationsAdd_OnClick() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizationId = $('#uDailyNotificationOrganizationIdEdit').val(),
        lAgent = lCard.AgentsByOrganization[lOrganizationId],
        lEvents = mAgentsControls.DailyNotificationsEventsListView.selectedDataItem(),
        lHitLevel = $('#uDailyNotificationsHitLevelIdEdit').val(),
        lEvent,
        lEventKey,

        lScopes = mAgentsControls.DailyNotificationsScopeListView.selectedDataItem(),
        lScope,
        lScopeKey,

        lNotification,
        lNotificationWrite = [],

        lBuilder = new SumoPredicateBuilder(),
        lQueryResult;

    for (lEventKey in lEvents) {
        if (lEvents.hasOwnProperty(lEventKey)) {
            lEvent = lEvents[lEventKey];
            for (lScopeKey in lScopes) {
                if (lScopes.hasOwnProperty(lScopeKey)) {
                    lScope = lScopes[lScopeKey];

                    lBuilder.Clear();
                    lBuilder.AddNewExpressionConditional('NotificationTypeId', lEvent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    lBuilder.AddNewExpressionConditional('Scope', lScope.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                   // lBuilder.AddNewExpressionConditional('HitLevelId', lHitLevel, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And()); [EE] causing bug 1921
                    lQueryResult = query(mAgentsData.DailyNotifications, lBuilder.RootExpression);

                    if (lQueryResult.length === 0) {
                        lNotification = new Notification();
                        lNotification.AgentId = lAgent.Id;
                        lNotification.ContactTypeId = -1;
                        lNotification.HitLevelId = lHitLevel;
                        lNotification.IsImmediate = false;
                        lNotification.NotificationTypeId = lEvent.Id;
                        lNotification.Scope = lScope.Id;
                        lNotification.WorkingHoursType = 2;
                        lNotification.TransactionId = moment().format("YYYYMMDDHHmmss");
                        lNotificationWrite.push(lNotification);
                    }
                }
            }
        }
    }

    if (lNotificationWrite.length > 0) {
        WriteMultiple(lNotificationWrite, agentsAgentsDailyNotifications_OnComplete, null, {}, true);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cAgentDailyNotificationSameScopeError'));
        ClosePopup();
    }
}

function agentsAgentsEditDailyNotificationsPopup_OnComplete() {
    "use strict";
    var lSelectedItems = mAgentsControls.DailyNotificationsListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lScopeList = getScopeList(),
        lEvents = getDataItems('NotificationType');
    lBuilder.AddNewExpressionConditional('IsImmediate', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);

    populateEditView(lSelectedItems[0], [
        { 'Id': 'NotificationTypeId', 'Type': 'Dropdown', 'DataSource': lEvents, 'LocaleName': 'NotificationType', 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'Scope', 'Type': 'Dropdown', 'DataSource': lScopeList, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'HitLevelId', 'Type': 'Dropdown', 'DataSource': getDataItems('HitLevel'), 'LocaleName': 'HitLevel', 'DataValueField': 'Id', 'DataTextField': 'Description', 'isNullableKey': false }
    ], {}, 'uDailyNotification', 'Edit', localizeDataItem);
}

function agentsAgentsAddDailyNotificationsEdit_OnClick() {
    "use strict";
    var lSelectedItems = mAgentsControls.DailyNotificationsListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lQueryResult,
        lItem = $.extend({}, lSelectedItems[0]);
    populateFromEditView(lItem, 'uDailyNotification', 'Edit');

    lBuilder.AddNewExpressionConditional('NotificationTypeId', lItem.NotificationTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Scope', lItem.Scope, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('HitLevelId', lItem.HitLevelId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lQueryResult = query(mAgentsData.DailyNotifications, lBuilder.RootExpression);

    if (lQueryResult.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAgentDailyNotificationAlreadyExists'));
        ClosePopup();
    } else {
        lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteMultiple([lItem], agentsAgentsDailyNotifications_OnComplete, null, {}, true);
    }
}

function uEditDailyNotificationButton_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsAddDailyNotificationsEdit_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentEditDailyNotifications'), '<div id="uDailyNotificationsPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uDailyNotificationsPopupPanel', 'Agents.Agents.DailyNotifications.EditPopup.Layout.htm', agentsAgentsEditDailyNotificationsPopup_OnComplete);
}



//------------------------
// Immediate Notifications
//------------------------
function uImmediateNotificationsListView_OnSelectChange() {
    "use strict";
    var lSelected = mAgentsControls.ImmediateNotificationsListView.selected();

    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
		$('#uRemoveImmediateNotificationButton').show();
		$('#uRemoveImmediateNotificationButtonBlockOut').hide();
        if (lSelected.length === 1) {
			$('#uEditImmediateNotificationButton').show();
			$('#uEditImmediateNotificationButtonBlockOut').hide();
        } else {
			$('#uEditImmediateNotificationButton').hide();
			$('#uEditImmediateNotificationButtonBlockOut').show();
        }
    } else {
		$('#uEditImmediateNotificationButton').hide();
		$('#uEditImmediateNotificationButtonBlockOut').show();
		$('#uRemoveImmediateNotificationButton').hide();
		$('#uRemoveImmediateNotificationButtonBlockOut').show();
    }
}

function agentsAgentsImmediateNotifications_Populate() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizations,
        lViewState = getViewState('AgentsSelectedOrganization'),
        lOrganizationId = -1;

    if (!isNullOrUndefined(lViewState)) {
        lOrganizationId = parseInt(lViewState.Value);
    }

    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('Id', lCard.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(getDataItems('Organizations'), lBuilder.RootExpression);
        populateEditView({ 'OrganizationId': lOrganizationId }, [
            { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
        ], {}, 'uImmediateNotification', 'Edit');
    }
    $('#uImmediateNotificationOrganizationIdEdit').change();
}

function uImmediateNotificationsListView_OnSort(aParams, aSort) {
    "use strict";
    var lImmediateNotifications = mAgentsControls.ImmediateNotificationsListView.getDataSource(),
    lImmediateNotificationsSortedList = [];

    lImmediateNotificationsSortedList = aSort.sort(lImmediateNotifications);
    mAgentsControls.ImmediateNotificationsListView.setDataSource(lImmediateNotificationsSortedList);

}

function agentsAgentsImmediateNotifications_Init() {
    "use strict";
    mAgentsControls.ImmediateNotificationsListView = new sumo.controls.ListView('uImmediateNotificationsListView', 'uImmediateNotificationsListViewHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'canUnselect': true
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
            { 'id': 'NotificationTypeId', 'title': localizeWrapper('cEvent'), 'dataField': 'NotificationTypeId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationTypeFormatter },
            { 'id': 'RiskLevelId', 'title': localizeWrapper('cEnrolleeRiskLevel'), 'dataField': 'RiskLevelId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationRiskLevelFormatter },
            { 'id': 'Scope', 'title': localizeWrapper('cEventScope'), 'dataField': 'Scope', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationScopeFormatter },
            { 'id': 'UserContactPriority', 'title': localizeWrapper('cEventMethod'), 'dataField': 'UserContactPriority', 'width': 'autoData', 'minWidth': 75, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationUserPriorityFormatter },
            { 'id': 'ContactFormatId', 'title': localizeWrapper('cEventFormat'), 'dataField': 'ContactFormatId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationContactFormatFormatter },
            { 'id': 'WorkingHoursType', 'title': localizeWrapper('cEventTime'), 'dataField': 'WorkingHoursType', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentWorkingHoursFormatter }
    ]);

    mAgentsControls.ImmediateNotificationsListView.bind('selectedchanged', veritracks.security.controller.extendSession);
    mAgentsControls.ImmediateNotificationsListView.bind('selectedchanged', uImmediateNotificationsListView_OnSelectChange);
    //mAgentsControls.ImmediateNotificationsListView.bind('sort', uImmediateNotificationsListView_OnSort);
    agentsAgentsImmediateNotifications_Populate();
}

function agentsAgentsImmediateNotificationsData_Init(aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lAgents = getDataItems('Agents'),
        lItem,
        lKey;
    FixDates(aData);



    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            mAgentsData.ImmediateNotifications[lItem.Id] = lItem;
        }
    }
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mAgentsData.ImmediateNotifications = query(mAgentsData.ImmediateNotifications, lBuilder.RootExpression);

    mAgentsControls.ImmediateNotificationsListView.setDataSource(mAgentsData.ImmediateNotifications);

    if (mAgentsData.ImmediateNotifications.length > 0) {
        $('#uSelectAllImmediateNotificationButton').show();
		$('#uUnSelectAllImmediateNotificationButton').hide();
		$('#uSelectAllImmediateNotificationButtonBlockOut').hide();
    } else {
        $('#uSelectAllImmediateNotificationButton').hide();
		$('#uUnSelectAllImmediateNotificationButton').hide();
		$('#uSelectAllImmediateNotificationButtonBlockOut').show();
    }
}

function agentsAgentsImmediateNotifications_OnComplete(aParams, aData) {
    "use strict";
    ClosePopup();
    agentsAgentsImmediateNotificationsData_Init(aData);
}

function uImmediateNotificationOrganizationIdEdit_OnChange(aSelect) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lOrganizationId = $(aSelect).val(),
        lAgent;

    if (!isNullOrUndefined(lCard) && !isNullOrUndefined(lCard.AgentsByOrganization)) {
        setViewState('AgentsSelectedOrganization', lOrganizationId);
        lAgent = lCard.AgentsByOrganization[lOrganizationId];
        mAgentsData.ImmediateNotifications = [];
        mAgentsControls.ImmediateNotificationsListView.setDataSource([]);
        uImmediateNotificationsListView_OnSelectChange();
        if (!isNullOrUndefined(lAgent)) {
            lBuilder.AddNewExpressionConditional('AgentId', lAgent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            //lBuilder.AddNewExpressionConditional('WorkingHoursType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Notification.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsImmediateNotifications_OnComplete, null, {}, null, 0, true);
        }
    }
}

function uRemoveImmediateNotificationButton_OnClick() {
    "use strict";
    var lSelectedItems = mAgentsControls.ImmediateNotificationsListView.selectedDataItem(),
        lNotificationWrite = [],
        lItem,
        lKey;

    for (lKey in lSelectedItems) {
        if (lSelectedItems.hasOwnProperty(lKey)) {
            lItem = lSelectedItems[lKey];
            lItem = $.extend({}, lItem);
            lItem.IsActive = false;
            lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            lNotificationWrite.push(lItem);
        }
    }

    if (lNotificationWrite.length > 0) {
        //agentsAgentsImmediateNotifications_OnComplete({}, lNotificationWrite);
        WriteMultiple(lNotificationWrite, agentsAgentsImmediateNotifications_OnComplete, null, {}, true);
    }
}

function agentsAgentsAddImmediateNotifications_OnClick() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lSelectedOrganizationId = $('#uImmediateNotificationOrganizationIdEdit').val(),
        lAgent = lCard.AgentsByOrganization[lSelectedOrganizationId],
        lBuilder = new SumoPredicateBuilder(),
        lNotifications = mAgentsData.ImmediateNotifications,
        lNotificationWrite = [],
        lNotificationList,
        lNotification,

        lSelectedEvents = mAgentsControls.ImmediateNotificationsEventsListView.selectedDataItem(),
        lEvents = getDataItems('NotificationType'),
        lEventKey,
        lEvent,

        lSelectedRiskLevels = mAgentsControls.ImmediateNotificationsRiskLevelListView.selectedDataItem(),
        lRiskLevels = RiskLevelFormatter(),
        lRiskLevelKey,
        lRiskLevel,

        lSelectedScopes = mAgentsControls.ImmediateNotificationsScopeListView.selectedDataItem(),
        lScopes = getScopeList(),
        lScopeKey,
        lScope,

        lSelectedMethods = mAgentsControls.ImmediateNotificationsMethodListView.selectedDataItem(),
        lMethods = getAgentMethodList(lSelectedOrganizationId),
        lMethodKey,
        lMethod,

        lSelectedTimes = mAgentsControls.ImmediateNotificationsTimeListView.selectedDataItem(),
        lTimes = getTimesList(),
        lTimeKey,
        lTime,

        lSelectedFormatMethod = null,
        lSelectedFormats = [];

    for (var lFormat in mAgentsControls.ImmediateNotificationsFormatListViewList){
      if (mAgentsControls.ImmediateNotificationsFormatListViewList.hasOwnProperty(lFormat)){
            lSelectedFormats = lSelectedFormats.concat(mAgentsControls.ImmediateNotificationsFormatListViewList[lFormat].selectedDataItem());
      }
    }

    for (lEventKey in lSelectedEvents) {
        if (lSelectedEvents.hasOwnProperty(lEventKey)) {
            lEvent = lSelectedEvents[lEventKey];

            for (lRiskLevelKey in lSelectedRiskLevels) {
                if (lSelectedRiskLevels.hasOwnProperty(lRiskLevelKey)) {
                    lRiskLevel = lSelectedRiskLevels[lRiskLevelKey];

                    for (lScopeKey in lSelectedScopes) {
                        if (lSelectedScopes.hasOwnProperty(lScopeKey)) {
                            lScope = lSelectedScopes[lScopeKey];

                            for (lMethodKey in lSelectedMethods) {
                                if (lSelectedMethods.hasOwnProperty(lMethodKey)) {
                                    lMethod = lSelectedMethods[lMethodKey];

                                    for (var lFormatKey in lSelectedFormats){
                                      if (lSelectedFormats.hasOwnProperty(lFormatKey)){
                                        if (lSelectedFormats[lFormatKey].MethodId == lMethod.Id){
                                          lSelectedFormatMethod = lSelectedFormats[lFormatKey];
                                        }
                                      }
                                    }

                                    for (lTimeKey in lSelectedTimes) {
                                        if (lSelectedTimes.hasOwnProperty(lTimeKey)) {
                                            lTime = lSelectedTimes[lTimeKey];

                                            lBuilder.Clear();
                                            lBuilder.AddNewExpressionConditional('ContactTypeId', lMethod.MethodId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('Scope', lScope.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('RiskLevelId', lRiskLevel.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('NotificationTypeId', lEvent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('WorkingHoursType', lTime.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('ContactFormatId', lSelectedFormatMethod.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                                            lBuilder.AddNewExpressionConditional('UserContactPriority', lMethod.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                                            lNotificationList = query(lNotifications, lBuilder.RootExpression);
                                            if (lNotificationList.length === 0) {
                                                lNotification = new Notification();
                                                lNotification.AgentId = lAgent.Id;
                                                lNotification.ContactTypeId = lMethod.MethodId;
                                                lNotification.IsImmediate = true;
                                                lNotification.NotificationTypeId = lEvent.Id;
                                                lNotification.RiskLevelId = lRiskLevel.Id;
                                                lNotification.Scope = lScope.Id;
                                                lNotification.WorkingHoursType = lTime.Id;
                                                lNotification.TransactionId = moment().format("YYYYMMDDHHmmss");
                                                lNotification.ContactFormatId = lSelectedFormatMethod.Id;
                                                lNotification.UserContactId = lMethod.UserContactId;
                                                lNotification.UserContactPriority = lMethod.Id;
                                                lNotificationWrite.push(lNotification);
                                            }

                                        }
                                    }

                                }
                            }

                        }
                    }

                }
            }

        }
    }

    if (lNotificationWrite.length > 0) {
        WriteMultiple(lNotificationWrite, agentsAgentsImmediateNotifications_OnComplete, null, {}, true);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cAgentImmediateNotificationAlreadyExists'));
        ClosePopup();
    }
}

function methodCheckItem(){
  'use strict';
  var lDataSource = mAgentsControls.ImmediateNotificationsMethodListView.getDataSource(),
    lSelectFormats = [],
    lFormatList = $.extend(true, [] ,getDataItems('UserContactFormat')),
    lSelected = mAgentsControls.ImmediateNotificationsMethodListView.selected();

    if (isNullOrUndefined(lSelected)){
      return;
    }

  for (var i = 0; i < mAgentsControls.ImmediateNotificationsFormatListViewList.length; i++){
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsFormatListViewList[i])){
      lSelectFormats[mAgentsControls.ImmediateNotificationsFormatListViewList[i].Id] = mAgentsControls.ImmediateNotificationsFormatListViewList[i].selected() == null?false:mAgentsControls.ImmediateNotificationsFormatListViewList[i].selected();
      $('#uImmediateNotificationsFormatSection' + (i + 1)).hide();
      mAgentsControls.ImmediateNotificationsFormatListViewList[i].dispose();
      mAgentsControls.ImmediateNotificationsFormatListViewList[i] = null;
    }
  }

  mAgentsControls.ImmediateNotificationsFormatListViewList = [];

  for (var lKey = 0; lKey < lDataSource.length; lKey++){
    //if (lDataSource.hasOwnProperty(lKey)){
      if (lSelected.indexOf(lDataSource[lKey].Id) != -1){
        var lUserFormatDataSource = [];
        for (var format = 0; format < lFormatList.length; format++){
          if (lFormatList.hasOwnProperty(format)){
            lUserFormatDataSource[format] = lFormatList[format];
            lUserFormatDataSource[format].MethodId = lDataSource[lKey].Id;
          }
        }
        var ImmediateNotificationsFormatListView = new sumo.controls.ListView('uImmediateNotificationsFormat' +  lDataSource[lKey].Id, 'uImmediateNotificationsFormatHolder' + lDataSource[lKey].Id, {
            'keyField': 'Id',
            'keyFieldType': 'number',
            'cssClass': 'VeritracksSelectListView',
            'selectMethod': 'single',
            'showHeader': false
        }, [
            { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
            { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'ContactFormatName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
          ]);
          $('#uImmediateNotificationsFormatMethod' + lDataSource[lKey].Id).html(lDataSource[lKey].ContactName);
          $('#uImmediateNotificationsFormatSection' + lDataSource[lKey].Id).show();
          if (lDataSource[lKey].MethodId == 1){
            var lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional("Id", 2, false,  mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
            var lNewDataSource = $.extend(true, [], lUserFormatDataSource);
            var lData = [];
            for (var i = 0; i < lNewDataSource.length; i++){
              if (lNewDataSource.hasOwnProperty(i) && !isNullOrUndefined(lNewDataSource[i])){
                  lData.push(lNewDataSource[i]);
              }
            }
            var lReducedFormatList = query(lData, lBuilder.RootExpression);
            ImmediateNotificationsFormatListView.setDataSource(lReducedFormatList);
          }else {
            var lNewDataSource = $.extend(true, [], lUserFormatDataSource);
            var lData = [];
            for (var i = 0; i < lNewDataSource.length; i++){
              if (lNewDataSource.hasOwnProperty(i) && !isNullOrUndefined(lNewDataSource[i])){
                  lData.push(lNewDataSource[i]);
              }
            }
            ImmediateNotificationsFormatListView.setDataSource(lData);
          }


          ImmediateNotificationsFormatListView.bind('selectedchanged', immediateNotificationItemCheck, null);
          if (lSelectFormats[ImmediateNotificationsFormatListView.Id]){
            ImmediateNotificationsFormatListView.selected(lSelectFormats[ImmediateNotificationsFormatListView.Id][0]);
          }
          mAgentsControls.ImmediateNotificationsFormatListViewList.push(ImmediateNotificationsFormatListView);
      }
  }//end of for

}

function escalationPlanItemCheck_OnSuccess(aParams, aData) {
    "use strict";
    var lMethodListOld = getMethodList(),
        lMethodListNew = getMethodList(true);

    if (aData.length > 0) {
        //mAgentsControls.ImmediateNotificationsMethodListView.setDataSource(lMethodListNew);
    } else {
        //mAgentsControls.ImmediateNotificationsMethodListView.setDataSource(lMethodListOld);
    }//end of else
}

function escalationPlanItemCheck(aRiskLevelIds) {
    "use strict";

    var lBuilder = new SumoPredicateBuilder(),
        lAgentCardItem = mAgentsControls.CardView.selectedDataItem(),
        lCurrentAgents = getDataItems('Agents'),
        lAgents = [],
        lAgentId = 0;


    lBuilder.AddNewExpressionConditional("Id", lAgentCardItem.AgentIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("OrganizationId", $("#uImmediateNotificationOrganizationIdEdit").val(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAgents = query(lCurrentAgents, lBuilder.RootExpression);

    if (lAgents.length > 0) {

        for (var key in lAgents) {
            if (lAgents.hasOwnProperty(key)) {
                lAgentId = lAgents[key].Id;
                break;
            }//end of if
        }//end of for
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('RiskLevelId', aRiskLevelIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('AgentId', lAgentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EscalationPlanRiskLevel.AssemblyQualifiedName, lBuilder.RootExpression, 0, escalationPlanItemCheck_OnSuccess, null, {}, null, 0, true);
    }

}

function agentsAgentsAddImmediateNotificationsPopup_OnSelectChange() {
    "use strict";
    immediateNotificationItemCheck();
    methodCheckItem();
}

function immediateNotificationItemCheck(){
  'use strict';
  var lEvents = mAgentsControls.ImmediateNotificationsEventsListView.selected(),
      lRiskLevels = mAgentsControls.ImmediateNotificationsRiskLevelListView.selected(),
      lScopes = mAgentsControls.ImmediateNotificationsScopeListView.selected(),
      lMethods = mAgentsControls.ImmediateNotificationsMethodListView.selected(),
      lFormat =  [],
      lTimes = mAgentsControls.ImmediateNotificationsTimeListView.selected();

      if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsFormatListViewList)){
        for(var i = 0; i < mAgentsControls.ImmediateNotificationsFormatListViewList.length; i++){
          if (mAgentsControls.ImmediateNotificationsFormatListViewList[i].selected() != null){
            lFormat = lFormat.concat(mAgentsControls.ImmediateNotificationsFormatListViewList[i].selected());
          }
        }
      }

  if (!isNullOrUndefined(lEvents) && lEvents.length > 0 &&
      !isNullOrUndefined(lRiskLevels) && lRiskLevels.length > 0 &&
      !isNullOrUndefined(lScopes) && lScopes.length > 0 &&
      !isNullOrUndefined(lMethods) && lMethods.length > 0 &&
      !isNullOrUndefined(lFormat) && lFormat.length > 0 &&
      !isNullOrUndefined(lTimes) && lTimes.length > 0) {
      $('#uPopupContainer .SaveButton').show();
  } else {
      $('#uPopupContainer .SaveButton').hide();
  }
}


function agentsAgentsAddImmediateNotificationsPopup_OnComplete() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lScopeList = getScopeList(),
        lTimeList = getTimesList(),
        lEvents = getDataItems('NotificationType'),
        lRiskLevels = RiskLevelFormatter(),
        lAgentId = 0,
        lOrganization = $('#uImmediateNotificationOrganizationIdEdit').val(),
        lMethodList = getAgentMethodList(lOrganization);

    $('#uPopupContainer .SaveButton').hide();
    // Events
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsEventsListView)) {
        mAgentsControls.ImmediateNotificationsEventsListView.dispose();
        mAgentsControls.ImmediateNotificationsEventsListView = null;
    }
    mAgentsControls.ImmediateNotificationsEventsListView = new sumo.controls.ListView('uImmediateNotificationsEvents', 'uImmediateNotificationsEventsHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Id', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true, 'formatMethod': agentNotificationTypeFormatter }
    ]);
    mAgentsControls.ImmediateNotificationsEventsListView.bind('selectedchanged', immediateNotificationItemCheck, null);
    lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);
    var lSort = new SortExpression();

    lSort.addAscendingColumn('Name');
    lEvents = lSort.sort(lEvents);

    mAgentsControls.ImmediateNotificationsEventsListView.setDataSource(lEvents);

    // Risk Level
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsRiskLevelListView)) {
        mAgentsControls.ImmediateNotificationsRiskLevelListView.dispose();
        mAgentsControls.ImmediateNotificationsRiskLevelListView = null;
    }

        mAgentsControls.ImmediateNotificationsRiskLevelListView = new sumo.controls.ListView('uImmediateNotificationsRiskLevel', 'uImmediateNotificationsRiskLevelHolder', {
            'keyField': 'Id',
            'keyFieldType': 'number',
            'cssClass': 'VeritracksSelectListView',
            'selectMethod': 'auto',
            'showHeader': false
        }, [
    { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
    { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
        ]);
        mAgentsControls.ImmediateNotificationsRiskLevelListView.bind('selectedchanged', immediateNotificationItemCheck, null);
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('SupportImmediateNotifFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);
        mAgentsControls.ImmediateNotificationsRiskLevelListView.setDataSource(lRiskLevels);
        if (lRiskLevels.length <= 0) {
            $('#uImmediateNotificationsRiskLevelHolderParent').remove();
        }


    // Scope
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsScopeListView)) {
        mAgentsControls.ImmediateNotificationsScopeListView.dispose();
        mAgentsControls.ImmediateNotificationsScopeListView = null;
    }
    mAgentsControls.ImmediateNotificationsScopeListView = new sumo.controls.ListView('uImmediateNotificationsScope', 'uImmediateNotificationsScopeHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
    ]);
    mAgentsControls.ImmediateNotificationsScopeListView.bind('selectedchanged', immediateNotificationItemCheck, null);
    mAgentsControls.ImmediateNotificationsScopeListView.setDataSource(lScopeList);

    // Method
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsMethodListView)) {
        mAgentsControls.ImmediateNotificationsMethodListView.dispose();
        mAgentsControls.ImmediateNotificationsMethodListView = null;
    }

    mAgentsControls.ImmediateNotificationsMethodListView = new sumo.controls.ListView('uImmediateNotificationsMethod', 'uImmediateNotificationsMethodHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'ContactName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
      ]);

    mAgentsControls.ImmediateNotificationsMethodListView.bind('selectedchanged', agentsAgentsAddImmediateNotificationsPopup_OnSelectChange, null);
    mAgentsControls.ImmediateNotificationsMethodListView.setDataSource(lMethodList);


    // Time
    if (!isNullOrUndefined(mAgentsControls.ImmediateNotificationsTimeListView)) {
        mAgentsControls.ImmediateNotificationsTimeListView.dispose();
        mAgentsControls.ImmediateNotificationsTimeListView = null;
    }
    mAgentsControls.ImmediateNotificationsTimeListView = new sumo.controls.ListView('uImmediateNotificationTime', 'uImmediateNotificationsTimeHolder', {
        'keyField': 'Id',
        'keyFieldType': 'number',
        'cssClass': 'VeritracksSelectListView',
        'selectMethod': 'auto',
        'showHeader': false
    }, [
        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'number', 'canResize': true }
    ]);

    mAgentsControls.ImmediateNotificationsTimeListView.bind('selectedchanged', immediateNotificationItemCheck, null);
    mAgentsControls.ImmediateNotificationsTimeListView.setDataSource(lTimeList);
}

function agentsAgentsAddImmediateNotificationsPopup_Init() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsAddImmediateNotifications_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentAddImmediateNotifications'), '<div id="uImmediateNotificationsPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uImmediateNotificationsPopupPanel', 'Agents.Agents.ImmediateNotifications.AddPopup.Layout.htm', agentsAgentsAddImmediateNotificationsPopup_OnComplete);
}

function agentsAgentsEditImmediateNotifications_OnClick() {
    "use strict";
    var lSelectedItems = mAgentsControls.ImmediateNotificationsListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lSelectedItem = lSelectedItems[0],
        lItem = $.extend({}, lSelectedItem),
        lQuery;

    populateFromEditView(lItem, 'uImmediateNotification', 'Edit');
    lBuilder.AddNewExpressionConditional('ContactTypeId', lItem.ContactTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Scope',lItem.Scope, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('RiskLevelId', lItem.RiskLevelId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('NotificationTypeId', lItem.NotificationTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', lItem.Id, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('WorkingHoursType', lItem.WorkingHoursType, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ContactFormatId', lItem.ContactFormatId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('UserContactPriority', lItem.UserContactPriority, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lQuery = query(mAgentsData.ImmediateNotifications, lBuilder.RootExpression);
    if (lQuery.length > 0) {
        //lItem = $.extend({}, lSelectedItem);
        //lItem.IsActive = false;
        mActivityNotification.addNotification(localizeWrapper('cAgentImmediateNotificationAlreadyExists'));
        ClosePopup();
    } else {
        lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteMultiple([lItem], agentsAgentsImmediateNotifications_OnComplete, null, {}, true);
    }
}
//benjamin
function agentsAgentsEditImmediateNotificationPopup_OnComplete() {
    "use strict";
    var lSelectedItems = mAgentsControls.ImmediateNotificationsListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lScopes = getScopeList(),
        lMethods = [],
        lFormats = getDataItems('UserContactFormat'),
        lEvents = getDataItems('NotificationType'),
        lTimes = getTimesList(),
        lRiskLevels = RiskLevelFormatter(),
        lSort = new SortExpression(),
        lOrganization = $('#uImmediateNotificationOrganizationIdEdit').val();

    lMethods = getAgentMethodList(lOrganization);
    lSort.addAscendingColumn('Name');

    lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);
    lEvents = lSort.sort(lEvents);

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('SupportImmediateNotifFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);
    if (lRiskLevels.length <= 0) {
        $('#uImmediateNotificationContactTypeIdHeader').remove();
        $('#uImmediateNotificationContactTypeIdEdit').remove();
    }


    populateEditView(lSelectedItems[0], [
        { 'Id': 'NotificationTypeId', 'Type': 'Dropdown', 'DataSource': lEvents, 'LocaleName': 'NotificationType', 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'RiskLevelId', 'Type': 'Dropdown', 'DataSource': lRiskLevels, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'Scope', 'Type': 'Dropdown', 'DataSource': lScopes, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'UserContactPriority', 'Type': 'Dropdown', 'DataSource': lMethods, 'DataValueField': 'Id', 'DataTextField': 'ContactName', 'isNullableKey': false },
        { 'Id': 'ContactFormatId', 'Type': 'Dropdown', 'DataSource': lFormats, 'DataValueField': 'Id', 'DataTextField': 'ContactFormatName', 'isNullableKey': false },
        { 'Id': 'WorkingHoursType', 'Type': 'Dropdown', 'DataSource': lTimes, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
    ], {}, 'uImmediateNotification', 'Edit', localizeDataItem);

    $('#uImmediateNotificationUserContactPriorityEdit').bind('change', uImmediateNotificationPriorityEditChange);
    uImmediateNotificationPriorityEditChange();
}

function uImmediateNotificationPriorityEditChange() {
    'use strict';
    var lMethods = [],
        lOrganization = $('#uImmediateNotificationOrganizationIdEdit').val(),
        lUserMethodSelectedId = $('#uImmediateNotificationUserContactPriorityEdit').val();

    lMethods = getAgentMethodList(lOrganization);

    for (var key in lMethods) {
        if (lMethods.hasOwnProperty(key)) {
            if (lMethods[key].Id == lUserMethodSelectedId && lMethods[key].MethodId == 1) {
                $('#uImmediateNotificationContactFormatIdEdit option[value="2"]').attr('disabled', true);
                $('#uImmediateNotificationContactFormatIdEdit').val(1);
                $('#uImmediateNotificationContactFormatIdEdit option[value="2"]').addClass("AgentImmediateNotificationDisabled")
                break;
            } else {
                $('#uImmediateNotificationContactFormatIdEdit option[value="2"]').attr('disabled', false);
                $('#uImmediateNotificationContactFormatIdEdit option[value="2"]').removeClass("AgentImmediateNotificationDisabled");

            }
        }//end of if
    }//end of for


}

function agentsAgentsEditImmediateNotificationPopup_Init() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsEditImmediateNotifications_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentEditImmediateNotifications'), '<div id="uImmediateNotificationsPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uImmediateNotificationsPopupPanel', 'Agents.Agents.ImmediateNotifications.EditPopup.Layout.htm', agentsAgentsEditImmediateNotificationPopup_OnComplete);
}



//-----------------
// Risk Level Plans
//-----------------
function agentsAgentsRiskLevelPlanRead_OnComplete(aParams, aData) {
    "use strict";
    var lRiskLevels = RiskLevelFormatter(),
        lEscalationPlans = getDataItems('EscalationPlans'),
        lBuilder = new SumoPredicateBuilder(),
        lRiskLevelPlans = [],
        lRiskLevelPlan,
        lQueryResults,
        lPlan,
        lItem,
        lKey,
        lOrganization = $('#uRiskLevelPlanOrganizationIdEdit').val();

    if (!isNullOrUndefined(mAgentsControls.RiskLevelListView)) {
        lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.NotEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lOrganization, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lRiskLevels = query(lRiskLevels, lBuilder.RootExpression);

        for (lKey in lRiskLevels) {
            if (lRiskLevels.hasOwnProperty(lKey)) {
                lItem = lRiskLevels[lKey];
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('RiskLevelId', lItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lQueryResults = query(aData, lBuilder.RootExpression);
                if (lQueryResults.length > 0) {
                    lRiskLevelPlan = lQueryResults[lQueryResults.length - 1];
                    lPlan = lEscalationPlans[lRiskLevelPlan.EscalationPlanId];
                    if (!isNullOrUndefined(lPlan)) {
                        lRiskLevelPlans.push({ 'RiskLevelId': lItem.Id, 'RiskLevelName': lItem.Name, 'RiskLevel': lItem, 'EscalationPlanId': lPlan.Id, 'EscalationPlanName': lPlan.Name, 'EscalationPlan': lPlan, 'Data': lRiskLevelPlan, 'Agent': aParams });
                    } else {
                        lRiskLevelPlans.push({ 'RiskLevelId': lItem.Id, 'RiskLevelName': lItem.Name, 'RiskLevel': lItem, 'EscalationPlanId': -1, 'EscalationPlanName': '- no plan -', 'EscalationPlan': null, 'Data': {}, 'Agent': aParams });
                    }

                } else {
                    lRiskLevelPlans.push({ 'RiskLevelId': lItem.Id, 'RiskLevelName': lItem.Name, 'RiskLevel': lItem, 'EscalationPlanId': -1, 'EscalationPlanName': '- no plan -', 'EscalationPlan': null, 'Data': {}, 'Agent': aParams });
                }
            }
        }

        mAgentsControls.RiskLevelListView.setDataSource(lRiskLevelPlans);
    }
}

function uRiskLevelPlanOrganizationIdEdit_OnChange(aSelect){
    "use strict";
    var lOrganizationId = $(aSelect).val(),
        lBuilder = new SumoPredicateBuilder(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lAgent;

    lAgent = lCard.AgentsByOrganization[lOrganizationId];
    if (!isNullOrUndefined(lAgent)) {
        setViewState('AgentsSelectedOrganization', lOrganizationId);
        lBuilder.AddNewExpressionConditional('AgentId', lAgent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mAgentsControls.RiskLevelListView.setDataSource([]);
        ReadMultiple(gObjectList.EscalationPlanRiskLevel.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsRiskLevelPlanRead_OnComplete, null, lAgent, null, 0, true);
    }
}

function agentsAgentsRiskLevelPlans_Populate() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizations = getDataItems('Organizations'),
        lBuilder = new SumoPredicateBuilder(),
        lViewState = getViewState('AgentsSelectedOrganization'),
        lOrganizationId = -1;

    if (!isNullOrUndefined(lViewState)) {
        lOrganizationId = parseInt(lViewState.Value);
    }
    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('Id', lCard.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(lOrganizations, lBuilder.RootExpression);
        populateEditView({ 'OrganizationId': lOrganizationId }, [{ 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }], {}, 'uRiskLevelPlan', 'Edit');
        uRiskLevelPlanOrganizationIdEdit_OnChange($('#uRiskLevelPlanOrganizationIdEdit'));
    }
}

function uRiskLevelListView_OnSort(aParams, aSort) {
    "use strict";
    var lRiskLevels = mAgentsControls.RiskLevelListView.getDataSource(),
    lRiskLevelsSortedList = [];

    lRiskLevelsSortedList = aSort.sort(lRiskLevels);
    mAgentsControls.RiskLevelListView.setDataSource(lRiskLevelsSortedList);
}

function agentsAgentsRiskLevelPlans_Init() {
    "use strict";
    mAgentsControls.RiskLevelListView = new sumo.controls.ListView('uRiskLevelListView', 'uRiskLevelListViewHolder', {
            'keyField': 'Id',
            'keyFieldType': 'number',
            'cssClass': 'VeritracksSelectListView',
            'selectMethod': 'none',
            'canUnselect': true
        }, [
            { 'id': 'RiskLevelName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'RiskLevelName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
            { 'id': 'EscalationPlanName', 'title': localizeWrapper('cAgentEscalationPlan'), 'dataField': 'EscalationPlanName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true }
    ]);

    mAgentsControls.RiskLevelListView.bind('selectedchanged', veritracks.security.controller.extendSession);
    //mAgentsControls.RiskLevelListView.bind('sort', uRiskLevelListView_OnSort);
    //mAgentsControls.RiskLevelListView.bind('selectedchanged', uImmediateNotificationsListView_OnSelectChange);
    agentsAgentsRiskLevelPlans_Populate();
}

function uEditRiskLevelPlanButton_OnClick() {
    "use strict";
    var lOrganizationId = $('#uRiskLevelPlanOrganizationIdEdit').val(),
        lPlans = mAgentsControls.RiskLevelListView.getDataSource(),
        lEscalationPlans = getDataItems('EscalationPlans'),
        lBuilder = new SumoPredicateBuilder(),
        lHtml = [],
        lItem,
        lKey;

    for (lKey in lPlans) {
        if (lPlans.hasOwnProperty(lKey)) {
            lItem = lPlans[lKey];
            lHtml.push('<h2>');
            lHtml.push(lItem.RiskLevelName);
            lHtml.push('</h2>');
            lHtml.push('<select id="uRiskLevelPlanEscalationPlanIdEdit');
            lHtml.push(lItem.RiskLevelId);
            lHtml.push('" style="margin: 5px 0"></select>');
        }
    }
    $('#uRiskLevelEditPanel').html(lHtml.join(''));

    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEscalationPlans = query(lEscalationPlans, lBuilder.RootExpression);
    for (lKey in lPlans) {
        if (lPlans.hasOwnProperty(lKey)) {
            lItem = lPlans[lKey];
            populateEditView(lItem.Data, [
                {
                    'Id': 'EscalationPlanId',
                    'Type': 'Dropdown',
                    'DataSource': lEscalationPlans,
                    'DataValueField': 'Id',
                    'DataTextField': 'Name',
                    'insertBlank': true,
                    'blankText': localizeText('cPleaseSelect')
                }], {}, 'uRiskLevelPlan', 'Edit' + lItem.RiskLevelId);
        }
    }

    $('#uEditRiskLevelPlanButton').hide();
	$('#uCancelRiskLevelPlanButton').show();
	$('#uCancelRiskLevelPlanButtonBlockOut').hide();
    $('#uSaveRiskLevelPlanButton').show();
    EnterEditMode('uRiskLevelPlanProfilePanel');
}

function uCancelRiskLevelPlanButton_OnClick() {
    "use strict";
    $('#uEditRiskLevelPlanButton').show();
	$('#uCancelRiskLevelPlanButton').hide();
	$('#uCancelRiskLevelPlanButtonBlockOut').show();
    $('#uSaveRiskLevelPlanButton').hide();
    ExitEditMode('uRiskLevelPlanProfilePanel');
}

function agentsAgentsRiskLevelPlansSave_OnSuccess(aParams, aData) {
    "use strict";
    var lOrganizationId = $('#uRiskLevelPlanOrganizationIdEdit').val(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lAgent;

    lAgent = lCard.AgentsByOrganization[lOrganizationId];
    uCancelRiskLevelPlanButton_OnClick();
    agentsAgentsRiskLevelPlanRead_OnComplete(lAgent, aData);
}

function uSaveRiskLevelPlanButton_OnClick() {
    "use strict";
    var lRiskLevelPlans = mAgentsControls.RiskLevelListView.getDataSource(),
        lRiskLevelPlanWrite = [],
        lRiskLevelPlan,
        lItem,
        lKey;

    $('#uCancelRiskLevelPlanButton').hide();
    $('#uSaveRiskLevelPlanButton').hide();
    for (lKey in lRiskLevelPlans) {
        if (lRiskLevelPlans.hasOwnProperty(lKey)) {
            lItem = lRiskLevelPlans[lKey];
            if (!isNullOrUndefined(lItem.EscalationPlan)) {
                lRiskLevelPlan = lItem.Data;
            } else {
                lRiskLevelPlan = new EscalationPlanRiskLevel();
                lRiskLevelPlan.AgentId = lItem.Agent.Id;
                lRiskLevelPlan.RiskLevelId = lItem.RiskLevelId;
                lRiskLevelPlan.TransactionId = moment().format("YYYYMMDDHHmmss");
            }
            populateFromEditView(lRiskLevelPlan, 'uRiskLevelPlan', 'Edit' + lItem.RiskLevelId);
            if (lRiskLevelPlan.EscalationPlanId == -1) {
                lRiskLevelPlan.IsActive = false;
            }
            if (lRiskLevelPlan.Id !== -1 || lRiskLevelPlan.IsActive) {
                lRiskLevelPlan.TransactionId = moment().format("YYYYMMDDHHmmss");
                lRiskLevelPlanWrite.push(lRiskLevelPlan);
            }
        }
    }
    if (lRiskLevelPlanWrite.length > 0) {
        WriteMultiple(lRiskLevelPlanWrite, agentsAgentsRiskLevelPlansSave_OnSuccess, null, {}, true);
    } else {
        agentsAgentsRiskLevelPlansSave_OnSuccess({}, []);
    }
}



//----------
// Off Hours
//----------
function agentsAgentsOffHours_OnComplete(aParams, aData) {
    "use strict";
    var lScheduleDisplays = [],
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lAgent,
        lSchedule,
        lKey;
    FixDates(aData);

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lSchedule = new OffHoursScheduleDisplay(aData[lKey]);
            //lAgent = getDataItem(lSchedule.AgentId, 'Agents');
            //lSchedule.StartTime = displayDateByTimeZoneId(lSchedule.StartTimeUTC, lAgent.TimeZoneId);
            //lSchedule.EndTime = displayDateByTimeZoneId(lSchedule.EndTimeUTC, lAgent.TimeZoneId);
            lScheduleDisplays.push(lSchedule);
        }
    }
    mAgentsData.OffHours = lScheduleDisplays;
    mAgentsControls.OffHoursListView.setDataSource(mAgentsData.OffHours);
}

function uOffHoursOrganizationIdEdit_OnChange(aSelect){
    "use strict";
    var lCard,
        lOrganizationId = $(aSelect).val(),
        lAgent,
        lBuilder;

    mAgentsData.OffHours = [];
    mAgentsControls.OffHoursListView.setDataSource(mAgentsData.OffHours);
    lCard = mAgentsControls.CardView.selectedDataItem();
    if (!isNullOrUndefined(lCard)) {
        setViewState('AgentsSelectedOrganization', lOrganizationId);
        lAgent = lCard.AgentsByOrganization[lOrganizationId];
        if (!isNullOrUndefined(lAgent)) {

            if (lAgent.DoNotifyDuringOffHours) {
				$('#uAddOffHourButton').show();
				$('#uAddOffHourButtonBlockOut').hide();
                $('#uDisableOffHourButton').show();
                $('#uOffHoursEnabled').show();
                $('#uEnableOffHourButton').hide();
                $('#uOffHoursDisabled').hide();
            } else {
				$('#uAddOffHourButton').hide();
				$('#uAddOffHourButtonBlockOut').show();
                $('#uDisableOffHourButton').hide();
                $('#uOffHoursEnabled').hide();
                $('#uEnableOffHourButton').show();
                $('#uOffHoursDisabled').show();
            }

            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('AgentId', lAgent.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            mAgentsControls.OffHoursListView.setDataSource([]);
            ReadMultiple(gObjectList.OffHoursSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsAgentsOffHours_OnComplete, null, {}, null, null, true);
        }
    }
}

function agentsAgentsOffHours_Populate() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizations,
        lViewState = getViewState('AgentsSelectedOrganization'),
        lOrganizationId = -1;

    if (!isNullOrUndefined(lViewState)) {
        lOrganizationId = parseInt(lViewState.Value);
    }

    if (!isNullOrUndefined(lCard)) {
        lBuilder.AddNewExpressionConditional('Id', lCard.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(getDataItems('Organizations'), lBuilder.RootExpression);
        populateEditView({ 'OrganizationId': lOrganizationId }, [
            { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
        ], {}, 'uOffHours', 'Edit');
    }
    $('#uOffHoursOrganizationIdEdit').change();
}

function uOffHoursListView_OnSelectChange(aSender, aSelected, aData) {
    "use strict";
    var lSelected = mAgentsControls.OffHoursListView.selected();
    if (isNullOrUndefined(lSelected) || lSelected.length === 0) {
		$('#uEditOffHourButton').hide();
		$('#uEditOffHourButtonBlockOut').show();
		$('#uDeleteOffHourButton').hide();
		$('#uDeleteOffHourButtonBlockOut').show();
    } else if (lSelected.length === 1) {
		$('#uEditOffHourButton').show();
		$('#uEditOffHourButtonBlockOut').hide();
		$('#uDeleteOffHourButton').show();
		$('#uDeleteOffHourButtonBlockOut').hide();
    } else {
		$('#uEditOffHourButton').hide();
		$('#uEditOffHourButtonBlockOut').show();
		$('#uDeleteOffHourButton').show();
		$('#uDeleteOffHourButtonBlockOut').hide();
    }
}

function formatOffHoursTime(aDateTime) {
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganization = getViewState('AgentsSelectedOrganization').Value,
        lTimeZone,
        lAgent,
        lResult = '';

    if (lOrganization) {
        lAgent = lCard.AgentsByOrganization[lOrganization];
        lTimeZone = getDataItem(lAgent.TimeZoneId, 'TimeZone');
        lResult = displayTime(convertMomentFromStringTimezone(aDateTime, lTimeZone.TimeZoneName));
    }

    return lResult;
}

function agentsAgentsOffHours_Init() {
    "use strict";
    if (isNullOrUndefined(mAgentsControls.OffHoursListView)) {
        mAgentsControls.OffHoursListView = new sumo.controls.ListView('uOffHoursListView', 'uOffHoursListViewHolder', {
                'keyFieldType': 'number',
                'cssClass': 'VeritracksSelectListView',
                'selectMethod': 'auto',
                'canUnselect': true
        }, [
                        { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
                { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
                { 'id': 'StartTime', 'title': localizeWrapper('cAnalysisStart'), 'dataField': 'StartTimeUTC', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatOffHoursTime },
                { 'id': 'EndTime', 'title': localizeWrapper('cAnalysisEnd'), 'dataField': 'EndTimeUTC', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatOffHoursTime },
                { 'id': 'IsSunday', 'title': localizeWrapper('cSundayLetter'), 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsMonday', 'title': localizeWrapper('cMondayLetter'), 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsTuesday', 'title': localizeWrapper('cTuesdayLetter'), 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsWednesday', 'title': localizeWrapper('cWednesdayLetter'), 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsThursday', 'title': localizeWrapper('cThursdayLetter'), 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsFriday', 'title': localizeWrapper('cFridayLetter'), 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
                { 'id': 'IsSaturday', 'title': localizeWrapper('cSaturdayLetter'), 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false }
        ]);
        mAgentsControls.OffHoursListView.bind('selectedchanged', veritracks.security.controller.extendSession, null);
        mAgentsControls.OffHoursListView.bind('selectedchanged', uOffHoursListView_OnSelectChange, null);
        mAgentsControls.OffHoursListView.bind('databind', uOffHoursListView_OnSelectChange, null);
        agentsAgentsOffHours_Populate();
    }
}

function uOffHoursFullDayCheckbox_OnChange(aCheckbox) {
    "use strict";
    var lIsDisabled = $(aCheckbox).is(':checked');
    $('#uOffHoursStartTimeEdit').val('12:00 AM').attr('disabled', lIsDisabled);
    $('#uOffHoursEndTimeEdit').val('11:59 PM').attr('disabled', lIsDisabled);
}

function uOffHoursScheduleTypeEdit_OnChange(aSelect) {
    "use strict";
    var lValue = aSelect.options[aSelect.selectedIndex].value;
    document.getElementById('uIsNoSchedule').checked = false;
    if (lValue === "true") {
        $('.OverrideSchedule').hide('fast', function () {
            $('.StandardSchedule').show();
            $('#uDayOfWeekHolder').addClass('ValidateCheckboxList');
        });
    } else {
        $('.StandardSchedule').hide('fast', function () {
            $('.OverrideSchedule').show();
            $('#uDayOfWeekHolder').removeClass('ValidateCheckboxList');
        });
    }
}

function agentsAgentsOffHoursPopup_OnComplete() {
    "use strict";
    var lSchedule = mAgentsData.OffHoursEditItem;
    if (!isNullOrUndefined(lSchedule)) {
        populateEditView(lSchedule, [], { 'StartTime': timeFieldFormatter, 'EndTime': timeFieldFormatter, 'Name':veritracks.system.decodeHtml }, 'uOffHours', 'Edit');
        populateEditView(lSchedule, [], { 'StartTime': displayShortDate, 'EndTime': displayShortDate }, 'uOffHours', 'DateEdit');

        document.getElementById('uScheduleRecurrenceSunday').checked = lSchedule.IsSunday;
        document.getElementById('uScheduleRecurrenceMonday').checked = lSchedule.IsMonday;
        document.getElementById('uScheduleRecurrenceTuesday').checked = lSchedule.IsTuesday;
        document.getElementById('uScheduleRecurrenceWednesday').checked = lSchedule.IsWednesday;
        document.getElementById('uScheduleRecurrenceThursday').checked = lSchedule.IsThursday;
        document.getElementById('uScheduleRecurrenceFriday').checked = lSchedule.IsFriday;
        document.getElementById('uScheduleRecurrenceSaturday').checked = lSchedule.IsSaturday;
        mAgentsControls.OffHoursValidator = new Validator('uOffHoursPopupPanel', mRegexValidation);
        $('.ValidateOnClick').click(function () {
            mAgentsControls.OffHoursValidator.IsValid();
        });

        populateDateView('#uOffHoursStartTimeDateEdit', function () { });
        //populateDateView('#uOffHoursEndTimeDateEdit', function () {  });
        $('.TimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true
        });
    }
    var lTypes = [];

    lTypes.push(new Option(localizeText('cEnrolleeReoccurring'), true));
    lTypes.push(new Option(localizeText('cEnrolleeOverride'), false));

    $('#uOffHoursScheduleTypeEdit').append(lTypes);

    $('#uOffHoursScheduleTypeEdit').val(lSchedule.IsRecurring.toString());
    $('#uOffHoursScheduleTypeEdit').change();
}

function agentsAgentsOffHoursSave_OnSuccess(aParams, aData) {
    "use strict";
    ClosePopup();
    $('#uOffHoursOrganizationIdEdit').change();
}

function agentsAgentsOffHoursSave_OnClick() {
    "use strict";
    var lStart = new Date($('#uOffHoursStartTimeDateEdit').val() + ' ' + $('#uOffHoursStartTimeEdit').val()),
        lEnd = new Date($('#uOffHoursStartTimeDateEdit').val() + ' ' + $('#uOffHoursEndTimeEdit').val()),
        lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizationId = $('#uOffHoursOrganizationIdEdit').val(),
        lAgent = lCard.AgentsByOrganization[lOrganizationId],
        lTimeZone = getTimezone(lAgent.TimeZoneId, 'TimeZone'),
        lSchedule = mAgentsData.OffHoursEditItem,
        lScheduleList = [],
        lWrapSchedule;

    if (mAgentsControls.OffHoursValidator.IsValid()) {
        populateFromEditView(lSchedule, 'uOffHours', 'Edit');
        lSchedule.StartTime = lStart;
        lSchedule.EndTime = lEnd;
        lSchedule.IsNoSchedule = document.getElementById('uIsNoSchedule').checked;
        lSchedule.IsRecurring = ($('#uOffHoursScheduleTypeEdit').val() === 'true');
        lSchedule.AgentId = lAgent.Id;

        if (lSchedule.IsRecurring) {
            lSchedule.IsSunday = document.getElementById('uScheduleRecurrenceSunday').checked;
            lSchedule.IsMonday = document.getElementById('uScheduleRecurrenceMonday').checked;
            lSchedule.IsTuesday = document.getElementById('uScheduleRecurrenceTuesday').checked;
            lSchedule.IsWednesday = document.getElementById('uScheduleRecurrenceWednesday').checked;
            lSchedule.IsThursday = document.getElementById('uScheduleRecurrenceThursday').checked;
            lSchedule.IsFriday = document.getElementById('uScheduleRecurrenceFriday').checked;
            lSchedule.IsSaturday = document.getElementById('uScheduleRecurrenceSaturday').checked;
        } else {
            lSchedule.IsSunday = lSchedule.StartTime.getDay() === 0;
            lSchedule.IsMonday = lSchedule.StartTime.getDay() === 1;
            lSchedule.IsTuesday = lSchedule.StartTime.getDay() === 2;
            lSchedule.IsWednesday = lSchedule.StartTime.getDay() === 3;
            lSchedule.IsThursday = lSchedule.StartTime.getDay() === 4;
            lSchedule.IsFriday = lSchedule.StartTime.getDay() === 5;
            lSchedule.IsSaturday = lSchedule.StartTime.getDay() === 6;
        }
        lScheduleList.push(lSchedule);
        if (lSchedule.EndTime < lSchedule.StartTime) {
            lWrapSchedule = $.extend({}, lSchedule);
            lWrapSchedule.StartTime = new Date(lWrapSchedule.StartTime);
            lWrapSchedule.EndTime = new Date(lWrapSchedule.EndTime);

            lWrapSchedule.Name += ' Early';
            lWrapSchedule.StartTime.setHours(0);
            lWrapSchedule.StartTime.setMinutes(0);
            lSchedule.Name += ' Late';
            lSchedule.EndTime.setHours(23);
            lSchedule.EndTime.setMinutes(59);

            lWrapSchedule.StartTime = convertTimeToUTC(lWrapSchedule.StartTime, lTimeZone.TimeZoneName);
            lWrapSchedule.EndTime = convertTimeToUTC(lWrapSchedule.EndTime, lTimeZone.TimeZoneName);

            lScheduleList.push(lWrapSchedule);
        }
        lSchedule.StartTime = convertTimeToUTC(lSchedule.StartTime, lTimeZone.TimeZoneName);
        lSchedule.EndTime = convertTimeToUTC(lSchedule.EndTime, lTimeZone.TimeZoneName);
        // Vulnerability 3252
        lSchedule.Name = veritracks.system.encodeHtml(lSchedule.Name);
        
        WriteMultiple(lScheduleList, agentsAgentsOffHoursSave_OnSuccess, null, {}, true);
    }

}

function agentsAgentsOffHoursPopup_Init(aTitleBar) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();

    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsAgentsOffHoursSave_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(aTitleBar, '<div id="uOffHoursPopupPanel"></div>', lButtonCommandBar, true);
    populateElement('uOffHoursPopupPanel', 'Agents.Agents.OffHours.Dialog.htm', agentsAgentsOffHoursPopup_OnComplete);
}

function uAddOffHourButton_OnClick() {
    "use strict";
    mAgentsData.OffHoursEditItem = new OffHoursSchedule();
    agentsAgentsOffHoursPopup_Init(localizeWrapper('cAgentAddOffHours'));
}

function uEditOffHourButton_OnClick() {
    "use strict";
    var lTimeZone;
    var lAgent = mAgentsControls.CardView.selectedDataItem();
    var lOrganizationId = $('#uOffHoursOrganizationIdEdit').val();
    if (lAgent) {
        lTimeZone = getDataItem(lAgent.AgentsByOrganization[lOrganizationId].TimeZoneId, 'TimeZone');
    }
    mAgentsData.OffHoursEditItem = $.extend({}, mAgentsControls.OffHoursListView.selectedDataItem()[0]);
    mAgentsData.OffHoursEditItem.StartTime = displayFixedTimeZoneTime(mAgentsData.OffHoursEditItem.StartTime, lTimeZone.TimeZoneName);
    mAgentsData.OffHoursEditItem.EndTime = displayFixedTimeZoneTime(mAgentsData.OffHoursEditItem.EndTime, lTimeZone.TimeZoneName);
    mAgentsData.OffHoursEditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
    agentsAgentsOffHoursPopup_Init(localizeWrapper('cAgentEditOffHours'));
}

function uDeleteOffHourButton_OnClick() {
    "use strict";
    var lSelect = mAgentsControls.OffHoursListView.selectedDataItem(),
        lOffHoursWrite = [],
        lItem,
        lKey;

    if (!isNullOrUndefined(lSelect)) {
        for (lKey in lSelect) {
            if (lSelect.hasOwnProperty(lKey)) {
                lItem = $.extend({}, lSelect[lKey]);
                lItem.IsActive = false;
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                lOffHoursWrite.push(prepareObjectForWcf(lItem));
            }
        }
    }
    if (lOffHoursWrite.length > 0) {
        WriteMultiple(lOffHoursWrite, agentsAgentsOffHoursSave_OnSuccess, null, {}, true);
    }
}

function agentsAgentsOffHoursChangeNotification_OnSuccess(aParams, aData) {
    "use strict";
    var lSelected = mAgentsControls.CardView.selected();
    setDataItem(aData.Id, 'Agents', aData);
    agentsDataListConverter();
    mAgentsControls.CardView.bind('databind', agentsUserWrite_OnRender, lSelected);
    mAgentsControls.CardViewFilter.filter();
}

function agentsAgentsOffHoursChangeNotification(aDoNotifyDuringOffHours) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lOrganizationId = $('#uOffHoursOrganizationIdEdit').val(),
        lAgent;

    if (!isNullOrUndefined(lCard)) {
        lAgent = lCard.AgentsByOrganization[lOrganizationId];
        if (!isNullOrUndefined(lAgent)) {
            lAgent = $.extend({}, lAgent);
            lAgent.DoNotifyDuringOffHours = aDoNotifyDuringOffHours;
            WriteSingle(lAgent, agentsAgentsOffHoursChangeNotification_OnSuccess, null, null, true);
        }
    }
}

function uDisableOffHourButton_OnClick() {
    "use strict";
    agentsAgentsOffHoursChangeNotification(false);
}

function uEnableOffHourButton_OnClick() {
    "use strict";
    agentsAgentsOffHoursChangeNotification(true);
}

































//-----------------
// Escalation Plans
//-----------------
function agentsNotificationEscalationPlanItems_OnComplete(aParams, aData) {
    "use strict";
    var lList = [],
        lItem,
        lKey;

    mAgentsData.EscalationPlanItemList = aData;
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            if (lItem.IsActive === true) {
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                lItem.data = lItem;
                lList.push(lItem);
            }
        }
    }
    mAgentsControls.EscalationPlanListView.setDataSource(lList);
}

function agentsNotificationEscalationPlans_Init() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression();

    if (!isNullOrUndefined(lCard)) {
        PopulateDetailView(lCard.Plan, { 'IsShared': displayBoolean, 'OrganizationId': OrganizationNameFormatter }, 'uEscalationPlan');
        mAgentsData.EscalationPlanItemList = [];
        if (!isNullOrUndefined(mAgentsControls.EscalationPlanListView)) {
            mAgentsControls.EscalationPlanListView.setDataSource([]);
            uEscalationPlanListView_OnSelectChange();

            lBuilder.AddNewExpressionConditional('EscalationPlanId', lCard.EscalationPlanId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lSort.addAscendingColumn('SortOrder');
            ReadMultiple(gObjectList.EscalationPlanItem.AssemblyQualifiedName, lBuilder.RootExpression, 0, agentsNotificationEscalationPlanItems_OnComplete, null, {}, lSort, 0, true);
        }
    }
}

function uCancelEscalationPlanButton_OnClick(aResetList) {
    "use strict";
    var lIsEmpty,
        lClass = 'Agents';
    $('#uAddEscalationPlanButton').show();
    $('#uEditEscalationPlanButton').show();
    $('#uSaveEscalationPlanButton').hide();
    $('#uCancelEscalationPlanButton').hide();
    ExitEditMode('uEscalationPlanProfilePanel');
    resetContentHoldersAgents();
    if (aResetList || aResetList === 'true') {
        agentsNotificationEscalationPlanItems_OnComplete({}, mAgentsData.EscalationPlanItemList);
    }
    lIsEmpty = (mAgentsData.EscalationPlansDirty.length === 0);
    lClass += mStateManager.Settings()[0];
    veritracks.system.applyFilterState(lClass, lIsEmpty);

}

function uAddEscalationPlanButton_OnClick() {
    "use strict";
    mAgentsData.PlanEditItem = new EscalationPlan();
    populateEditView(mAgentsData.PlanEditItem, [
        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
    ], {}, 'uEscalationPlan', 'Edit');
    $('#uAddEscalationPlanButton').hide();
    $('#uEditEscalationPlanButton').hide();
    $('#uSaveEscalationPlanButton').show();
    $('#uCancelEscalationPlanButton').show();
    EnterEditMode('uEscalationPlanProfilePanel');
    resetContentHoldersAgents();
    mAgentsControls.Validator = new Validator('uEscalationPlanProfilePanel', mRegexValidation);
    mAgentsControls.EscalationPlanListView.setDataSource([]);
    $('#uEscalationPlanProfilePanel').show();

}

function uEditEscalationPlanButton_OnClick() {
    "use strict";
    mAgentsData.PlanEditItem = mAgentsControls.CardView.selectedDataItem().Plan;
    populateEditView(mAgentsData.PlanEditItem, [
        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
    ], {}, 'uEscalationPlan', 'Edit');
    $('#uAddEscalationPlanButton').hide();
    $('#uEditEscalationPlanButton').hide();
    $('#uSaveEscalationPlanButton').show();
    $('#uCancelEscalationPlanButton').show();
    EnterEditMode('uEscalationPlanProfilePanel');
    resetContentHoldersAgents();
    mAgentsControls.Validator = new Validator('uEscalationPlanProfilePanel', mRegexValidation);
}

function agentsEscalationPlanItemsWrite_OnSuccess(aParams, aData) {
    "use strict";
    setDataItem(aParams.Id, 'EscalationPlans', aParams);
    agentsEscalationPlansDataListConverter();
    mAgentsControls.CardViewFilter.filter();
    uCancelEscalationPlanButton_OnClick(false);
}

function agentsEscalationPlansWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lCurrentItems = mAgentsControls.EscalationPlanListView.getDataSource(),
        lWritePrep = [],
        lWrite = [],
        lWriteItem,
        lItem,
        lKey;

    for (lKey in mAgentsData.EscalationPlanItemList) {
        if (mAgentsData.EscalationPlanItemList.hasOwnProperty(lKey)) {
            lItem = mAgentsData.EscalationPlanItemList[lKey];
            lWriteItem = $.extend({},lItem);
            lWriteItem.IsActive = false;
            lWriteItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            lWritePrep[lWriteItem.Id] = lWriteItem;
        }
    }

    for (lKey in lCurrentItems) {
        if (lCurrentItems.hasOwnProperty(lKey)) {
            lItem = lCurrentItems[lKey];
            lWriteItem = $.extend({}, lItem);
            lWriteItem.SortOrder = lKey;
            lWriteItem.EscalationPlanId = aData.Id;
            lWriteItem.TransactionId = moment().format("YYYYMMDDHHmmss");
            lWrite.push(lWriteItem);

            if (lItem.Id !== -1) {
                lWriteItem.IsActive = true;
                lWritePrep[lWriteItem.Id] = null;
            }
        }
    }

    for (lKey in lWritePrep) {
        if (lWritePrep.hasOwnProperty(lKey)) {
            lItem = lWritePrep[lKey];
            if (!isNullOrUndefined(lItem)) {
                lItem.TransactionId = moment().format("YYYYMMDDHHmmss");
                lWrite.push(lItem);
            }
        }
    }

    WriteMultiple(lWrite, agentsEscalationPlanItemsWrite_OnSuccess, null, aData, true);
}

function uSaveEscalationPlanButton_OnClick() {
    "use strict";
    if (mAgentsControls.Validator.IsValid()) {
        $('#uSaveEscalationPlanButton').hide();
        $('#uCancelEscalationPlanButton').hide();
        populateFromEditView(mAgentsData.PlanEditItem, 'uEscalationPlan', 'Edit');
        mAgentsData.PlanEditItem.IsShared = $('#uEscalationPlanIsSharedEdit').is(':checked');
        mAgentsData.PlanEditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        WriteSingle(mAgentsData.PlanEditItem, agentsEscalationPlansWrite_OnSuccess, null, {}, true);
    }
}

function agentsEscalationPlansPopup_OnComplete(aItem) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lContactTypes = [{ 'Id': 1, 'Value': localizeText('cAgentPrimaryEmail') }, { 'Id': 2, 'Value': localizeText('cAgentSecondaryEmail') }],
        lOrganizationId = $('#uEscalationPlanOrganizationIdEdit').val(),
        lCurrentAgents = mAgentsControls.EscalationPlanListView.getDataSource(),
        lCurrentAgentIds = [],
        lAgents,
        lItem,
        lKey;

    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    for (lKey in lCurrentAgents) {
        if (lCurrentAgents.hasOwnProperty(lKey)) {
            lItem = lCurrentAgents[lKey];
            lCurrentAgentIds.push(lItem.Id);
        }
    }
    if (lCurrentAgentIds.length > 0) {
        lBuilder.AddNewExpressionConditional('Id', lCurrentAgentIds, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    }
    lAgents = query(getDataItems('Agents'), lBuilder.RootExpression);

    populateEditView(aItem, [
        { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': AgentsSortFormatter(lAgents), 'DataValueField': 'Id', 'DataTextField': 'FullName', 'isNullableKey': false },
        { 'Id': 'ContactTypeId', 'Type': 'Dropdown', 'DataSource': lContactTypes, 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': false }
    ], {}, 'uEscalationPlanItem', 'Edit');

    $('#uEscalationPlanItemAgentIdEdit').change()
}

$('#uEscalationPlanItemAgentIdEdit').live('change', function (a) {
    var lAgent = getDataItem($('#uEscalationPlanItemAgentIdEdit').val(), 'Agents');
    var t = $('#uEscalationPlanItemContactTypeIdEdit')[0];

    $('#uEscalationPlanItemContactTypeIdEdit').empty();

    var lFirstValue = lAgent.FirstContactName || 'First Contact';
    var lSecondValue = lAgent.SecondContactName || 'Second Contact';
    var lThirdValue = lAgent.ThirdContactName || 'Third Contact';

    if (lAgent.FirstContactMethodId == 2 && lFirstValue) {
        t.options.add(new Option(lFirstValue, 1, false, false))
    }
    if (lAgent.SecondContactMethodId == 2 && lSecondValue) {
        t.options.add(new Option(lSecondValue, 2, false, false))
    }
    //if (lAgent.ThirdContactMethodId == 2 && lThirdValue) {
    //    t.options.add(new Option(lThirdValue, 3, false, false))
    //}
    if (t.options.length == 0) {
        t.options.add(new Option('Please Select a Value', -1, false, true))
    }
})


function agentsNotificationEscalationPlansAdd_OnClick() {
    "use strict";
    var lItem = new EscalationPlanItem(),
        lAgents = mAgentsControls.EscalationPlanListView.getDataSource();
    populateFromEditView(lItem, 'uEscalationPlanItem', 'Edit');
    lItem.data = lItem;
    lAgents.push(lItem);
    mAgentsControls.EscalationPlanListView.setDataSource(lAgents);
    ClosePopup();
}

function uAddEscalationPlanItemButton_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        lItem = new EscalationPlanItem();

    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'agentsNotificationEscalationPlansAdd_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentAddAgent'), '<div id="uNotificationEscalationPlansPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uNotificationEscalationPlansPopupPanel', 'Agents.NotificationEscalationPlans.Details.Popup.Layout.htm', function () { agentsEscalationPlansPopup_OnComplete(lItem); });
}

function uEscalationPlanListView_OnSelectChange(aSender, aIndex, aParams) {
    "use strict";
    var lLength;
    if (!isNullOrUndefined(aIndex)) {
        $('.MoveButton').show();
        $('#uRemoveEscalationPlanItemButton').show();
        lLength = mAgentsControls.EscalationPlanListView.getDataSource().length;
        if (aIndex == 0) {
            $('#uMoveUpEscalationPlanItemButton').hide();
        } else if (aIndex == (lLength - 1)) {
            $('#uMoveDownEscalationPlanItemButton').hide();
        }
    } else {
        $('#uRemoveEscalationPlanItemButton').hide();
        $('.MoveButton').hide();
    }

    //uCancelEscalationPlanButton_OnClick();

}

function uMoveEscalationPlanItemButton_OnSuccess(aSender, aData, aParams) {
    "use strict";
    aSender.unbind('databind', uMoveEscalationPlanItemButton_OnSuccess);
    aSender.selected(aParams);
}

function uMoveUpEscalationPlanItemButton_OnClick() {
    "use strict";
    var lSelectedIndex = mAgentsControls.EscalationPlanListView.selected(),
        lAgents = mAgentsControls.EscalationPlanListView.getDataSource(),
        lNewIndex = lSelectedIndex - 1;
    lAgents.move(lSelectedIndex, lNewIndex);
    mAgentsControls.EscalationPlanListView.bind('databind', uMoveEscalationPlanItemButton_OnSuccess, lNewIndex);
    mAgentsControls.EscalationPlanListView.setDataSource(lAgents);
}

function uMoveDownEscalationPlanItemButton_OnClick() {
    "use strict";
    var lSelectedIndex = mAgentsControls.EscalationPlanListView.selected(),
        lAgents = mAgentsControls.EscalationPlanListView.getDataSource(),
        lNewIndex = lSelectedIndex + 1;
    lAgents.move(lSelectedIndex, lNewIndex);
    mAgentsControls.EscalationPlanListView.bind('databind', uMoveEscalationPlanItemButton_OnSuccess, lNewIndex);
    mAgentsControls.EscalationPlanListView.setDataSource(lAgents);
}

function uRemoveEscalationPlanItemButton_OnClick() {
    "use strict";
    var lSelectedIndex = mAgentsControls.EscalationPlanListView.selected(),
        lAgents = mAgentsControls.EscalationPlanListView.getDataSource(),
        lList = [],
        lKey;

    for (lKey in lAgents) {
        if (lAgents.hasOwnProperty(lKey) && lKey != lSelectedIndex) {
            lList.push(lAgents[lKey]);
        }
    }

    mAgentsControls.EscalationPlanListView.setDataSource(lList);
}

//---------------------
// Edit Data Population
//---------------------
function PopulateOrganizationDropdown(aId, aBaseElementId, aIsMultiple) {
    "use strict";
    var lBaseElement = $('#' + aBaseElementId),
        lSelect = $('<select/>', {
            'id': aId
        }),
        lOption,
        lOrganizations = getDataItems('Organizations'),
        lKey;

    lOrganizations = OrganizationSortFormatter(lOrganizations);
    if (typeof aIsMultiple !== 'undefined' && aIsMultiple) {
        lOption = $('<option/>', {
            'text': '[multiple selected]',
            'value': '-1'
        });
        lOption.appendTo(lSelect);
    }
    for (lKey in lOrganizations) {
        if (lOrganizations.hasOwnProperty(lKey)) {
            var lOrganization = lOrganizations[lKey];
            lOption = $('<option/>', {
                'text': lOrganization.Name,
                'value': lOrganization.Id
            });
            lOption.appendTo(lSelect);
        }
    }
    lBaseElement.html('');
    lSelect.appendTo(lBaseElement);
}

//function AgentUniversalSearchGenerator(aDataItem) {
//    return aDataItem.FullName + ' (' + aDataItem.UserName + ')';
//}

function setUserPermissions(lUser, aData) {
    var lKey,
        lItem,
        availablePermissions = [4, 5, 12, 13, 21];
    mAgentsData.UserPermissions = [];
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            if (lUser.UserRoleValueTypeId === 2) {
                if ($.inArray(lItem.PermissionId, availablePermissions) === -1) {
                    lItem.Value = 0;
                }
            }
            mAgentsData.UserPermissions[lItem.PermissionId] = lItem;
        }
    }
};

function updateAgentResetPassword_OnSuccess(aParams, aData) {
    "use strict";
    $("#uAgenUserPassword").val('');
    $("#uConfirmAgentUserPassword").val('');
    $("#uAgenUserPassword").removeClass("ValidateError");
    $("#uAgenUserPassword").removeClass("ValidateSuccess");
    $("#uConfirmAgentUserPassword").removeClass("ValidateError");
    $("#uConfirmAgentUserPassword").removeClass("ValidateSuccess");
    $("#uAgentUserPasswordReset").click();
    $("#uAgentResetPasswordError").hide();
    uResetAgentPasswordButton_OnClick(true);

}

function generateAgentPassword_OnSuccess(aParams, aData) {
    "use strict";
    //  updateAgentResetPassword_OnSuccess();
    if (aData == -2) {
        $('#uPasswordUpdateError').show();
        mActivityNotification.addNotification('Password has previously been used');
    } else {
        $('#uPasswordUpdateSuccess').show();
        mActivityNotification.addNotification(localizeWrapper('cAgentSendEmailAgent') + aParams.FirstName + " " + aParams.LastName);
    }
}


function onAgentResetPasswordFail(aParams,aData) {
    "use strict";

}

function uResetGenerateAgentPassword() {
    "use strict";
    var lUserData = mAgentsControls.CardView.selectedDataItem(),
        lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lTempPassword = $("#uAgenUserPassword").val(),
        lConfirmPassword = $("#uConfirmAgentUserPassword").val();
    var lUser = GetUser(lUserData.UserId);
    var lStrength = getPasswordStrength(lConfirmPassword, lUser);


    $('#uPasswordUpdateSuccess').hide();
    $('#uPasswordUpdateError').hide();
    $('#uPasswordError').hide();

    if (!isNullOrUndefined(lUserData)) {
        if (lTempPassword != "" && lConfirmPassword != "" && lStrength <= 2) {
            mActivityNotification.addNotification('Password not strong enough');
            return;
        }
        if ((lTempPassword == '' && lConfirmPassword == '') || mAgentsControls.PasswordValidator.IsValid()) {
            var lData = {'aSecurityToken': lSecurityToken, 'aSecurityContextId': -1, 'aUserId': lUserData.UserId,'aId':lUserData.User.IdToken, 'aNewPassword': lTempPassword
            };
            callAjax('AgentResetPassword', lData, generateAgentPassword_OnSuccess, onAgentResetPasswordFail, lUserData);
        } else {
            $("#uAgentResetPasswordError").show();
        }//end of if
    }//end of outer if
}

function uResetAgentPasswordButton_OnClick(isHidable) {
    "use strict";
    var aValue = $("#uAgentUserPasswordReset").prop('checked');
    if (aValue == false || isHidable) {
        $("#uAgentUserPasswordResetHolder").hide();
        if (!isNullOrUndefined(mAgentsControls.PasswordValidator)) {
            mAgentsControls.PasswordValidator.dispose();
            mAgentsControls.PasswordValidator = null;
            $("#uAgenUserPassword").removeClass("Validate");
            $("#uAgenUserPassword").removeClass("ValidatePassword");
            $("#uConfirmAgentUserPassword").removeClass("Validate");
            $("#uConfirmAgentUserPassword").removeClass("ValidatePasswordMatch");
        }//end of if

        $("#uAgenUserPassword").val('');
        $("#uConfirmAgentUserPassword").val('');
    } else {
        $("#uAgentUserPasswordResetHolder").show();
        if (isNullOrUndefined(mAgentsControls.PasswordValidator)) {
            $("#uAgenUserPassword").addClass("Validate");
            $("#uAgenUserPassword").addClass("ValidatePassword");
            $("#uConfirmAgentUserPassword").addClass("Validate");
            $("#uConfirmAgentUserPassword").addClass("ValidatePasswordMatch");
            //mAgentsControls.PasswordValidator = new Validator("uAgentResetPasswordTable", mRegexValidation);
            //mAgentsControls.PasswordValidator.scan();
        } //end of if
    }//end end if if

}

function uAgentUnlockAccount() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lUnlock = new UserUnlock(lCard.UserId);

    WriteSingle(lUnlock, AgenUnlock_OnSuccess, Sad, lCard.UserId, true);
}

function AgenUnlock_OnSuccess(aParams, aData) {
    "use strict";
    var lUser = GetUser(aParams);

    lUser.AccountStatus = "OPEN";
    WriteSingle(lUser, null, null, null, false);

    $('#uAccountUnlockSuccess').show();
    mActivityNotification.addNotification('Account Unlocked');
}

function uEditAgentCredentialsButton_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lUser = GetUser(lCard.UserId);

    if (!lUser) {
        mActivityNotification.addNotification('No user selected');
        return;

    }
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup("Edit Credentials", "<div id='EditUserCredentials'></div>", lButtonBar, false, false);
    populateElement('EditUserCredentials', 'Agents.Agents.Credentials.Layout.htm', function () {
        var lCard = mAgentsControls.CardView.selectedDataItem();
        var lUser = GetUser(lCard.UserId);

        populateEditView({}, [
        { 'Id': 'SecurityQuestionId', 'Type': 'Dropdown', 'DataSource': getDataItems('SecurityQuestions'), 'LocaleName': 'SecurityQuestion', 'DataValueField': 'Id', 'DataTextField': 'Value', 'isNullableKey': true }
        ], {}, 'uUserDetails', 'Edit', localizeDataItem);

        if (lUser.AccountStatus == "LOCKED") {
            $('#uAgentAccountLocked').show();
        }
        if (mAgentsData.TargetIsMe || lCard.UserId == gUserDetails.UserId) {
            mAgentsControls.PasswordValidator = new Validator("uMyAccountCredentials", mRegexValidation);
            $('#AdministratorCredentialAccess').remove();
            $('#uMyAccountCredentials').show();
            if (gUserDetails.PasswordPolicy) {
                hideScoreCard('MyAccountUpdatePassword');
            } else {
                $('.PasswordPolicyStrength').hide();
                $('.MyAccountUpdatePassword').hide();
            }
        } else {
            mAgentsControls.PasswordValidator = new Validator("AdministratorCredentialAccess", mRegexValidation);
            $('#uMyAccountCredentials').remove();
            $('#AdministratorCredentialAccess').show();
            if (lUser.PasswordPolicy) {
                hideScoreCard('AdminUpdatePassword');
            } else {
                $('.PasswordPolicyStrength').hide();
                $('.AdminUpdatePassword').hide();
            }
        }
        $('#uUserDetailsUserName').text(lCard.UserName);
        $('#uAgenUserPassword').bind('paste', AdminPasswordUpdate_OnPaste);
        $('#uUserDetailsPasswordEdit').bind('paste', AdminPasswordUpdate_OnPaste);
    });
}

function AdminPasswordUpdate_OnPaste() {
    setTimeout(function () {
        AdminPasswordUpdate_OnKeyUp();
    }, 100);
}

function AdminPasswordUpdate_OnKeyUp() {
    var lPassword = $('#uAgenUserPassword').val();
    var lUserData = mAgentsControls.CardView.selectedDataItem();
    var lUser = GetUser(lUserData.UserId);
    showScoreCard('AdminUpdatePassword', getPasswordStrength(lPassword, lUser));
}

function MyAgentPasswordUpdate_OnPaste() {
    setTimeout(function () {
        MyAgentPasswordUpdate_OnKeyUp();
    }, 100);
}
function MyAgentPasswordUpdate_OnKeyUp() {
    var lPassword = $('#uUserDetailsPasswordEdit').val();
    showScoreCard('MyAccountUpdatePassword', getPasswordStrength(lPassword));
}

function uUpdateMyAgentsPassword() {
    "use strict";
    var lCurrentPassword = $('#uUserDetailsCurrentPasswordEdit').val();
    var lNewPassword = $('#uUserDetailsPasswordEdit').val();
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lStrength = getPasswordStrength(lNewPassword);

    $('#uPasswordUpdateSuccess').hide();
    $('#uPasswordUpdateError').hide();
    $('#uPasswordError').hide();
    if (lNewPassword == "" || lCurrentPassword == "") {
        mActivityNotification.addNotification('Password information missing.');
        return;
    }
    if (lCurrentPassword != lNewPassword && lStrength >= 3) {
        WriteUserPassword(lCard.UserId, lCurrentPassword, lNewPassword, uUpdateMyAgentsPassword_OnSuccess, Sad, null);
    } else {
        if (lStrength <= 1) {
            mActivityNotification.addNotification('Password not strong enough');
        } else {
            mActivityNotification.addNotification('New Password is the same as old password');
        }
    }
}

function uUpdateMyAgentsPassword_OnSuccess(aParams, aData) {
    "use strict";
    if (aData == 0) {
        $('#uPasswordError').show();
        mActivityNotification.addNotification('Error occured with password update, please check your current password.');
    }
    if (aData == -2) {
        $('#uPasswordUpdateError').show();
        mActivityNotification.addNotification('Password has previously been used');
    } else if(aData == 1) {
        $('#uPasswordUpdateSuccess').show();
        FadeOutAccountExpire();
        mActivityNotification.addNotification('Password updated');
    }
}

function uUpdateAgentSecurityAnswer() {
    "use strict";
    var lUserSecurityAnswer = new UserSecurityAnswer();
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lAnswer = $('#uUserDetailsSecurityAnswerEdit').val();
    var lQuestion = parseInt($('#uUserDetailsSecurityQuestionIdEdit').val());
    var lUser = lCard.User;

    if (lAnswer && lQuestion != -1) {
        lUser.SecurityQuestionId = lQuestion;
        WriteSingle(lUser, UpdateMySecurityAnswer, Sad, null, true);
    } else {
        mActivityNotification.addNotification('Missing security information');
    }
}

function UpdateMySecurityAnswer(aParams, aData) {
    "use strict";
    var lUserSecurityAnswer = new UserSecurityAnswer();
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lAnswer = $('#uUserDetailsSecurityAnswerEdit').val();
    var lQuestion = parseInt($('#uUserDetailsSecurityQuestionIdEdit').val());

    if (aData) {
        lUserSecurityAnswer.UserId = lCard.UserId;
        lUserSecurityAnswer.SecurityQuestionId = lQuestion;
        lUserSecurityAnswer.SecurityAnswer = lAnswer;
        WriteSingle(lUserSecurityAnswer, UserSecurityAnswerUpdate_OnSuccess, null, [], true);
    }
}

function UserSecurityAnswerUpdate_OnSuccess(aParams, aData) {
    "use strict";
    $('#uSecurityUpdateSuccess').show();
    mActivityNotification.addNotification('Security information updated');
}

function uEditAgentSettingsButton_OnClick() {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lUser = GetUser(lCard.UserId);

    if (!lUser) {
        mActivityNotification.addNotification('No user selected');
        return;
    }
    if (lUser.Id != gUserDetails.UserId) {
        mActivityNotification.addNotification('Not your user');
        return;
    }

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'SaveAgentUserPreferences()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup("Edit Settings", "<div id='EditUserSettings'></div>", lButtonBar, false, false);
    populateElement('EditUserSettings', 'Agents.Agents.Settings.Layout.htm', function () {
        EnterEditMode('EditUserSettings');
        $('#EditUserSettings').show();
        populateExtraAccountSettings();
    });
}

function populateExtraAccountSettings() {
    var lPreferences = getUserPreferences(4),
        lSMSOptions = [{ 'Id': -1, 'Name': localizeText('cAgentNotEnabled') }],
        lSMSOptInEnabled = veritracks.system.clientSetting('SMSoptinflag'),
        lPasswordPolicyEnabled = veritracks.system.clientSetting('passwordpolicyenable'),
        lSMSField = $('#smsOptInOptions'),
        lSelRoles = $('#selRoles'),
        lPreference,
        lHtml = [],
        lWidth = 0,
        lValue = 1,
        lItem,
        lKey;

    function populateCultureDropdown() {
        var lCultures = getDataItems('Culture'),
            lPreferences = getUserPreferences(13),
            lCultureId = gUserDetails.CultureId,
            lOptionHtml = [],
            lItem,
            lKey;

        for (lKey in lCultures) {
            if (lCultures.hasOwnProperty(lKey)) {
                lItem = lCultures[lKey];
                lOptionHtml.push('<option value="');
                lOptionHtml.push(lItem.Id);
                lOptionHtml.push('">');
                lOptionHtml.push(lItem.Name);
                lOptionHtml.push('</option>');
            }
        }
        if (count(lPreferences) > 0) {
            lItem = lPreferences['CultureId'];
            if (!isNullOrUndefined(lItem) && lItem.Value != -1) {
                lCultureId = lItem.Value;
            }
        }
        $('#uAgentCultureSettingEdit').html(lOptionHtml.join('')).val(lCultureId);
    }

    function populateAutoDashboardDropdown() {
        var lPreferences = getUserPreferences(13),
            lAutoDasboardEnabled = veritracks.system.clientSetting('AutoDashboardRefreshEnabled'),
            lOptions = [{ 'Id': 0, 'Name': localizeText('cManual') }, { 'Id': 1, 'Name': localizeText('cAutomatic') }],
            lOptionHtml = [],
            lDashboardVal = 0,
            lItem,
            lKey;


        if (lAutoDasboardEnabled) {
            for (lKey in lOptions) {
                if (lOptions.hasOwnProperty(lKey)) {
                    lOptionHtml.push('<option value="' + lOptions[lKey].Id + '">' + lOptions[lKey].Name + '</option>');
                }
            }
            if (count(lPreferences) > 0) {
                lItem = lPreferences['AutomaticDashboardUpdate'];
                if (!isNullOrUndefined(lItem) && lItem.Value != -1) {
                    lDashboardVal = lItem.Value;
                }
            }
            $('#uAgentAutoDashboardSettingEdit').html(lOptionHtml.join('')).val(lDashboardVal);
        } else {
            $('#uAgentAutoDashboard').hide();
        }
    }
    function populateShowMetricDropDown(){
        var lPreferences = getUserPreferences(13);
        console.log(lPreferences);
        var lValue =  getUserPreferenceValue(13,'ShowMetric');
        if (!isNullOrUndefined(lValue)) {
            lValue = parseInt(lValue);
            document.getElementById('uAgentShowMetricSettingEdit').value = lValue;
        }
       
    }

    lPreference = lPreferences['TrackType'];
    if (!isNullOrUndefined(lPreference)) {
        lValue = parseInt(lPreference.Value, 10);
    }
    lHtml.push('<option value="1">' + localizeText('cTripsVisits') + '</option>');
    lHtml.push('<option value="2">' + localizeText('cTrackpoints') + '</option>');

    $('#uTripsVisitsSettingEdit').html(lHtml.join('')).val(lValue);
    lHtml = [];

    populateCultureDropdown();
    populateAutoDashboardDropdown();
    populateShowMetricDropDown();

    var lCarveOutPreference = getCarveOutPreference(null, true);

    $('#uAgentAbsencesEnabled').prop('checked', lCarveOutPreference);

    
}


function SaveAgentUserPreferences() {
    "use strict";
    var lValue;
    const SHOW_METRIC_TYPE =16;
    var lPreference = [];
    var lPreferencesWrite = [];
    var lAutoDashboardEnabled = veritracks.system.clientSetting('AutoDashboardRefreshEnabled');
    var lShowMetric = parseInt(document.getElementById('uAgentShowMetricSettingEdit').value);
    lValue = $('#uTripsVisitsSettingEdit').val();
    if (!isNullOrUndefined(lValue) && lValue !== '') {
        lPreference = new UserPreference();
        lPreference.Id = gUserDetails.UserId;
        lPreference.Value = lValue;
        lPreference.UserPreferenceType = 4;
        lPreference.ColumnName = 'TrackType';
        lPreferencesWrite.push(lPreference);
    }
    

    lValue = $('#uAgentCultureSettingEdit').val();
    if (!isNullOrUndefined(lValue) && lValue !== '') {
        if (lValue == gUserDetails.CultureId) {
            lValue = -1;
        }
        lPreference = new UserPreference();
        lPreference.Id = gUserDetails.UserId;
        lPreference.Value = lValue;
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'CultureId';
        lPreferencesWrite.push(lPreference);
    }
    if (!isNullOrUndefined(lShowMetric) && lShowMetric !== '') {
        lPreference = new UserPreference();
        lPreference.Id = gUserDetails.UserId;
        lPreference.Value = lShowMetric;
        lPreference.UserPreferenceType = 13;
        lPreference.ColumnName = 'ShowMetric';
        lPreferencesWrite.push(lPreference);
    }
    if (lAutoDashboardEnabled) {
        lValue = $('#uAgentAutoDashboardSettingEdit').val();
        if (!isNullOrUndefined(lValue) && lValue !== '') {
            lPreference = new UserPreference();
            lPreference.Id = gUserDetails.UserId;
            lPreference.Value = lValue;
            lPreference.UserPreferenceType = 13;
            lPreference.ColumnName = 'AutomaticDashboardUpdate';
            lPreferencesWrite.push(lPreference);
        }
    }
    lValue = $('#uAgentAbsencesEnabled').is(':checked') ? 1 : 0
    if (!isNullOrUndefined(lValue) && lValue !== '') {
        lPreference = new UserPreference();
        lPreference.Id = gUserDetails.UserId;
        lPreference.Value = lValue;
        lPreference.UserPreferenceType = 4;
        lPreference.ColumnName = 'CarveOutPreference';
        lPreferencesWrite.push(lPreference);
    }

    if (lPreferencesWrite.length > 0) {
        mActivityNotification.addNotification('Saving User Settings.....');
        writeUserPreferences(lPreferencesWrite, agentsUpdatePreferences_OnSuccess);
    }
}

function agentsUpdatePreferences_OnSuccess(aParams, aData) {
    "use strict";
    ClosePopup();
    mActivityNotification.addNotification('Updated User Settings!!!');
}


function save2FA(userId, callback) {
    var lDataItem = new DataItem('UserTwoFASecret')
    var userSecretReset = new UserTwoFASecret();

    userSecretReset.Id = userId;
    userSecretReset.UserSecretKey = '';
    userSecretReset.TransactionId = moment().format("YYYYMMDDHHmmss");

    WriteSingle(userSecretReset, callback, Sad, null, true);
}
//2fa
function uAdminResetUser2FA_OnClick() {
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    lHtml.push('<p><strong>Before resetting two-factor authentication for ' + lCard.FullName + ', please verify that this is the intended action.</strong></p>')

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Continue', function () {
        save2FA(lCard.UserId, function (aParams, aData) {
            mActivityNotification.addNotification('User Two-Factor Authentication has been reset they can now login and setup again.')
            ClosePopup();
        })
    }));

    DisplayPopup('Reset Two-Factor Authentication Confirmation', lHtml.join(''), lButtonBar, false);
}

function uAdminGenerateTempCodes() {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    lHtml.push('<h3><b>WARNING<b> Generating new codes for this user will automatically disable previously generated codes for this user.</h3>');
    lButtonBar.append(GenerateButton(localizeWrapper('cAgentGenerateCodes'), 'Generate', function () {
        ClosePopup();
        veritracks.data.controller.Generate2Factor10Codes(lCard.UserId, uGenerateHtopOnSuccess, Sad, null);
    }));

    DisplayPopup('10 one time codes for ' + lCard.FullName, lHtml.join(''), lButtonBar, false);


}


function uGenerateHtopOnSuccess(aPrams, aData) {
    "use strict";
    var lCard = mAgentsControls.CardView.selectedDataItem();
    var lButtonBar = GenerateButtonCommandBar();
    var lHtml = [];

    if (aData.length == 0) {
        lHtml.push('<p>This user is not setup for 2 factor authentication</p>');
    }

    for (var key in aData) {
        if (aData.hasOwnProperty(key)) {
            lHtml.push('<div>');
            lHtml.push(aData[key]);
            lHtml.push('</div>');
        }
    }

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', function () {
        ClosePopup();
    }));

    DisplayPopup('10 one time codes for ' + lCard.FullName, lHtml.join(''), lButtonBar, false);
}


/* MOVE CASELOAD */
function agentsAgentsCaseloadMove_OnClick() {
    "use strict";
    var lSelectedEnrollees = mAgentsControls.CurrentCaseloadListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder();

    mAgentsData.SelectedOrganization = $('#uAgentsMoveOrganizationIdEdit').val();
    mAgentsData.SelectedAgent = $('#uAgentsMoveAgentIdEdit').val();

    function ZoneRead_OnSuccess(aZoneCount, aData) {
        var lKey,
        lExtraCheckZones = [];

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                var lZone = aData[lKey];
                if (lZone.EnrolleeCount !== aZoneCount[lZone.Id] && lZone.EnrolleeCount !== 0) {
                    lExtraCheckZones.push(lZone)
                }
            }
        }

        if (lExtraCheckZones.length > 0) {
            GroupZonesMove(lExtraCheckZones)
        } else {
            ContinueCaseloadMove();
        }
    }

    function ZoneEnrollee_OnSuccess(aParams, aData) {
        var lZoneIds = getArrayByIds(aData),
            lZoneList,
            lZoneCount = {},
            lKeyA,
            lKeyB;

        // get count of enrollees appearing in zones to be moved
        for (lKeyA in lZoneIds) {
            if (lZoneIds.hasOwnProperty(lKeyA)) {
                var lnum = lZoneIds[lKeyA];
                lZoneCount[lnum] = lZoneCount[lnum] ? lZoneCount[lnum] + 1 : 1;
            }
        }

        if (isNullOrUndefined(lZoneIds) || lZoneIds.length == 0) {
            ContinueCaseloadMove();
        } else {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('Id', lZoneIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            ReadMultiple(gObjectList.Zone.AssemblyQualifiedName, lBuilder.RootExpression, 0, ZoneRead_OnSuccess, Sad, lZoneCount);
        }

    }

    lBuilder.AddNewExpressionConditional('EnrolleeId', mAgentsControls.CurrentCaseloadListView.selected(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.ZoneEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, ZoneEnrollee_OnSuccess, null, {}, null, 0, true);

}


function GroupZonesMove(aGroupZones) {
    var lBuilder = new SumoPredicateBuilder();
    var lGroupId = getArrayByIds(aGroupZones);
    var lSelectedEnrolleeIds = mAgentsControls.CurrentCaseloadListView.selected();

    lBuilder.AddNewExpressionConditional('EntityId', lGroupId, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ZoneScheduleType', 1, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OffenderSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, function (aParams, aData) {
        aData = aData.filter(function (schedule) {
            if (lSelectedEnrolleeIds.indexOf(schedule.EnrolleeId) !== -1) {
                return schedule
            }
        });

        FixDates(aData);

        // formatter dependent on this....
        mEnrolleesData.OffenderSchedules = aData;

        GroupZonesInitiateListView(aParams);
        GroupZonesSchedulesInitiateListView(aData);

        if (aData.length == 0) {
            mActivityNotification.addNotification('No Schedules to be deleted....');
            return ContinueCaseloadMove();
        }
    }, Sad, aGroupZones);

    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();

    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', function () {
        ClosePopup();
    }, false).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cOk'), 'Save', 'removeAllGroupZoneSchedules()', false).appendTo(lButtonBar);


    lHtml.push('<div style="height:50em; width: 80em">');
    lHtml.push('<div><h3>There are one or more enrollee schedules to zones shared by other enrollees.  These schedules will be deleted.  Do you wish to proceed?</p></div>')
    lHtml.push('<strong>Shared Zones</strong>')
    lHtml.push('<div id="uGroupZonesListViewHolder" style="height: 25%">')
    lHtml.push('</div>');
    lHtml.push('<hr></br>')
    lHtml.push('<strong>Schedules that need to be deleted </strong>')
    lHtml.push('<div id="uGroupSchedulesListViewHolder" style="height: 50%">')
    lHtml.push('</div>');
    lHtml.push('</div>');

    DisplayPopup('Group Zones', lHtml.join(''), lButtonBar, false)
}

function GroupZonesInitiateListView(aZones) {
    mAgentsControls.ZonesCaseloadListView = new sumo.controls.ListView('uGroupZonesListView', 'uGroupZonesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': false, 'localization': true
    }, [
        { 'id': 'Name', 'title': localizeWrapper('cEnrolleeZoneName'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'dataType': 'string', 'canResize': true },
        { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Description', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'sortable': false, 'canResize': true },
        { 'id': 'OrganizationId', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationId', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': OrganizationNameFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Scope', 'title': localizeWrapper('cZoneScope'), 'dataField': 'Scope', 'width': 'autoData', 'minWidth': 100, 'dataType': 'string', 'formatMethod': zoneScopeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Shape', 'title': localizeWrapper('cZoneShape'), 'dataField': 'Shape', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': zoneShapeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'Type', 'title': localizeWrapper('cZoneType'), 'dataField': 'Type', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': zoneTypeFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'IsActive', 'title': localizeWrapper('cEnrolleeActive'), 'dataField': 'IsActive', 'width': 'autoData', 'minWidth': 100, 'dataType': 'number', 'formatMethod': booleanLongFormatter, 'sortable': false, 'canResize': true },
        { 'id': 'EnrolleeCount', 'title': localizeWrapper('cZoneEnrolleeCount'), 'dataField': 'EnrolleeCount', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null }
    ]);

    mAgentsControls.ZonesCaseloadListView.setDataSource(aZones)
}

function GroupZonesSchedulesInitiateListView(aSchedules) {
    var lColumns = [];

    lColumns.push(
     { 'id': 'EnrolleeId', 'title': localizeWrapper('cEnrolleeFullName'), 'dataField': 'EnrolleeId', 'width': 'autoData', 'minWidth': 200, 'maxWidth': 200, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': EnrolleeNameFormatter },
     { 'id': 'Description', 'title': 'Description', 'dataField': 'Name', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
     { 'id': 'Target', 'title': 'Target', 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
     { 'id': 'TargetType', 'title': 'Target Type', 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 75, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null });

    lColumns.push({ 'id': 'StartTime', 'title': 'Start', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatScheduleStartTime },
      { 'id': 'EndTime', 'title': 'End', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'dataType': 'date', 'formatMethod': formatScheduleEndTime });
    

    lColumns.push({ 'id': 'ScheduleType', 'title': 'Type', 'dataField': 'ScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
   { 'id': 'ZoneScheduleType', 'title': 'Zone Category', 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': scheduleZoneTypeFormatter },
   { 'id': 'IsSunday', 'title': 'S', 'dataField': 'IsSunday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsMonday', 'title': 'M', 'dataField': 'IsMonday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsTuesday', 'title': 'T', 'dataField': 'IsTuesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsWednesday', 'title': 'W', 'dataField': 'IsWednesday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsThursday', 'title': 'R', 'dataField': 'IsThursday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsFriday', 'title': 'F', 'dataField': 'IsFriday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false },
   { 'id': 'IsSaturday', 'title': 'S', 'dataField': 'IsSaturday', 'width': 'autoData', 'minWidth': 12, 'sortable': false, 'cssClass': null, 'dataType': 'boolean', 'formatMethod': booleanShortFormatter, 'canResize': false });


    mAgentsControls.ScheduleCaseloadListView = new sumo.controls.ListView('uGroupSchedulesListView', 'uGroupSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, lColumns);

    mAgentsControls.ScheduleCaseloadListView.setDataSource(enrolleesScheduleDataListConverter(aSchedules));
}

function removeAllGroupZoneSchedules() {
    var lSchedules = mEnrolleesData.OffenderSchedules.map(function (schedule) {
        schedule.IsActive = false
        return schedule;
    })

    WriteMultiple(lSchedules, function (aParams, aData) {
        aData.forEach(function (schedule) {
            var zone = GetZone(schedule.EntityId);
            if (zone) {
                zone.EnrolleeCount = zone.EnrolleeCount >= 1 ? zone.EnrolleeCount - 1 : 0;
                setDataItem(zone.Id, 'Zones', zone);
            }
        });
        
        mActivityNotification.addNotification('Successfully deleted all schedules preventing move....')
        ContinueCaseloadMove();

    }, Sad, null, true);
}

function ContinueCaseloadMove() {
    var lSelectedEnrollees = mAgentsControls.CurrentCaseloadListView.selectedDataItem(),
     lBuilder = new SumoPredicateBuilder(),
     lOrganizationId = mAgentsData.SelectedOrganization,
     lAgentId = mAgentsData.SelectedAgent,
     lAgent = getDataItem(lAgentId, "Agents"),
     lProtocolRefreshWrite = [],
     lEnrolleeWrite = [],
     lProtocolRefresh,
     lEnrollee,
     lBuilder = new SumoPredicateBuilder(),
     lKey;

    // zone move methods
    function zoneMove_OnSuccess(aParams, aData) {
        var lItem,
            lKey;

        FixDates(aData);
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                setDataItem(lItem.Id, 'Zones', lItem);
            }
        }

        mActivityNotification.addNotification(localizeWrapper('cAgentZoneMoveSuccess'));
    }

    function zoneMove_OnFailure() {
        mActivityNotification.addNotification(localizeWrapper('cAgentZoneMoveFailed'));
    }
    function ZoneEnrolleeMoveZone_OnSuccess(aParams, aData) {
        var lEnrolleeZones = aData,
            lZoneIds = getArrayByIds(lEnrolleeZones),
            lZoneList,
            lZoneCount = {},
            lMoveZoneWrite = [],
            lExtraCheckZones = [],
            lKeyA,
            lKeyB;

        // get count of enrollees appearing in zones to be moved
        for (lKeyA in lZoneIds) {
            if (lZoneIds.hasOwnProperty(lKeyA)) {
                var lnum = lZoneIds[lKeyA];
                lZoneCount[lnum] = lZoneCount[lnum] ? lZoneCount[lnum] + 1 : 1;
            }
        }


        // gather zones that may be moved.
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', lZoneIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lZoneList = query(getDataItems('Zones'), lBuilder.RootExpression);


        for (lKeyB in lZoneList) {
            if (lZoneList.hasOwnProperty(lKeyB)) {
                var lZone = lZoneList[lKeyB];
                if (lZone.EnrolleeCount == lZoneCount[lZone.Id] || lZone.EnrolleeCount == 0) {
                    lZone.AgentId = lAgentId;
                    lZone.OrganizationId = lOrganizationId;
                    lMoveZoneWrite.push(lZone);
                } else {
                    // not to be moved
                }
            }
        }

        if (ObjectLength(lMoveZoneWrite) > 0) {
               WriteMultiple(lMoveZoneWrite, zoneMove_OnSuccess, zoneMove_OnFailure, null, false);
        }
    }

    // BBG move methods
    function moveDeviceClusters_OnSuccess(aParams, aData) {
        var lItem,
            lKey;

        FixDates(aData);
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                setDataItem(lItem.Id, 'DeviceClusters', lItem);
            }
        }

        mActivityNotification.addNotification(localizeWrapper('cAgentBluBoxGroupMoveSuccess'));
    }

    function moveDeviceClusters_OnFailure(aParams, aData) {
        mActivityNotification.addNotification(localizeWrapper('cAgentBluBoxGroupMoveFailed'));
    }

    function moveBluBoxGroups_Init(aData) {
        var lBuilder = new SumoPredicateBuilder(),
            lDeviceClustersEnrollees,
            lDeviceClusters,
            lDeviceClustersCollection = [],
            lDeviceClusterCount = {},
            lDeviceClusterIds = [],
            lEnrolleeIds = getArrayByIds(aData);

        // gather device cluster enrollees
        lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrolleeIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lDeviceClustersEnrollees = query(getDataItems('DeviceClusterEnrollee'), lBuilder.RootExpression);


        // get Device cluster ids and count
        for (var lKey in lDeviceClustersEnrollees) {
            if (lDeviceClustersEnrollees.hasOwnProperty(lKey)) {
                var lnum = lDeviceClustersEnrollees[lKey].DeviceClusterId;
                lDeviceClusterIds.push(lnum);
                lDeviceClusterCount[lnum] = lDeviceClusterCount[lnum] ? lDeviceClusterCount[lnum] + 1 : 1;
            }
        }

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('Id', lDeviceClusterIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceClusters = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);

        for (var lKey in lDeviceClusters) {
            if (lDeviceClusters.hasOwnProperty(lKey)) {
                var lDeviceCluster = lDeviceClusters[lKey];
                if (lDeviceCluster.EnrolleeCount == lDeviceClusterCount[lDeviceCluster.Id] && lDeviceCluster.OrganizationId != lOrganizationId) {
                    lDeviceCluster.OrganizationId = lOrganizationId;
                    lDeviceClustersCollection.push(lDeviceCluster);
                }
            }
        }

        if (ObjectLength(lDeviceClustersCollection) > 0) {
            WriteMultiple(lDeviceClustersCollection, moveDeviceClusters_OnSuccess, moveDeviceClusters_OnFailure, null, true);
        }

    }
    function devices_OnSuccess(aParams, aData) {
        var lItem,
            lKey;
        FixDates(aData);
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                setDataItem(lItem.Id, 'Devices', lItem);
            }
        }

        agentsAgentsCaseload_Populate();

        ClosePopup();
    }

    function devices_OnFailure(a, b, c, d) {
        ClosePopup();
    }

    function enrollees_OnSuccess(aParams, aData) {
        var lBuilder = new SumoPredicateBuilder(),

            lDeviceAssignments = getDataItems('CurrentDeviceAssignments'),
            lDeviceAssignmentList,
            lDeviceAssignment,
            lAssignmentKey,
            lDevices = getDataItems('Devices'),
            lDeviceWrite = [],
            lDevice;

        FixDates(aData);
        if (aData.length > 0) {
            mActivityNotification.addNotification(localizeWrapper('cAgentCaseloadMoveSuccess'));
        }
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lEnrollee = aData[lKey];
                lEnrollee.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(lEnrollee.OrganizationId) !== -1);
                if (lEnrollee.ArchiveFlag == 'N') {
                    setDataItem(lEnrollee.Id, 'Enrollees', lEnrollee);
                }
                universalSearch_UpdateData();
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lDeviceAssignmentList = query(lDeviceAssignments, lBuilder.RootExpression);
                for (lAssignmentKey in lDeviceAssignmentList) {
                    if (lDeviceAssignmentList.hasOwnProperty(lAssignmentKey)) {
                        lDeviceAssignment = lDeviceAssignmentList[lAssignmentKey];
                        lDevice = lDevices[lDeviceAssignment.Id];
                        if (!isNullOrUndefined(lDevice)) {
                            if (lDevice.OrganizationId !== lEnrollee.OrganizationId) {
                                lDevice = $.extend({}, lDevice);
                                lDevice.OrganizationId = lEnrollee.OrganizationId;
                                lDevice.UserId = gUserDetails.UserId;
                                lDeviceWrite.push(prepareObjectForWcf(lDevice));
                            }
                        }
                    }
                }
            }
        }
        if (lDeviceWrite.length > 0) {
            WriteMultiple(lDeviceWrite, devices_OnSuccess, devices_OnFailure, null, true);
        } else {
            devices_OnSuccess(null, []);
        }

        // moving blubox groups
        moveBluBoxGroups_Init(aData);

        // moving zones
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', getArrayByIds(aData), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ZoneEnrollee.AssemblyQualifiedName, lBuilder.RootExpression, 0, ZoneEnrolleeMoveZone_OnSuccess, null, {}, null, 0, true);
    }

    function enrollees_OnFailure(a, b, c, d) {
        setLoadingBarStatus('uAgentsMoveCaseloadLoadingBar', 'uAgentsMoveCaseloadContent', false, null);
        $('#uPopupContainer .Button').show();
    }

    setLoadingBarStatus('uAgentsMoveCaseloadLoadingBar', 'uAgentsMoveCaseloadContent', true, null);
    $('#uPopupContainer .Button').hide();

    for (lKey in lSelectedEnrollees) {
        if (lSelectedEnrollees.hasOwnProperty(lKey)) {
            lEnrollee = lSelectedEnrollees[lKey];
            if (!isNullOrUndefined(lEnrollee)) {
                if (lEnrollee.OrganizationId !== lOrganizationId) {
                    lProtocolRefresh = new EnrolleeProtocolRefresh();
                    lProtocolRefresh.Id = lEnrollee.Id;
                    lProtocolRefreshWrite.push(lProtocolRefresh);
                }
                lEnrollee = $.extend({}, lEnrollee);
                lEnrollee.AgentId = lAgentId;
                lEnrollee.OrganizationId = lOrganizationId;
                lEnrolleeWrite.push(lEnrollee);
            }
        }
    }
    if (lEnrolleeWrite.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAgentCaseloadMoving') + lAgent.FullName);
        WriteMultiple(lEnrolleeWrite, enrollees_OnSuccess, enrollees_OnFailure, null, true);
        if (lProtocolRefreshWrite.length > 0) {
            WriteMultiple(lProtocolRefreshWrite, null, null, null, true);
        }
    } else {
        enrollees_OnSuccess(null, []);
    }
}

// STATE MANAGER HANDLERS
function mStateManagerBilling_Init(aPrevious, aCurrent) {
    "use strict";
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        gLoadScreenCounter++;
        // var lLayout = aCurrent.Tab + 'Billing.htm';
        // populateElement('uMasterContentHolder', 'Billing.htm', uMasterContentHolder_OnLoad);
    } else {
        systemCacheItems_Init();
    }
}